import { jsx as m, jsxs as M, Fragment as en } from "react/jsx-runtime";
import * as w from "react";
import G, { useState as Jr, useRef as ge, useCallback as Ar, useEffect as xt, useLayoutEffect as Au, forwardRef as ku, useContext as Ao, useMemo as cn } from "react";
import { unstable_batchedUpdates as Cu } from "react-dom";
function kr() {
  return kr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kr.apply(this, arguments);
}
var Ii = function(e) {
  var t = ge(e);
  return t.current = e, t;
}, Eu = "💡 react-cool-dimensions: the browser doesn't support Resize Observer, please use polyfill: https://github.com/wellyshen/react-cool-dimensions#resizeobserver-polyfill", Su = "💡 react-cool-dimensions: the browser doesn't support border-box size, fallback to content-box size. Please see: https://github.com/wellyshen/react-cool-dimensions#border-box-size-measurement", Nu = function(t, n) {
  var r = "", i = -1;
  return Object.keys(t).forEach(function(a) {
    var o = t[a];
    n >= o && o > i && (r = a, i = o);
  }), r;
}, Cn = function(t) {
  var n = t === void 0 ? {} : t, r = n.useBorderBoxSize, i = n.breakpoints, a = n.updateOnBreakpointChange, o = n.shouldUpdate, l = n.onResize, s = n.polyfill, u = Jr({
    currentBreakpoint: "",
    width: null,
    height: null
  }), d = u[0], c = u[1], h = ge({}), f = ge(), y = ge(), v = ge(!1), C = ge(), b = Ii(l), A = Ii(o), x = Ar(function() {
    y.current && y.current.disconnect();
  }, []), T = Ar(function(N) {
    N && N !== C.current && (x(), C.current = N, c({
      currentBreakpoint: "",
      width: N.clientWidth,
      height: N.clientHeight
    })), y.current && C.current && y.current.observe(C.current);
  }, [x]);
  return xt(function() {
    if ((!("ResizeObserver" in window) || !("ResizeObserverEntry" in window)) && !s)
      return console.error(Eu), function() {
        return null;
      };
    var N = null;
    return y.current = new (s || ResizeObserver)(function(k) {
      var B = k[0];
      N = requestAnimationFrame(function() {
        var U = B.contentBoxSize, I = B.borderBoxSize, R = B.contentRect, D = U;
        r && (I ? D = I : v.current || (console.warn(Su), v.current = !0)), D = Array.isArray(D) ? D[0] : D;
        var z = D ? D.inlineSize : R.width, Q = D ? D.blockSize : R.height;
        if (!(z === h.current.width && Q === h.current.height)) {
          h.current = {
            width: z,
            height: Q
          };
          var Y = {
            currentBreakpoint: "",
            width: z,
            height: Q,
            entry: B,
            observe: T,
            unobserve: x
          };
          i ? (Y.currentBreakpoint = Nu(i, z), Y.currentBreakpoint !== f.current && (b.current && b.current(Y), f.current = Y.currentBreakpoint)) : b.current && b.current(Y);
          var L = {
            currentBreakpoint: Y.currentBreakpoint,
            width: z,
            height: Q,
            entry: B
          };
          if (!(A.current && !A.current(L))) {
            if (!A.current && i && a) {
              c(function(Z) {
                return Z.currentBreakpoint !== L.currentBreakpoint ? L : Z;
              });
              return;
            }
            c(L);
          }
        }
      });
    }), T(), function() {
      x(), N && cancelAnimationFrame(N);
    };
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(i),
    r,
    T,
    x,
    a
  ]), kr({}, d, {
    observe: T,
    unobserve: x
  });
};
const ko = (e) => /* @__PURE__ */ w.createElement("svg", { width: 12, height: 11, viewBox: "0 0 12 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M0.892578 5.49512H11.8593", stroke: "white", strokeWidth: 1.74854 }), /* @__PURE__ */ w.createElement("path", { d: "M6.37598 10.9785L6.37598 0.0117701", stroke: "white", strokeWidth: 1.74854 })), Co = (e) => /* @__PURE__ */ w.createElement("svg", { width: 11, height: 3, viewBox: "0 0 11 3", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M0.0117188 1.49512H10.9785", stroke: "white", strokeWidth: 1.74854 })), Eo = (e) => /* @__PURE__ */ w.createElement("svg", { width: 31, height: 31, viewBox: "0 0 31 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.7485 11.6647C20.3526 11.1239 19.8751 10.6465 19.3341 10.2507L22.9238 6.66106L24.338 8.07527L20.7485 11.6647ZM21.9236 16.5C21.9739 16.174 22 15.8401 22 15.5C22 15.1599 21.9739 14.826 21.9236 14.5L27 14.5V16.5L21.9236 16.5ZM19.3347 20.7489C19.8756 20.3531 20.3531 19.8756 20.7489 19.3347L24.3384 22.9242L22.9242 24.3384L19.3347 20.7489ZM14.5 21.9236C14.826 21.9739 15.1599 22 15.5 22C15.8401 22 16.174 21.9739 16.5 21.9236L16.5 27H14.5L14.5 21.9236ZM10.2511 19.3347C10.647 19.8756 11.1244 20.3531 11.6653 20.7489L8.07579 24.3384L6.66158 22.9242L10.2511 19.3347ZM9.07645 14.5C9.02611 14.826 9 15.1599 9 15.5C9 15.8401 9.02611 16.174 9.07645 16.5H4V14.5H9.07645ZM10.2515 11.6647L6.66203 8.07527L8.07625 6.66106L11.6659 10.2507C11.1249 10.6465 10.6474 11.1239 10.2515 11.6647ZM16.5 9.07645C16.174 9.02611 15.8401 9 15.5 9C15.1599 9 14.826 9.02611 14.5 9.07645V4H16.5V9.07645Z", fill: "currentColor" })), X1 = ({ children: e, additionalCls: t = "" }) => /* @__PURE__ */ m(
  "div",
  {
    className: `${t} ui-shadow-md ui-rounded-2xl ui-border ui-border-gray-300 ui-bg-white ui-z-10 ui-relative`,
    children: e
  }
), tn = ({ children: e, additionalCls: t = "" }) => /* @__PURE__ */ m("div", { className: `${t} ui-rounded-2xl ui-border ui-bg-white ui-z-10 ui-relative`, children: e }), Xr = (e) => {
  switch (e) {
    case "Square":
      return 1;
    case "FourByThree":
      return 4 / 3;
    case "SixteenByNine":
      return 16 / 9;
  }
}, Mu = (e, t) => {
  if (t < 1) {
    const n = Math.min(e.height * t, e.width), r = n / t;
    return [n, r];
  } else {
    const n = Math.min(e.width / t, e.height);
    return [n * t, n];
  }
}, Ou = (e, t) => {
  const n = Xr(t), [r, i] = Mu(e, n), o = (e.x + e.width) / 2 - r / 2, s = e.y + e.height / 2 - i / 2;
  return { w: r, h: i, x: o, y: s };
}, Fi = (e) => {
  let { x: t, y: n, w: r, h: i } = e;
  return `${Math.round(t)},${Math.round(n)},${Math.round(r)},${Math.round(i)}`;
}, Ri = (e) => {
  if (e.type === "MinWidth")
    return `(min-width: ${e.minWidth}px)`;
  if (e.type === "MaxWidth")
    return `(max-width: ${e.maxWidth}px)`;
}, So = (e, t, n, r, i = "staging", a = !1) => {
  const { url: o } = e, l = Fi(a ? { x: e.x, y: e.y, w: e.width, h: e.height } : Ou(e, t));
  return `https://hoopla.imgix.net/${i}/${encodeURIComponent(
    o
  )}?auto=format,compress&rect=${l}&width=${Math.round(r)}&blur=${Math.round(n)}`;
}, Tu = (e, t, n, r, i = "staging", a = !1) => {
  const o = So(e, t, n, r, i, a);
  return `${o}&dpr=1 1x, ${o}&dpr=2 2x, ${o}&dpr=3 3x`;
}, Pu = w.forwardRef((e, t) => /* @__PURE__ */ M("picture", { children: [
  e.queries.map((n) => /* @__PURE__ */ m(
    "source",
    {
      media: Ri(n),
      srcSet: Tu(
        n.crop,
        n.size.ar,
        e.blur ?? 0,
        n.size.width,
        e.environment,
        e.forceCrop
      )
    },
    Ri(n)
  )),
  /* @__PURE__ */ m(
    "img",
    {
      onLoad: e.onLoad,
      className: e.className,
      style: e.style,
      ref: t,
      alt: e.alt,
      src: So(
        e.crop,
        e.default.ar,
        e.blur ?? 0,
        e.default.width,
        e.environment,
        e.forceCrop
      )
    }
  )
] })), ht = (e) => {
  switch (e) {
    case "Initial":
    case "NotVisible":
      return !1;
    case "Visible":
      return !0;
  }
}, Du = (e) => {
  const [t, n] = w.useState("Initial"), [r, i] = w.useState(null), a = w.useRef();
  return w.useEffect(() => {
    var o;
    if (r != null)
      if ("IntersectionObserver" in window) {
        const l = new IntersectionObserver((s) => {
          n(() => {
            var u;
            return (u = s[0]) != null && u.isIntersecting ? "Visible" : "NotVisible";
          });
        }, e);
        return l.observe(r), (o = a.current) == null || o.disconnect(), a.current = l, () => {
          l.disconnect();
        };
      } else
        n("Visible");
  }, [r, e]), [i, t];
}, zu = (e) => {
  const [t, n] = Du(e), [r, i] = w.useState("Initial");
  return w.useEffect(() => {
    i((a) => {
      switch (a) {
        case "Initial":
        case "NotVisible":
          return n;
        case "Visible":
          return a;
      }
    });
  }, [n]), [t, r];
}, No = ({ children: e }) => {
  const [t, n] = zu({
    threshold: 0,
    rootMargin: "250px"
  }), r = w.useCallback(
    (i) => {
      t(() => i ?? null);
    },
    [t]
  );
  return /* @__PURE__ */ m("div", { ref: r, children: e(n) });
}, K1 = (e) => {
  const t = { ...e.default, width: 50 }, n = e.queries.map((r) => ({
    ...r,
    size: { ...r.size, width: 50 }
  }));
  return /* @__PURE__ */ m(No, { children: (r) => {
    switch (r) {
      case "Initial":
        return /* @__PURE__ */ m(en, { children: " " });
      case "NotVisible":
      case "Visible":
        return /* @__PURE__ */ m(
          Pu,
          {
            crop: e.crop,
            default: ht(r) ? e.default : t,
            queries: ht(r) ? e.queries : n,
            blur: ht(r) ? e.blur ?? 0 : e.lazyBlur ?? 150,
            className: e.className,
            style: e.style,
            alt: e.alt,
            onLoad: e.onLoad,
            forceCrop: e.forceCrop,
            environment: e.environment
          }
        );
    }
  } });
}, Bu = (e) => /* @__PURE__ */ m(
  "div",
  {
    className: `ui-bg-gray-100 ui-w-full ${e.loadAnimation ? "skeletonLoad" : ""} ui-rounded-md`,
    style: { ...e.style, width: e.default.width, aspectRatio: Xr(e.default.ar) }
  }
), Lu = (e, t) => {
  if (t < 1) {
    const n = Math.min(e.height * t, e.width), r = n / t;
    return [n, r];
  } else {
    const n = Math.min(e.width / t, e.height);
    return [n * t, n];
  }
}, Iu = (e, t) => {
  const n = Xr(t), [r, i] = Lu(e, n), o = (e.x + e.width) / 2 - r / 2, s = e.y + e.height / 2 - i / 2;
  return { w: r, h: i, x: o, y: s };
}, ji = (e) => {
  let { x: t, y: n, w: r, h: i } = e;
  return `${Math.round(r)}x${Math.round(i)}@${Math.round(t)}x${Math.round(n)}`;
}, Vi = (e) => {
  if (e.type === "MinWidth")
    return `(min-width: ${e.minWidth}px)`;
  if (e.type === "MaxWidth")
    return `(max-width: ${e.maxWidth}px)`;
}, Fu = (e) => {
  switch (e) {
    case "FourByThree":
      return "4:3";
    case "Square":
      return "1:1";
    case "SixteenByNine":
    default:
      return "16:9";
  }
}, Mo = (e, t, n, r, i = "staging", a = !1) => {
  const { url: o } = e, l = ji(a ? { x: e.x, y: e.y, w: e.width, h: e.height } : Iu(e, t));
  return `https://hoopla.twic.pics/${i}/${encodeURIComponent(o)}?twic=v1/output=${n ? "preview" : "auto"}/crop=${l}/cover=${Fu(t)}${r ? `/resize=${r}` : ""}`;
}, Hi = (e, t, n, r, i = "staging", a = !1) => {
  const o = Mo(e, t, n, null, i, a);
  return `${o}/resize=${r} 1x, ${o}/resize=${r * 2} 2x, ${o}/resize=${r * 3} 3x`;
}, Ru = w.forwardRef((e, t) => /* @__PURE__ */ M("picture", { children: [
  e.queries.map((n) => /* @__PURE__ */ m(
    "source",
    {
      media: Vi(n),
      srcSet: Hi(
        n.crop,
        n.size.ar,
        (e.blur ?? 0) > 0,
        n.size.width,
        e.environment,
        e.forceCrop
      )
    },
    Vi(n)
  )),
  /* @__PURE__ */ m(
    "img",
    {
      onLoad: e.onLoad,
      className: e.className,
      style: e.style,
      ref: t,
      alt: e.alt,
      src: Mo(
        e.crop,
        e.default.ar,
        (e.blur ?? 0) > 0,
        e.default.width,
        e.environment,
        e.forceCrop
      ),
      srcSet: Hi(
        e.crop,
        e.default.ar,
        (e.blur ?? 0) > 0,
        e.default.width,
        e.environment,
        e.forceCrop
      )
    }
  )
] })), Qi = (e) => {
  const t = { ...e.default, width: 50 }, n = e.queries.map((r) => ({
    ...r,
    size: { ...r.size, width: 50 }
  }));
  return /* @__PURE__ */ m(No, { children: (r) => {
    switch (r) {
      case "Initial":
        return /* @__PURE__ */ m(en, { children: " " });
      case "NotVisible":
      case "Visible":
        return /* @__PURE__ */ m(
          Ru,
          {
            crop: e.crop,
            default: ht(r) ? e.default : t,
            queries: ht(r) ? e.queries : n,
            blur: ht(r) ? e.blur ?? 0 : e.lazyBlur ?? 150,
            className: e.className,
            style: e.style,
            alt: e.alt,
            onLoad: e.onLoad,
            forceCrop: e.forceCrop,
            environment: e.environment
          }
        );
    }
  } });
}, Cr = ({
  croppedImages: e,
  imgixImage: t,
  queries: n,
  base: r,
  alt: i,
  style: a,
  env: o
}) => {
  const l = (s, u) => {
    switch (s.ar) {
      case "SixteenByNine":
        return u.crop16x9;
      case "FourByThree":
        return u.crop4x3;
      case "Square":
        return u.crop1x1;
      default:
        return u.crop16x9;
    }
  };
  if (!e && t) {
    const s = n.map((d) => ({
      ...d,
      crop: {
        url: t.url,
        x: t.crop.offsetX,
        y: t.crop.offsetY,
        height: t.crop.height,
        width: t.crop.width
      }
    })), u = {
      url: t.url,
      x: t.crop.offsetX,
      y: t.crop.offsetY,
      height: t.crop.height,
      width: t.crop.width
    };
    return /* @__PURE__ */ m(Qi, { crop: u, default: r, queries: s, environment: o, alt: i, style: a });
  } else if (e) {
    const s = n.map((d) => ({
      ...d,
      crop: l(d.size, e)
    })), u = l(r, e);
    return /* @__PURE__ */ m(Qi, { crop: u, queries: s, default: r, forceCrop: !0, environment: o, alt: i, style: a });
  }
  return /* @__PURE__ */ m(G.Fragment, {});
}, Ui = ({
  base: e,
  style: t,
  loadAnimation: n = !1
}) => /* @__PURE__ */ m(Bu, { default: e, style: t, loadAnimation: n }), ju = (e) => /* @__PURE__ */ w.createElement("svg", { width: 63, height: 65, viewBox: "0 0 63 65", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M18.8808 53.5665C15.8632 54.3492 13.1498 51.532 14.0451 48.5459L24.524 13.5941C25.3832 10.7283 28.9692 9.78556 31.1267 11.8582L57.5464 37.2397C59.8031 39.4077 58.8086 43.2105 55.7795 43.9961L18.8808 53.5665Z", fill: "#AFD4FF" }), /* @__PURE__ */ w.createElement("path", { d: "M30.3621 23.625L32.4457 32.125", stroke: "black", strokeWidth: 3, strokeLinecap: "round" }), /* @__PURE__ */ w.createElement("circle", { cx: 34.484, cy: 39.7401, r: 2.32844, fill: "black" }), /* @__PURE__ */ w.createElement("circle", { cx: 23.4628, cy: 59.3805, r: 1.94483, transform: "rotate(4.43918 23.4628 59.3805)", fill: "#FFCFD5" }), /* @__PURE__ */ w.createElement("circle", { cx: 6.21718, cy: 36.5722, r: 3.44483, transform: "rotate(4.43918 6.21718 36.5722)", fill: "#FFCFD5" }), /* @__PURE__ */ w.createElement("circle", { cx: 57.3704, cy: 22.6383, r: 1.44483, transform: "rotate(4.43918 57.3704 22.6383)", fill: "#FFCFD5" }), /* @__PURE__ */ w.createElement("circle", { cx: 34.4839, cy: 62.7989, r: 1.44483, transform: "rotate(4.43918 34.4839 62.7989)", fill: "#FFCFD5" }), /* @__PURE__ */ w.createElement("circle", { cx: 45.3686, cy: 10.1848, r: 2.44483, transform: "rotate(4.43918 45.3686 10.1848)", fill: "#FFCFD5" })), Vu = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", viewBox: "0 0 52 56", width: 52, height: 56, ...e }, /* @__PURE__ */ w.createElement("path", { fill: "#AFD4FF", d: "M50.3351 48.414C50.2443 51.5302 46.7817 53.3493 44.1642 51.6561L13.5269 31.837C11.0149 30.212 11.1107 26.5053 13.7032 25.0122L45.4507 6.72783C48.1624 5.16607 51.5365 7.18259 51.4453 10.3106L50.3351 48.414Z" }), /* @__PURE__ */ w.createElement("g", { opacity: 0.09 }, /* @__PURE__ */ w.createElement("mask", { id: "a", width: 41, height: 47, x: 11, y: 6, maskUnits: "userSpaceOnUse" }, /* @__PURE__ */ w.createElement("path", { fill: "#AFD4FF", d: "M50.2019 48.4097C50.102 51.5256 46.634 53.3346 44.0215 51.6336L13.4426 31.7246C10.9354 30.0922 11.042 26.3859 13.639 24.9004L45.4401 6.70936C48.1563 5.15558 51.5244 7.182 51.4241 10.3097L50.2019 48.4097Z" })), /* @__PURE__ */ w.createElement("g", { mask: "url(#a)" }, /* @__PURE__ */ w.createElement("path", { fill: "url(#pattern0)", d: "M0 0H36.5279V59.2465H0z", style: {
  mixBlendMode: "multiply"
}, transform: "matrix(-0.946724 0.322047 0.322047 0.946724 57.3403 -3.30127)" }))), /* @__PURE__ */ w.createElement("path", { stroke: "#181351", strokeLinecap: "round", strokeWidth: 2.70812, d: "M42.5948 35.7026C41.2031 34.3261 39.4613 33.6347 37.7432 33.9713C36.0251 34.308 34.673 35.6056 33.9037 37.4054" }), /* @__PURE__ */ w.createElement("circle", { cx: 4.91321, cy: 2.3021, r: 1.875, fill: "#FFCFD5", transform: "rotate(4.43918 4.91321 2.3021)" }), /* @__PURE__ */ w.createElement("circle", { cx: 10.2882, cy: 7.35825, r: 1.875, fill: "#FFCFD5", transform: "rotate(4.43918 10.2882 7.35825)" }), /* @__PURE__ */ w.createElement("circle", { cx: 15.6627, cy: 12.4144, r: 1.875, fill: "#FFCFD5", transform: "rotate(4.43918 15.6627 12.4144)" }), /* @__PURE__ */ w.createElement("circle", { cx: 4.17347, cy: 11.8329, r: 1.875, fill: "#FFCFD5", transform: "rotate(4.43918 4.17347 11.8329)" }), /* @__PURE__ */ w.createElement("circle", { cx: 9.54798, cy: 16.889, r: 1.875, fill: "#FFCFD5", transform: "rotate(4.43918 9.54798 16.889)" }), /* @__PURE__ */ w.createElement("circle", { cx: 3.43323, cy: 21.3636, r: 1.875, fill: "#FFCFD5", transform: "rotate(4.43918 3.43323 21.3636)" }), /* @__PURE__ */ w.createElement("circle", { cx: 2.69349, cy: 30.8949, r: 1.875, fill: "#FFCFD5", transform: "rotate(4.43918 2.69349 30.8949)" }), /* @__PURE__ */ w.createElement("path", { fill: "#70B2FF", d: "M19.8361 45.1889C20.5926 46.2928 21.7567 47.051 23.0722 47.2966C24.3878 47.5423 25.747 47.2552 26.8509 46.4987C27.9548 45.7422 28.713 44.5781 28.9586 43.2626C29.3795 41.0087 27.0042 35.124 26.149 33.1061C26.1168 33.0293 26.066 32.9618 26.0012 32.9095C25.9364 32.8572 25.8597 32.8218 25.7779 32.8066C25.696 32.7913 25.6117 32.7966 25.5324 32.8219C25.4531 32.8473 25.3814 32.892 25.3236 32.952C23.7959 34.5249 19.459 39.1563 19.0382 41.4102C18.7925 42.7257 19.0796 44.085 19.8361 45.1889Z" }), /* @__PURE__ */ w.createElement("circle", { cx: 43.3923, cy: 24.7944, r: 2.1665, fill: "#181351" }), /* @__PURE__ */ w.createElement("circle", { cx: 28.0325, cy: 28.1777, r: 2.1665, fill: "#181351" }), /* @__PURE__ */ w.createElement("defs", null, /* @__PURE__ */ w.createElement("pattern", { id: "pattern0", width: 1, height: 1, patternContentUnits: "objectBoundingBox" }, /* @__PURE__ */ w.createElement("use", { transform: "scale(0.00609756 0.0037594)", xlinkHref: "#image0" })))), Hu = (e) => /* @__PURE__ */ w.createElement("svg", { width: 73, height: 66, viewBox: "0 0 73 66", fill: "none", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M53.6431 58.8641C52.3147 61.6844 48.4136 61.9683 46.6908 59.3701L26.5257 28.9594C24.8724 26.466 26.4414 23.1065 29.4146 22.7737L65.8236 18.6991C68.9335 18.351 71.2206 21.5478 69.8871 24.3788L53.6431 58.8641Z", fill: "#FFAFCC" }), /* @__PURE__ */ w.createElement("g", { opacity: 0.09 }, /* @__PURE__ */ w.createElement("mask", { id: "mask0_342_6447", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 25, y: 18, width: 46, height: 44 }, /* @__PURE__ */ w.createElement("path", { d: "M53.5227 58.807C52.186 61.6233 48.2841 61.8958 46.5689 59.2926L26.4933 28.8228C24.8473 26.3245 26.4261 22.9696 29.4003 22.6456L65.8212 18.6779C68.9321 18.339 71.2098 21.5425 69.868 24.3696L53.5227 58.807Z", fill: "#FFD6AF" })), /* @__PURE__ */ w.createElement("g", { mask: "url(#mask0_342_6447)" }), /* @__PURE__ */ w.createElement("mask", { id: "mask1_342_6447", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 25, y: 18, width: 46, height: 44 }, /* @__PURE__ */ w.createElement("path", { d: "M53.5227 58.807C52.186 61.6233 48.2841 61.8958 46.5689 59.2926L26.4933 28.8228C24.8473 26.3245 26.4261 22.9696 29.4003 22.6456L65.8212 18.6779C68.9321 18.339 71.2098 21.5425 69.868 24.3696L53.5227 58.807Z", fill: "#FFD6AF" })), /* @__PURE__ */ w.createElement("g", { mask: "url(#mask1_342_6447)" }, /* @__PURE__ */ w.createElement("rect", { width: 36.5279, height: 59.2465, transform: "matrix(-0.996541 -0.0830982 -0.0830982 0.996541 80.7302 14.2568)", fill: "url(#pattern0)", style: {
  mixBlendMode: "multiply"
} }))), /* @__PURE__ */ w.createElement("path", { d: "M13.8093 25.2485C13.8093 25.9292 14.3074 26.4023 15.1624 26.4023H20.093C20.7986 26.4023 21.2136 25.9873 21.2136 25.3066C21.2136 24.709 20.7986 24.3105 20.093 24.3105H17.0383V24.1694L20.342 20.0522C20.8152 19.4961 21.0227 19.0479 21.0227 18.5498C21.0227 17.8691 20.5164 17.4375 19.678 17.4375H14.9133C14.2078 17.4375 13.801 17.8359 13.801 18.4834C13.801 19.1226 14.2078 19.5293 14.9133 19.5293H17.8518V19.6621L14.4983 23.7793C14.0251 24.3188 13.8093 24.7588 13.8093 25.2485Z", fill: "#AFD4FF" }), /* @__PURE__ */ w.createElement("circle", { cx: 34.4227, cy: 12.6597, r: 1.44483, transform: "rotate(4.43918 34.4227 12.6597)", fill: "#AFD4FF" }), /* @__PURE__ */ w.createElement("circle", { cx: 4.88246, cy: 28.5529, r: 1.94483, transform: "rotate(4.43918 4.88246 28.5529)", fill: "#AFD4FF" }), /* @__PURE__ */ w.createElement("circle", { cx: 21.3704, cy: 39.3917, r: 1.44483, transform: "rotate(4.43918 21.3704 39.3917)", fill: "#AFD4FF" }), /* @__PURE__ */ w.createElement("circle", { cx: 21.6186, cy: 7.52077, r: 2.44483, transform: "rotate(4.43918 21.6186 7.52077)", fill: "#AFD4FF" }), /* @__PURE__ */ w.createElement("path", { d: "M0.186768 16.165C0.186768 16.8828 0.709717 17.3853 1.62231 17.3853H7.73364C8.47192 17.3853 8.90259 16.9443 8.90259 16.2676C8.90259 15.6421 8.47192 15.2114 7.73364 15.2114H3.45776V15.0679L7.97974 9.17188C8.46167 8.5874 8.66675 8.13623 8.66675 7.62354C8.66675 6.90576 8.1438 6.42383 7.24146 6.42383H1.3147C0.555908 6.42383 0.145752 6.86475 0.145752 7.51074C0.145752 8.16699 0.555908 8.60791 1.3147 8.60791H5.44702V8.75146L0.884033 14.6372C0.412354 15.2114 0.186768 15.6523 0.186768 16.165Z", fill: "#AFD4FF" }), /* @__PURE__ */ w.createElement("circle", { cx: 48.816, cy: 46.9996, r: 2.0367, fill: "black" }), /* @__PURE__ */ w.createElement("path", { d: "M57.125 40.23C57.125 38.9097 56.0547 37.8394 54.7344 37.8394C53.4141 37.8394 52.3438 38.9097 52.3438 40.23", stroke: "black", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ w.createElement("path", { d: "M44.9063 40.23C44.9063 38.9097 43.8359 37.8394 42.5156 37.8394C41.1953 37.8394 40.125 38.9097 40.125 40.23", stroke: "black", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ w.createElement("defs", null, /* @__PURE__ */ w.createElement("pattern", { id: "pattern0", patternContentUnits: "objectBoundingBox", width: 1, height: 1 }, /* @__PURE__ */ w.createElement("use", { xlinkHref: "#image0_342_6447", transform: "scale(0.00609756 0.0037594)" })), /* @__PURE__ */ w.createElement("image", { id: "image0_342_6447", width: 164, height: 266, xlinkHref: "data:image/png;base64,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" }))), _1 = {
  CANCELLED: "cancelled",
  PAST: "past",
  PROBLEMS: "problems",
  NO_TICKETS: "noTickets",
  NO_TICKETS_BUT_PROMO: "noTicketsButPromo"
}, Wi = ({ type: e, children: t }) => {
  let n;
  switch (e) {
    case "CANCELLED":
      n = /* @__PURE__ */ m(Vu, { className: "ui-mb-3" });
      break;
    case "PAST":
    case "PROBLEMS":
      n = /* @__PURE__ */ m(ju, { className: "ui-mb-3" });
      break;
    case "NO_TICKETS":
    case "NO_TICKETS_BUT_PROMO":
      n = /* @__PURE__ */ m(Hu, { className: "ui-mb-3" });
      break;
  }
  return /* @__PURE__ */ M("div", { className: "ui-h-40 ui-flex ui-flex-col ui-items-center ui-justify-center ui-py-5", children: [
    n,
    /* @__PURE__ */ m("div", { className: "ui-font-semibold ui-text-center", children: t })
  ] });
}, $1 = ({ illustration: e, title: t, information: n, endButton: r }) => /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-1 ui-px-3 ui-py-4 ui-border ui-border-gray-200 ui-rounded-2xl ui-items-center ui-text-sm", children: [
  e,
  /* @__PURE__ */ M(
    "div",
    {
      className: `ui-flex ui-flex-col ${e ? "ui-w-[calc(100%-2rem-0.75rem)]" : "ui-w-[calc(100%-0.75rem)]"}`,
      children: [
        t,
        n
      ]
    }
  ),
  r
] }), e0 = ({ illustration: e, endButton: t }) => /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-1 ui-px-3 ui-py-4 ui-border ui-border-gray-200 ui-rounded-2xl ui-items-center ui-text-sm skeletonLoad", children: [
  e && /* @__PURE__ */ m("div", { className: "ui-rounded-full ui-h-8 ui-w-8 ui-min-w-[2rem] ui-bg-gray-100 ui-mr-2" }),
  /* @__PURE__ */ M(
    "div",
    {
      className: `ui-flex ui-flex-col ${e ? "ui-w-[calc(100%-2rem-0.75rem)]" : "ui-w-[calc(100%-0.75rem)]"}`,
      children: [
        /* @__PURE__ */ m("div", { className: "ui-w-1/2 ui-bg-gray-100 ui-h-4 ui-mb-2 ui-rounded-full" }),
        /* @__PURE__ */ m("div", { className: "ui-w-1/2 ui-bg-gray-100 ui-h-4 ui-rounded-full" })
      ]
    }
  ),
  t && /* @__PURE__ */ m("div", { className: "ui-rounded-full ui-h-8 ui-w-8 ui-min-w-[2rem] ui-bg-gray-100 ui-mr-2" })
] }), t0 = ({ hasMap: e, map: t, children: n }) => e && t ? /* @__PURE__ */ m("div", { className: "ui-mt-4 ui-border ui-border-gray-200 ui-rounded-2xl", children: /* @__PURE__ */ M("div", { className: "ui-flex-1", children: [
  t,
  /* @__PURE__ */ m("div", { className: "ui-flex ui-p-3 ui-pt-0 ui-justify-between ui-items-center", children: n })
] }) }) : /* @__PURE__ */ m("div", { className: "ui-flex-1", children: /* @__PURE__ */ m("div", { className: "ui-flex ui-items-center ui-flex-1 ui-border ui-border-gray-200 ui-px-4 ui-py-3 ui-rounded-xl ui-mt-4 [&>div:first-child]:ui-mr-2", children: /* @__PURE__ */ m("div", { className: "ui-flex ui-flex-col ui-font-medium [&>*:first-child]:ui-text-gray-600 [&>*:first-child]:ui-opacity-[0.85] [&>*:first-child]:ui-font-normal ui-text-sm", children: n }) }) }), n0 = () => /* @__PURE__ */ m("div", { className: "ui-mt-4 ui-border ui-border-gray-200 ui-rounded-2xl skeletonLoad", children: /* @__PURE__ */ M("div", { className: "ui-flex-1", children: [
  /* @__PURE__ */ m("div", { className: "ui-p-1 ui-mb-2", children: /* @__PURE__ */ m("div", { className: "ui-w-full ui-rounded-xl ui-overflow-hidden ui-bg-gray-100 ui-h-[220px] tablet:ui-h-[280px]" }) }),
  /* @__PURE__ */ M("div", { className: "ui-flex ui-p-3 ui-pt-0 ui-justify-between ui-items-center", children: [
    /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-col ui-w-full", children: [
      /* @__PURE__ */ m("div", { className: "ui-h-4 ui-w-1/2 ui-bg-gray-100 ui-mb-0.5 ui-rounded-full" }),
      /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-col", children: [
        /* @__PURE__ */ m("div", { className: "ui-w-1/2 ui-h-4 ui-bg-gray-100 ui-mb-0.5 ui-rounded-full" }),
        /* @__PURE__ */ m("div", { className: "ui-w-1/2 ui-h-3 ui-bg-gray-100 ui-mb-0.5 ui-rounded-full" }),
        /* @__PURE__ */ m("div", { className: "ui-w-1/2 ui-h-3 ui-bg-gray-100 ui-rounded-full" })
      ] })
    ] }),
    /* @__PURE__ */ m("div", { className: "ui-flex ui-items-center ui-min-h-[48px] ui-rounded-md ui-h-8 ui-w-20 ui-bg-gray-100" })
  ] })
] }) }), Qu = {
  small: "ui-w-4 ui-h-4 ui-border-2",
  normal: "ui-w-[26px] ui-h-[26px] ui-border-[3px]",
  large: "ui-w-[36px] ui-h-[36px] ui-border-[4px]"
}, Uu = {
  black: "ui-border-gray-800 ui-border-t-gray-900",
  white: "ui-border-gray-200 ui-border-t-gray-400"
}, bt = ({ size: e = "normal", theme: t = "black" }) => /* @__PURE__ */ m("div", { className: `ui-rounded-full ${Qu[e]} ${Uu[t]} ui-animate-spin` }), r0 = () => /* @__PURE__ */ m("div", { className: "ui-w-full ui-h-full ui-flex ui-items-center ui-justify-center", children: /* @__PURE__ */ m(bt, { size: "large" }) }), i0 = ({ height: e }) => /* @__PURE__ */ m("div", { className: "ui-flex ui-items-center ui-justify-center", style: { height: e }, children: /* @__PURE__ */ m(bt, { size: "large" }) }), a0 = ({
  infoText: e,
  formattedSummary: t,
  buttonText: n,
  toTopText: r,
  inactiveText: i,
  onClick: a,
  loading: o = !1,
  isActive: l = !1
}) => {
  const [s, u] = G.useState(!1), [d, c] = G.useState(0), [h, f] = G.useState(0), y = G.createRef(), v = G.createRef();
  window.addEventListener("scroll", () => {
    var x;
    const A = ((x = v.current) == null ? void 0 : x.getBoundingClientRect().top) || 0;
    v.current && y.current && A < 35 && !s ? (u(!0), c(v.current.offsetWidth), f(y.current.offsetHeight)) : v.current && y.current && A >= 35 && s && (u(!1), c(v.current.offsetWidth));
  }), G.useEffect(() => {
    var A;
    f(((A = y.current) == null ? void 0 : A.offsetHeight) || 0);
  }, [y]);
  const C = () => {
    v.current && v.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  };
  let b;
  return s ? l ? b = /* @__PURE__ */ M(
    "div",
    {
      ref: y,
      style: { width: d },
      className: "ui-z-20 ui-fixed ui-top-[32px] ui-flex ui-justify-between ui-w-full ui-bg-ticketBackgroundActive ui-pb-3 ui-pt-2 ui-px-5 ui-items-center ui-tracking-wide ui-rounded-xl ui-border ui-border-gray-300",
      children: [
        /* @__PURE__ */ M("div", { className: "ui-flex ui-gap-y-0.5 ui-flex-col", children: [
          /* @__PURE__ */ m("div", { className: "ui-opacity-65 ui-text-gray-700 ui-text-sm", children: e }),
          /* @__PURE__ */ m("div", { className: "ui-font-semibold", children: t })
        ] }),
        /* @__PURE__ */ m("div", { children: o ? /* @__PURE__ */ m(
          "button",
          {
            className: "ui-py-3 ui-rounded-md ui-px-5 ui-bg-cornflowerBlue ui-text-white ui-flex ui-justify-center",
            disabled: !0,
            children: /* @__PURE__ */ m(bt, { theme: "white" })
          }
        ) : /* @__PURE__ */ m(
          "button",
          {
            className: "ui-py-3 ui-rounded-md ui-px-5 ui-bg-cornflowerBlue ui-text-white ui-font-semibold hover:ui-opacity-80",
            onClick: C,
            children: r
          }
        ) })
      ]
    }
  ) : b = /* @__PURE__ */ m(
    "div",
    {
      ref: y,
      style: { width: d },
      className: "ui-z-20 ui-fixed ui-top-[32px] ui-flex ui-py-4 ui-items-center ui-justify-center ui-w-full ui-font-semibold ui-bg-ticketBackgroundNonActive ui-rounded-xl ui-border ui-border-gray-300",
      children: /* @__PURE__ */ m(
        "button",
        {
          className: "ui-text-opacity-[0.65] ui-py-1 ui-px-5 ui-font-semibold hover:ui-opacity-80",
          onClick: C,
          children: r
        }
      )
    }
  ) : l ? b = /* @__PURE__ */ M(
    "div",
    {
      ref: y,
      className: "ui-flex ui-justify-between ui-w-full ui-bg-ticketBackgroundActive ui-pb-3 ui-pt-2 ui-px-5 ui-items-center ui-tracking-wide",
      children: [
        /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-col ui-gap-y-0.5", children: [
          /* @__PURE__ */ m("div", { className: "ui-opacity-65 ui-text-gray-700 ui-text-sm", children: e }),
          /* @__PURE__ */ m("div", { className: "ui-font-semibold", children: t })
        ] }),
        /* @__PURE__ */ m("div", { children: o ? /* @__PURE__ */ m(
          "button",
          {
            className: "ui-py-3 ui-rounded-md ui-px-5 ui-bg-cornflowerBlue ui-text-white ui-flex ui-justify-center",
            disabled: !0,
            children: /* @__PURE__ */ m(bt, { theme: "white" })
          }
        ) : /* @__PURE__ */ m(
          "button",
          {
            className: "ui-py-3 ui-rounded-md ui-px-5 ui-bg-cornflowerBlue ui-text-white ui-font-semibold hover:ui-opacity-80",
            onClick: a,
            children: n
          }
        ) })
      ]
    }
  ) : b = /* @__PURE__ */ m(
    "div",
    {
      ref: y,
      className: "ui-pb-6 ui-pt-3.5 ui-flex ui-items-center ui-justify-center ui-w-full ui-font-semibold ui-text-opacity-[0.65] ui-bg-ticketBackgroundNonActive",
      children: i
    }
  ), /* @__PURE__ */ m("div", { ref: v, className: s ? "" : "[&>*]:ui-rounded-b-2xl", style: { minHeight: h - 2 }, children: b });
}, Wu = () => /* @__PURE__ */ m(
  "div",
  {
    className: "ui-py-5 ui-flex ui-items-center ui-justify-center ui-font-semibold  ui-animate-skeletonLoad ui-w-full",
    children: /* @__PURE__ */ m("span", { className: "ui-w-1/2 ui-min-h-4 ui-h-5 ui-bg-gray-300 ui-rounded-full" })
  }
), qu = (e) => /* @__PURE__ */ w.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", stroke: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("g", { clipPath: "url(#clip0_156_13)" }, /* @__PURE__ */ w.createElement("circle", { cx: 9.04899, cy: 8.73649, r: 6.31852, stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ w.createElement("path", { d: "M9.04907 9.17395V11.8438", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ w.createElement("circle", { cx: 9.04889, cy: 6.11823, r: 1.05573, fill: "currentColor" })), /* @__PURE__ */ w.createElement("defs", null, /* @__PURE__ */ w.createElement("clipPath", { id: "clip0_156_13" }, /* @__PURE__ */ w.createElement("rect", { width: 16, height: 16, fill: "currentColor", transform: "translate(0.994141 0.73645)" })))), er = ({
  label: e,
  availability: t = "MANY_LEFT",
  selected: n = "NONE",
  icon: r,
  align: i = "right",
  onClick: a,
  hidden: o = !1
}) => /* @__PURE__ */ m(
  "button",
  {
    onClick: a,
    disabled: t === "SOLD_OUT",
    className: `ui-flex ui-items-center ui-justify-center ui-bg-cornflowerBlue ui-rounded-full ui-p-0 ui-border-0 ui-min-w-[32px] ui-w-8 ui-h-8 ui-outline-none ui-select-none ui-z-10 ui-cursor-pointer ui-transition-transform ui-ease-out ui-duration-[75ms] hover:ui-brightness-90 focus:ui-brightness-90 focus:ui-border focus:ui-border-gray-600 active:ui-brightness-75 ${i === "left" ? "ui-mr-[-15px]" : "ui-ml-[-15px]"} ${o ? "ui-translate-x-[2px]" : ""} ${{
      PROMO: "ui-bg-promoPurple",
      SOLD_OUT: "!ui-bg-white !ui-cursor-default hover:!ui-brightness-100 active:!ui-brightness-100 focus:!ui-brightness-100 !ui-opacity-30",
      FEATURED: "ui-bg-featuredGreen",
      NONE: "",
      POPULAR: "",
      PROMOTED: ""
    }[t === "SOLD_OUT" ? t : n]}`,
    "aria-label": e,
    children: r
  }
), Bt = ({ children: e }) => /* @__PURE__ */ m("div", { className: "ui-my-1 ui-font-semibold ui-text-red-400", children: e }), o0 = ({
  name: e,
  formattedPrice: t,
  description: n,
  quantity: r,
  onChangeQuantity: i,
  availability: a = "MANY_LEFT",
  selected: o = "NONE",
  soldOutMessage: l,
  showMoreMessage: s,
  showDetailsMessage: u,
  error: d,
  errorMessage: c,
  requiredAddons: h = !1,
  requiredAddonsContent: f,
  showFeeSpecification: y,
  feeSpecification: v,
  tooltipActive: C = !1,
  tooltipText: b,
  exceedsLimit: A,
  exceedsLimitMessage: x,
  lessThanMin: T,
  lessThanMinMessage: N,
  divisibleBy: k,
  divisibleByMessage: B
}) => {
  const [U, I] = G.useState(!1), [R, D] = G.useState(!0), [z, Q] = G.useState(!1), [Y, L] = G.useState(!0), [Z, ee] = G.useState(!1), te = a === "SOLD_OUT", Ce = te && (n || h || y), g = Cn({
    onResize: ({ unobserve: ie, height: p }) => {
      p && p > 40 && (I(!te), D(te)), ie();
    }
  }), he = Cn({
    onResize: ({ unobserve: ie, height: p }) => {
      p && p > 55 && (Q(!te), L(te)), ie();
    }
  });
  return /* @__PURE__ */ m("div", { className: "ui-bg-white ui-group", children: /* @__PURE__ */ m(
    "div",
    {
      className: o === "PROMO" ? "ui-relative ui-bg-promoPurple group-last:ui-rounded-b-[10px] group-last:before:ui-rounded-bl-[10px] ui-bg-opacity-10 before:ui-content-[''] before:ui-w-[3px] before:ui-h-full before:ui-absolute before:ui-top-0 before:ui-left-0 before:ui-bg-promoPurple" : o === "FEATURED" ? "ui-relative ui-bg-featuredGreen group-last:ui-rounded-b-[10px] group-last:before:ui-rounded-bl-[10px] ui-bg-opacity-10 before:ui-content-[''] before:ui-w-[3px] before:ui-h-full before:ui-mb-4 before:ui-absolute before:ui-top-0 before:ui-left-0 before:ui-bg-featuredGreen" : "",
      children: /* @__PURE__ */ M(
        "div",
        {
          className: `ui-py-4 ui-mx-4 ui-flex ui-flex-col ui-border-b group-last:ui-border-none ${o === "FEATURED" || o === "PROMO" ? "ui-border-gray-200" : "ui-border-gray-100 "}`,
          children: [
            /* @__PURE__ */ M("div", { className: "ui-flex ui-justify-between", children: [
              /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-col ui-max-w-[calc(100%-120px)]", children: [
                /* @__PURE__ */ M("div", { className: "ui-flex-1 ui-group/name", children: [
                  /* @__PURE__ */ m(
                    "div",
                    {
                      className: "ui-font-semibold ui-relative ui-items-center ui-flex ui-overflow-hidden ui-max-w-full [&>span]:ui-text-ellipsis [&>span]:ui-block [&>span]:ui-overflow-hidden [&>span]:ui-flex-1",
                      children: /* @__PURE__ */ M("span", { translate: "yes", children: [
                        e,
                        C && /* @__PURE__ */ m(qu, { style: { opacity: 0.5, display: "inline", marginBottom: "2px", marginLeft: "2px" } })
                      ] })
                    }
                  ),
                  C && /* @__PURE__ */ m(
                    "div",
                    {
                      className: "group-hover/name:ui-flex ui-hidden ui-absolute ui-shadow-md ui-border-gray-200 ui-border ui-w-fit ui-text-sm ui-bg-white ui-py-2 ui-px-3 ui-z-20 ui-rounded-md ui-flex-col before:ui-z-10 before:ui-bg-white before:ui-content-[''] before:ui-w-2 before:ui-h-2 before:ui-rotate-45 before:-ui-top-1 before:ui-absolute before:ui-left-[40%] before:ui-border-l before:ui-border-t before:ui-border-gray-200 [&>span]:ui-font-medium",
                      children: b
                    }
                  )
                ] }),
                /* @__PURE__ */ M("div", { className: "ui-flex ui-items-center", children: [
                  /* @__PURE__ */ m("span", { className: `${te ? "ui-mr-3 ui-line-through ui-decoration-gray-500" : ""} ui-text-base`, children: t }),
                  te && /* @__PURE__ */ m("span", { className: "ui-text-hooplaRed ui-bg-hooplaRedBg ui-text-sm ui-px-1 ui-pt-0.5 ui-rounded-[3px]", children: l })
                ] })
              ] }),
              /* @__PURE__ */ m("div", { className: "ui-h-10 ui-min-w-[84px] ui-max-w-[120px] ui-flex ui-justify-end ui-items-end", children: te ? /* @__PURE__ */ m(
                er,
                {
                  availability: a,
                  selected: o,
                  label: "Sold out",
                  icon: /* @__PURE__ */ m(Eo, { height: 40 })
                }
              ) : /* @__PURE__ */ M(en, { children: [
                /* @__PURE__ */ m(
                  er,
                  {
                    onClick: (ie) => {
                      ie.preventDefault(), i(r - 1);
                    },
                    availability: a,
                    selected: o,
                    hidden: r <= 0,
                    align: "left",
                    label: "Remove one from cart",
                    icon: /* @__PURE__ */ m(Co, { height: 18 })
                  }
                ),
                /* @__PURE__ */ m(
                  "input",
                  {
                    className: `ui-bg-gray-600 ui-bg-opacity-10 ui-border-0 ui-h-8 ui-max-w-[60px] md:ui-max-w-[65px] ui-text-black ui-text-center ui-font-semibold ui-outline-none ui-transition-[width] ui-ease-out ui-duration-75 ${r <= 0 ? "ui-w-0" : ""}`,
                    type: "text",
                    value: r,
                    onChange: (ie) => {
                      const p = parseInt(ie.target.value, 10);
                      isNaN(p) ? i(0) : i(parseInt(ie.target.value, 10));
                    }
                  }
                ),
                /* @__PURE__ */ m(
                  er,
                  {
                    onClick: (ie) => {
                      ie.preventDefault(), i(r + 1);
                    },
                    availability: a,
                    selected: o,
                    align: "right",
                    label: "Add one to cart",
                    icon: /* @__PURE__ */ m(ko, { height: 18 })
                  }
                )
              ] }) })
            ] }),
            /* @__PURE__ */ M("div", { translate: "yes", children: [
              /* @__PURE__ */ M("div", { className: te ? Z ? "ui-block" : "ui-hidden" : "ui-block", children: [
                n && /* @__PURE__ */ M(
                  "div",
                  {
                    ref: g.observe,
                    className: `ui-max-w-full ui-my-1 ui-text-sm ui-text-normal ui-text-neutral-900 ui-text-opacity-[0.65] ui-relative ${R ? "" : "ui-flex ui-flex-col [&>span]:ui-h-6 [&>span]:ui-whitespace-nowrap [&>span]:ui-text-ellipsis [&>span]:ui-block [&>span]:ui-overflow-hidden [&>span]:ui-flex-1"}`,
                    children: [
                      /* @__PURE__ */ m("span", { children: n }),
                      U && !R && /* @__PURE__ */ m("div", { className: "ui-flex-1 ui-mt-1", children: /* @__PURE__ */ m(
                        "button",
                        {
                          className: "ui-bg-transparent ui-text-sm ui-p-0 ui-leading-6 ui-border-0 ui-outline-none ui-cursor-pointer ui-underline hover:ui-opacity-80",
                          onClick: () => D(!0),
                          children: s
                        }
                      ) })
                    ]
                  }
                ),
                (y || h) && /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-col ui-mb-1 ui-text-sm ui-text-neutral-900 ui-text-opacity-[0.65]", children: [
                  y && /* @__PURE__ */ m("span", { children: v }),
                  h && /* @__PURE__ */ M("div", { children: [
                    /* @__PURE__ */ m("div", { ref: he.observe, className: Y ? "" : "preview", children: /* @__PURE__ */ m("span", { children: f }) }),
                    z && !Y && /* @__PURE__ */ m("div", { className: "ui-flex-1", children: /* @__PURE__ */ m(
                      "button",
                      {
                        className: "ui-mt-1 ui-bg-transparent ui-text-sm ui-p-0 ui-leading-6 ui-border-0 ui-outline-none ui-cursor-pointer ui-underline hover:ui-opacity-80",
                        onClick: () => L(!0),
                        children: s
                      }
                    ) })
                  ] })
                ] })
              ] }),
              Ce && (Z ? /* @__PURE__ */ m(
                "button",
                {
                  className: "ui-bg-transparent ui-text-sm ui-p-0 ui-text-neutral-900 ui-text-opacity-[0.65] ui-leading-6 ui-border-0 ui-outline-none ui-cursor-pointer ui-underline hover:ui-opacity-80",
                  onClick: () => ee(!1),
                  children: u.hide
                }
              ) : /* @__PURE__ */ m(
                "button",
                {
                  className: "ui-mt-1 ui-bg-transparent ui-text-sm ui-p-0 ui-text-neutral-900 ui-text-opacity-[0.65] ui-leading-6 ui-border-0 ui-outline-none ui-cursor-pointer ui-underline hover:ui-opacity-80",
                  onClick: () => ee(!0),
                  children: u.show
                }
              )),
              A && /* @__PURE__ */ m(Bt, { children: x }),
              T && /* @__PURE__ */ m(Bt, { children: N }),
              k && /* @__PURE__ */ m(Bt, { children: B }),
              d && /* @__PURE__ */ m(Bt, { children: c })
            ] })
          ]
        }
      )
    }
  ) });
}, Yu = () => /* @__PURE__ */ m("div", { className: "ui-py-4 ui-flex ui-flex-col ui-border-b last:ui-border-b-0 ui-border-gray-200 ui-px-4", children: /* @__PURE__ */ M("div", { className: "ui-flex ui-justify-between", children: [
  /* @__PURE__ */ M("div", { className: "ui-w-full", children: [
    /* @__PURE__ */ m("div", { className: "ui-bg-gray-100 ui-w-3/4 ui-h-6 ui-rounded-full" }),
    /* @__PURE__ */ m("div", { className: "ui-mt-2 ui-bg-gray-100 ui-w-[20%] ui-h-5 ui-rounded-full" })
  ] }),
  /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "ui-w-10 ui-h-10 ui-bg-gray-100 ui-rounded-full" }) })
] }) }), l0 = ({
  image: e,
  images: t,
  imageAlt: n,
  env: r,
  isCancelled: i,
  isPast: a,
  children: o,
  footerButton: l,
  cancelledText: s,
  pastText: u,
  active: d = !1
}) => /* @__PURE__ */ M(
  tn,
  {
    additionalCls: `ui-w-full desktopSmall:ui-w-[400px] first:[&>*]:ui-rounded-t-[10px] last:[&>*]:ui-rounded-b-[10px] ${d ? "!ui-bg-ticketBackgroundActive" : "!ui-bg-ticketBackgroundNonActive"}`,
    children: [
      /* @__PURE__ */ m("div", { className: "ui-hidden desktopSmall:ui-block", children: /* @__PURE__ */ m(
        Cr,
        {
          imgixImage: e,
          croppedImages: t,
          queries: [],
          style: { width: "100%", aspectRatio: "16/9", borderRadius: "12px 12px 0 0" },
          base: { width: 400, ar: "SixteenByNine" },
          alt: n,
          env: r
        }
      ) }),
      /* @__PURE__ */ M("div", { className: "ui-m-2.5 ui-rounded-[10px] first:[&>*]:ui-rounded-t-[10px] last:[&>*]:ui-rounded-b-[10px]", children: [
        i && /* @__PURE__ */ m(Wi, { type: "CANCELLED", children: s }),
        !i && a && /* @__PURE__ */ m(Wi, { type: "PAST", children: u }),
        !i && !a && o
      ] }),
      l
    ]
  }
), u0 = () => /* @__PURE__ */ M(tn, { additionalCls: "ui-w-full desktopSmall:ui-w-[400px] skeletonLoad !ui-bg-ticketBackgroundNonActive", children: [
  /* @__PURE__ */ m("div", { className: "ui-hidden desktopSmall:ui-flex [&_div]:ui-block [&_div]:ui-rounded-t-md [&_div]:ui-overflow-hidden", children: /* @__PURE__ */ m("div", { className: "ui-bg-gray-100 ui-aspect-video ui-w-full" }) }),
  /* @__PURE__ */ m("div", { className: "ui-m-2.5 ui-rounded-[10px] ui-bg-white", children: Array.apply(null, Array(5)).map((e, t) => /* @__PURE__ */ m(Yu, {}, t)) }),
  /* @__PURE__ */ m(Wu, {})
] }), Zu = (e) => /* @__PURE__ */ w.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M5.625 2.25L12.375 9L5.625 15.75", stroke: "currentColor", strokeWidth: 1.6875 })), Gu = (e) => /* @__PURE__ */ w.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M2.25 5.625L9 12.375L15.75 5.625", stroke: "currentColor", strokeWidth: 1.6875 })), Ju = (e) => /* @__PURE__ */ w.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25214 1C2.00832 1 1 2.00832 1 3.25214V14.7479C1 15.9917 2.00832 17 3.25214 17H14.7479C15.9917 17 17 15.9917 17 14.7479V3.25214C17 2.00832 15.9917 1 14.7479 1H3.25214ZM9.42355 4.59052C9.74968 4.26448 9.74975 3.73578 9.42371 3.40965C9.09767 3.08352 8.56898 3.08344 8.24285 3.40948L4.29839 7.35282L4.29831 7.35291C2.66484 8.98638 2.66484 11.6334 4.29831 13.2669C5.93178 14.9004 8.57883 14.9004 10.2123 13.2669L14.5505 8.92867C15.5292 7.95 15.5292 6.36046 14.5505 5.38179C13.5719 4.40313 11.9823 4.40313 11.0037 5.38179L7.45409 8.93136C7.12801 9.25744 7.12801 9.78614 7.45409 10.1122C7.78018 10.4383 8.30887 10.4383 8.63496 10.1122L12.1845 6.56266C12.511 6.23617 13.0432 6.23617 13.3697 6.56266C13.6961 6.88915 13.6961 7.42131 13.3697 7.7478L9.03143 12.086C8.05014 13.0673 6.46047 13.0673 5.47917 12.086C4.49791 11.1048 4.49788 9.51516 5.47909 8.53386L5.47917 8.53377L9.42355 4.59052Z", fill: "currentColor" })), Xu = (e) => /* @__PURE__ */ w.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25214 1C2.00832 1 1 2.00832 1 3.25214V14.7479C1 15.9917 2.00832 17 3.25214 17H14.7479C15.9917 17 17 15.9917 17 14.7479V3.25214C17 2.00832 15.9917 1 14.7479 1H3.25214ZM12.668 5.501C12.9447 5.13207 12.8699 4.60869 12.501 4.332C12.1321 4.05531 11.6087 4.13007 11.332 4.499L5.332 12.499C5.05531 12.8679 5.13007 13.3913 5.499 13.668C5.86793 13.9447 6.39131 13.8699 6.668 13.501L12.668 5.501ZM7.5 5.75C7.5 6.7165 6.7165 7.5 5.75 7.5C4.7835 7.5 4 6.7165 4 5.75C4 4.7835 4.7835 4 5.75 4C6.7165 4 7.5 4.7835 7.5 5.75ZM12.25 14C13.2165 14 14 13.2165 14 12.25C14 11.2835 13.2165 10.5 12.25 10.5C11.2835 10.5 10.5 11.2835 10.5 12.25C10.5 13.2165 11.2835 14 12.25 14Z", fill: "currentColor" })), Ku = (e) => /* @__PURE__ */ w.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("g", { clipPath: "url(#clip0_6954_9863)" }, /* @__PURE__ */ w.createElement("path", { d: "M6.87931 5.70977L9 2.0086L11.1207 5.70977L11.7714 5.33691L11.1207 5.70977C11.2982 6.01963 11.5998 6.23876 11.9494 6.31186L16.1247 7.18503L13.2601 10.3456L13.8158 10.8493L13.26 10.3456C13.0202 10.6103 12.905 10.9648 12.9435 11.3199L13.4033 15.5607L9.51217 13.8129C9.1864 13.6665 8.8136 13.6665 8.48783 13.8129L4.59666 15.5607L5.05649 11.3199C5.09498 10.9648 4.97978 10.6103 4.73995 10.3456L1.87525 7.18503L6.0506 6.31186C6.40017 6.23876 6.70177 6.01963 6.87931 5.70977ZM16.4178 6.86174L16.4174 6.86218L16.4178 6.86174Z", fill: "#FFCF1F", stroke: "#FFCF1F", strokeWidth: 1.5 })), /* @__PURE__ */ w.createElement("defs", null, /* @__PURE__ */ w.createElement("clipPath", { id: "clip0_6954_9863" }, /* @__PURE__ */ w.createElement("rect", { width: 18, height: 18, fill: "white" })))), Rn = ({ children: e }) => /* @__PURE__ */ m("div", { className: "ui-opacity-50 ui-mr-4 ui-text-black", children: e }), _u = ({
  stateText: e,
  availabilityText: t
}) => /* @__PURE__ */ M(G.Fragment, { children: [
  /* @__PURE__ */ M("div", { className: "ui-flex-1 ui-flex", children: [
    /* @__PURE__ */ m(Ju, { color: "#4FC391", height: 20 }),
    /* @__PURE__ */ m("span", { className: "ui-ml-1 ui-text-black ui-font-medium ui-truncate", children: e })
  ] }),
  t && /* @__PURE__ */ m(Rn, { children: t })
] }), $u = ({
  stateText: e,
  availabilityText: t
}) => /* @__PURE__ */ M(G.Fragment, { children: [
  /* @__PURE__ */ M("div", { className: "ui-flex-1 ui-flex", children: [
    /* @__PURE__ */ m(Xu, { color: "#B28BF9", height: 20 }),
    /* @__PURE__ */ m("span", { className: "ui-ml-1 ui-text-black ui-font-medium ui-truncate", children: e })
  ] }),
  t && /* @__PURE__ */ m(Rn, { children: t })
] }), es = ({
  stateText: e,
  availabilityText: t
}) => /* @__PURE__ */ M(G.Fragment, { children: [
  /* @__PURE__ */ M("div", { className: "ui-flex-1 ui-flex", children: [
    /* @__PURE__ */ m(Ku, { height: 20 }),
    /* @__PURE__ */ m("span", { className: "ui-ml-1 ui-text-black ui-font-medium ui-truncate", children: e })
  ] }),
  t && /* @__PURE__ */ m(Rn, { children: t })
] }), ts = ({
  stateText: e,
  availabilityText: t
}) => /* @__PURE__ */ M(G.Fragment, { children: [
  /* @__PURE__ */ m("span", { translate: "yes", className: "ui-flex-1 ui-text-left ui-text-black ui-font-medium ui-truncate", children: e }),
  t && /* @__PURE__ */ m(Rn, { children: t })
] }), ns = {
  FEATURED: _u,
  PROMO: $u,
  PROMOTED: es,
  NONE: ts
}, s0 = ({
  name: e,
  description: t,
  groupAvailability: n = "MANY_LEFT",
  groupSelected: r = "NONE",
  stateTexts: i,
  availabilityTexts: a,
  isOpen: o,
  onOpen: l,
  quantity: s,
  children: u
}) => {
  const [d, c] = G.useState(o);
  let h;
  G.useEffect(() => (o ? c(o) : h = setTimeout(() => {
    c(o);
  }, 75), () => {
    clearTimeout(h);
  }), [o]);
  const f = i[r] || null, y = a[n] || null;
  let v;
  if (n !== "SOLD_OUT") {
    const C = ns[r];
    v = /* @__PURE__ */ m(C, { stateText: r === "NONE" ? e : f, availabilityText: y });
  } else
    v = /* @__PURE__ */ M(G.Fragment, { children: [
      /* @__PURE__ */ m("span", { className: "ui-font-normal ui-flex-1 ui-text-left ui-text-black ui-truncate", children: e }),
      y && /* @__PURE__ */ m("span", { className: "ui-mr-4 ui-text-black", children: y })
    ] });
  return /* @__PURE__ */ M(
    "div",
    {
      className: `ui-bg-white ui-rounded-[10px] ui-mt-3 first:ui-mt-0 ${n === "SOLD_OUT" ? "ui-opacity-50" : ""}`,
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: `ui-overflow-hidden ui-py-2 ui-z-10 ui-relative ui-border-gray-300 ui-bg-white ui-mx-4 ${o ? "ui-border-b" : "ui-border-none"}`,
            children: /* @__PURE__ */ M(
              "button",
              {
                className: `ui-w-full ui-flex ui-flex-col ui-py-2 ${n === "SOLD_OUT" ? "ui-cursor-default" : ""}`,
                onClick: l,
                children: [
                  /* @__PURE__ */ M("div", { className: "ui-flex ui-items-center ui-w-full ui-gap-1", children: [
                    v,
                    s > 0 && !o && n !== "SOLD_OUT" && /* @__PURE__ */ m("div", { className: "ui-rounded-full ui-bg-cornflowerBlue ui-min-w-[1.5rem] ui-min-h-[1.5rem]", children: /* @__PURE__ */ m("span", { className: "ui-text-sm ui-text-white", children: s }) }),
                    /* @__PURE__ */ m("div", { className: o ? "" : "ui-opacity-20", children: o ? /* @__PURE__ */ m(Gu, { height: 18 }) : /* @__PURE__ */ m(Zu, { height: 18 }) })
                  ] }),
                  t && (o || d) && /* @__PURE__ */ m(
                    "span",
                    {
                      translate: "yes",
                      className: `${d && o ? "ui-opacity-100 ui-translate-y-0" : "ui-opacity-0 ui-translate-y-[-0.5rem]"} ui-transition-all ui-duration-150 ui-ease-out ui-text-sm ui-text-gray-500 ui-text-left`,
                      children: t
                    }
                  )
                ]
              }
            )
          }
        ),
        (o || d) && /* @__PURE__ */ m(
          "div",
          {
            className: `${d && o ? "ui-opacity-100 ui-translate-y-0" : "ui-opacity-0 ui-translate-y-[-2rem]"} ui-transition-all ui-duration-150 ui-ease-out last:[&>div]:ui-rounded-b-lg ui-z-20 relative`,
            children: u
          }
        )
      ]
    }
  );
}, tr = ({
  label: e,
  state: t = "NONE",
  disabled: n = !1,
  icon: r,
  align: i = "right",
  onClick: a,
  hidden: o = !1
}) => /* @__PURE__ */ m(
  "button",
  {
    onClick: a,
    disabled: t === "SOLD_OUT" || n,
    className: `ui-flex ui-items-center ui-justify-center ui-bg-cornflowerBlue disabled:ui-bg-gray-500 disabled:ui-cursor-default disabled:ui-brightness-100 ui-rounded-full ui-p-0 ui-border-0 ui-min-w-[32px] ui-w-8 ui-h-8 ui-outline-none ui-select-none ui-z-10 ui-cursor-pointer ui-transition-transform ui-ease-out ui-duration-[75ms] hover:ui-brightness-90 focus:ui-brightness-90 focus:ui-border focus:ui-border-gray-600 active:ui-brightness-75 ${i === "left" ? "ui-mr-[-15px]" : "ui-ml-[-15px]"} ${o ? "ui-translate-x-[2px]" : ""} ${{
      PROMO: "ui-bg-promoPurple",
      SOLD_OUT: "!ui-bg-white !ui-cursor-default hover:!ui-brightness-100 active:!ui-brightness-100 focus:!ui-brightness-100 !ui-opacity-30",
      FEATURED: "ui-bg-featuredGreen",
      NONE: "",
      POPULAR: ""
    }[t]}`,
    "aria-label": e,
    children: r
  }
), c0 = ({
  name: e,
  formattedPrice: t,
  description: n,
  quantity: r,
  onChangeQuantity: i,
  state: a = "NONE",
  soldOutMessage: o,
  showMoreMessage: l,
  error: s,
  showFeeSpecification: u,
  feeSpecification: d,
  maxPerTicket: c,
  minPerTicket: h,
  errorMessage: f,
  comments: y
}) => {
  const [v, C] = G.useState(!1), [b, A] = G.useState(!0), { observe: x } = Cn({
    onResize: ({ unobserve: N, height: k }) => {
      k && k > 25 && (C(!0), A(!1)), N();
    }
  }), T = a === "SOLD_OUT";
  return /* @__PURE__ */ m("div", { className: "ui-bg-white ui-group", children: /* @__PURE__ */ M("div", { className: "ui-py-4 ui-mx-4 ui-flex ui-flex-col ui-border-b group-last:ui-border-none ui-border-gray-100", children: [
    /* @__PURE__ */ M("div", { className: "ui-flex ui-justify-between", children: [
      /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-col", children: [
        /* @__PURE__ */ m("div", { className: "ui-flex-1 ui-group ui-relative", children: /* @__PURE__ */ m("div", { className: "ui-font-semibold ui-items-center ui-flex", translate: "yes", children: e }) }),
        /* @__PURE__ */ M("div", { className: "ui-flex ui-items-center", children: [
          /* @__PURE__ */ m("span", { className: `${T ? "ui-mr-3 ui-line-through ui-decoration-gray-500" : ""} ui-text-base`, children: t }),
          T && /* @__PURE__ */ m("span", { className: "ui-text-hooplaRed ui-bg-hooplaRedBg ui-text-sm ui-px-1 ui-pt-0.5 ui-rounded-[3px]", children: o })
        ] })
      ] }),
      /* @__PURE__ */ m("div", { className: "ui-h-10 ui-min-w-[84px] ui-max-w-[120px] ui-flex ui-justify-end", children: T ? /* @__PURE__ */ m(tr, { state: a, label: "Sold out", icon: /* @__PURE__ */ m(Eo, { height: 40 }) }) : /* @__PURE__ */ M(en, { children: [
        /* @__PURE__ */ m(
          tr,
          {
            onClick: (N) => {
              N.preventDefault(), i(r - 1);
            },
            state: a,
            hidden: r <= 0,
            align: "left",
            disabled: h ? r <= h : !1,
            label: "Remove one from cart",
            icon: /* @__PURE__ */ m(Co, { height: 18 })
          }
        ),
        /* @__PURE__ */ m(
          "input",
          {
            className: `ui-bg-gray-600 ui-bg-opacity-10 ui-border-0 ui-h-8 ui-max-w-[60px] md:ui-max-w-[65px] ui-text-black ui-text-center ui-font-semibold ui-outline-none ui-transition-[width] ui-ease-out ui-duration-75 ${r <= 0 ? "ui-w-0" : ""}`,
            type: "text",
            value: r,
            onChange: (N) => {
              const k = parseInt(N.target.value, 10);
              isNaN(k) ? i(0) : i(parseInt(N.target.value, 10));
            }
          }
        ),
        /* @__PURE__ */ m(
          tr,
          {
            onClick: (N) => {
              N.preventDefault(), i(r + 1);
            },
            disabled: c ? r >= c : !1,
            state: a,
            align: "right",
            label: "Add one to cart",
            icon: /* @__PURE__ */ m(ko, { height: 18 })
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ M("div", { translate: "yes", children: [
      n && /* @__PURE__ */ M(
        "div",
        {
          ref: x,
          className: `ui-max-w-full ui-mt-1 ui-text-sm ui-text-normal ui-text-neutral-900 ui-relative ui-text-opacity-[0.65] ${b ? "" : "ui-flex ui-flex-col [&>span]:ui-h-6 [&>span]:ui-whitespace-nowrap [&>span]:ui-text-ellipsis [&>span]:ui-block [&>span]:ui-overflow-hidden [&>span]:ui-flex-1"}`,
          children: [
            /* @__PURE__ */ m("span", { children: n }),
            v && !b && /* @__PURE__ */ m("div", { className: "ui-flex-1", children: /* @__PURE__ */ m(
              "button",
              {
                className: "ui-bg-white ui-text-sm ui-p-0 ui-leading-6 ui-border-0 ui-outline-none ui-cursor-pointer ui-underline hover:ui-opacity-80",
                onClick: () => A(!0),
                children: l
              }
            ) })
          ]
        }
      ),
      u && /* @__PURE__ */ m("div", { className: "ui-flex ui-flex-col ui-mb-1 ui-text-sm ui-text-neutral-900 ui-text-opacity-[0.65]", children: d }),
      s && /* @__PURE__ */ m(Bt, { children: f }),
      y.length > 0 && /* @__PURE__ */ m("div", { className: "ui-flex ui-flex-col ui-gap-2 ui-mt-2", children: y.map((N) => /* @__PURE__ */ M("div", { className: "ui-relative", children: [
        /* @__PURE__ */ m(
          "input",
          {
            id: N.id,
            className: "ui-p-3 ui-border ui-border-gray-300 ui-rounded-md ui-w-full ui-overflow-hidden ui-resize-none ui-peer ui-block",
            placeholder: "",
            type: "text",
            value: N.comment,
            onChange: (k) => N.onChangeComment(k.target.value)
          }
        ),
        /* @__PURE__ */ m(
          "label",
          {
            htmlFor: N.id,
            className: "ui-absolute ui-text-sm ui-text-neutral-500 ui-duration-300 ui-transform ui--translate-y-4 ui-scale-75 ui-top-2 ui-z-10 ui-origin-[0] ui-bg-white ui-px-2 peer-focus:ui-px-2 peer-focus:ui-text-blue-600 peer-placeholder-shown:ui-scale-100 peer-placeholder-shown:ui--translate-y-1/2 peer-placeholder-shown:ui-top-1/2 peer-focus:ui-top-2 peer-focus:ui-scale-75 peer-focus:ui--translate-y-4 ui-start-1",
            children: N.commentPlaceHolder
          }
        )
      ] }, N.id)) })
    ] })
  ] }) });
}, d0 = () => /* @__PURE__ */ m("div", { className: "ui-py-4 ui-flex ui-flex-col ui-border-b last:ui-border-b-0 ui-border-gray-200 ui-px-4", children: /* @__PURE__ */ M("div", { className: "ui-flex ui-justify-between", children: [
  /* @__PURE__ */ M("div", { className: "ui-w-full", children: [
    /* @__PURE__ */ m("div", { className: "ui-bg-gray-100 ui-w-3/4 ui-h-6 ui-rounded-full" }),
    /* @__PURE__ */ m("div", { className: "ui-mt-2 ui-bg-gray-100 ui-w-[20%] ui-h-5 ui-rounded-full" })
  ] }),
  /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m("div", { className: "ui-w-10 ui-h-10 ui-bg-gray-100 ui-rounded-full" }) })
] }) }), f0 = ({ children: e, footerButton: t }) => /* @__PURE__ */ M("div", { className: "ui-w-full desktopSmall:ui-w-[360px] ui-flex ui-flex-col ui-gap-8", children: [
  /* @__PURE__ */ m(tn, { additionalCls: "!ui-bg-gray-100", children: /* @__PURE__ */ m("div", { className: "ui-m-2.5 ui-rounded-[10px] ui-overflow-hidden", children: e }) }),
  t
] }), h0 = ({
  summaryLines: e,
  summaryTotal: t,
  onContinue: n,
  buttonText: r,
  loading: i,
  disabled: a = !1
}) => /* @__PURE__ */ M("div", { className: "ui-flex ui-flex-col ui-gap-4", children: [
  /* @__PURE__ */ m("div", { className: "ui-border-b ui-border-gray-300 ui-pb-4", children: e }),
  /* @__PURE__ */ m("div", { children: t }),
  i ? /* @__PURE__ */ m(
    "button",
    {
      className: "ui-py-3 ui-rounded-md ui-px-5 ui-bg-cornflowerBlue ui-text-white ui-w-full ui-flex ui-justify-center ui-mt-4",
      disabled: !0,
      children: /* @__PURE__ */ m(bt, { theme: "white" })
    }
  ) : /* @__PURE__ */ m(
    "button",
    {
      className: "ui-py-3 ui-rounded-md ui-px-5 ui-bg-cornflowerBlue ui-text-white ui-font-semibold hover:ui-opacity-80 ui-w-full  ui-justify-center ui-mt-4 disabled:ui-bg-gray-300 disabled:ui-cursor-default disabled:hover:ui-opacity-100",
      onClick: n,
      disabled: a,
      children: r
    }
  )
] }), m0 = {
  GRAY: "gray",
  WHITE: "white"
}, qi = {
  GRAY: "ui-bg-gray-200",
  WHITE: "ui-bg-white"
}, ve = ({ icon: e, children: t, theme: n = "WHITE", hoverable: r = !1 }) => e ? /* @__PURE__ */ m(
  "div",
  {
    className: `ui-text-sm ui-border ui-w-fit ui-border-gray-100 ui-rounded-full ui-flex ui-shadow-sm ui-overflow-hidden ${r ? "hover:ui-border-gray-200 hover:ui-cursor-default" : ""} ${qi[n]}`,
    children: /* @__PURE__ */ M("div", { className: "ui-flex ui-items-center ui-px-3 ui-py-2", children: [
      e,
      /* @__PURE__ */ m("span", { className: "ui-ml-1", children: t })
    ] })
  }
) : /* @__PURE__ */ m(
  "div",
  {
    className: `ui-text-sm ui-border ui-w-fit ui-border-gray-100 ui-rounded-full ui-flex ui-shadow-sm ui-overflow-hidden ${r ? "hover:ui-border-gray-200 hover:ui-cursor-default" : ""}${qi[n]}`,
    children: /* @__PURE__ */ m("div", { className: "ui-flex ui-items-center ui-px-3 ui-py-2", children: t })
  }
), Pe = ({ children: e }) => /* @__PURE__ */ m("div", { className: "ui-flex ui-flex-wrap [&>div]:ui-mr-1 [&>div:last-child]:ui-mr-0 ui-gap-y-2", children: e }), It = ({ loadAnimation: e = !1 }) => /* @__PURE__ */ m(
  "div",
  {
    className: `ui-text-sm ui-border ui-w-[75px] ui-relative ui-border-gray-100 ui-rounded-full ui-flex ui-shadow-sm ui-overflow-hidden ui-bg-gray-100 ui-flex-grow-0 ${e ? "skeletonLoad" : ""}`,
    children: /* @__PURE__ */ m("div", { className: "ui-h-8" })
  }
);
function En(e) {
  "@babel/helpers - typeof";
  return En = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, En(e);
}
function it(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function re(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ue(e) {
  re(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || En(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function rs(e, t) {
  re(2, arguments);
  var n = ue(e).getTime(), r = it(t);
  return new Date(n + r);
}
var is = {};
function jn() {
  return is;
}
function Er(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Sn(e) {
  re(1, arguments);
  var t = ue(e);
  return t.setHours(0, 0, 0, 0), t;
}
var as = 864e5;
function os(e, t) {
  re(2, arguments);
  var n = Sn(e), r = Sn(t), i = n.getTime() - Er(n), a = r.getTime() - Er(r);
  return Math.round((i - a) / as);
}
function ls(e, t) {
  re(2, arguments);
  var n = Sn(e), r = Sn(t);
  return n.getTime() === r.getTime();
}
function us(e) {
  return re(1, arguments), e instanceof Date || En(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ss(e) {
  if (re(1, arguments), !us(e) && typeof e != "number")
    return !1;
  var t = ue(e);
  return !isNaN(Number(t));
}
function cs(e, t) {
  re(2, arguments);
  var n = it(t);
  return rs(e, -n);
}
var ds = 864e5;
function fs(e) {
  re(1, arguments);
  var t = ue(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), i = n - r;
  return Math.floor(i / ds) + 1;
}
function Nn(e) {
  re(1, arguments);
  var t = 1, n = ue(e), r = n.getUTCDay(), i = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function Oo(e) {
  re(1, arguments);
  var t = ue(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = Nn(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = Nn(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function hs(e) {
  re(1, arguments);
  var t = Oo(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Nn(n);
  return r;
}
var ms = 6048e5;
function ps(e) {
  re(1, arguments);
  var t = ue(e), n = Nn(t).getTime() - hs(t).getTime();
  return Math.round(n / ms) + 1;
}
function Mn(e, t) {
  var n, r, i, a, o, l, s, u;
  re(1, arguments);
  var d = jn(), c = it((n = (r = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && r !== void 0 ? r : (s = d.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ue(e), f = h.getUTCDay(), y = (f < c ? 7 : 0) + f - c;
  return h.setUTCDate(h.getUTCDate() - y), h.setUTCHours(0, 0, 0, 0), h;
}
function To(e, t) {
  var n, r, i, a, o, l, s, u;
  re(1, arguments);
  var d = ue(e), c = d.getUTCFullYear(), h = jn(), f = it((n = (r = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (s = h.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(f >= 1 && f <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(c + 1, 0, f), y.setUTCHours(0, 0, 0, 0);
  var v = Mn(y, t), C = /* @__PURE__ */ new Date(0);
  C.setUTCFullYear(c, 0, f), C.setUTCHours(0, 0, 0, 0);
  var b = Mn(C, t);
  return d.getTime() >= v.getTime() ? c + 1 : d.getTime() >= b.getTime() ? c : c - 1;
}
function gs(e, t) {
  var n, r, i, a, o, l, s, u;
  re(1, arguments);
  var d = jn(), c = it((n = (r = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : d.firstWeekContainsDate) !== null && r !== void 0 ? r : (s = d.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = To(e, t), f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(h, 0, c), f.setUTCHours(0, 0, 0, 0);
  var y = Mn(f, t);
  return y;
}
var ys = 6048e5;
function bs(e, t) {
  re(1, arguments);
  var n = ue(e), r = Mn(n, t).getTime() - gs(n, t).getTime();
  return Math.round(r / ys) + 1;
}
function X(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var vs = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return X(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : X(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return X(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return X(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return X(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return X(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return X(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, i = t.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, r - 3));
    return X(a, n.length);
  }
};
const qe = vs;
var st = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ws = {
  // Era
  G: function(t, n, r) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var i = t.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return qe.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, i) {
    var a = To(t, i), o = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var l = o % 100;
      return X(l, 2);
    }
    return n === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : X(o, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = Oo(t);
    return X(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return X(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return X(i, 2);
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return X(i, 2);
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return qe.M(t, n);
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return X(i + 1, 2);
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, i) {
    var a = bs(t, i);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : X(a, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var i = ps(t);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : X(i, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : qe.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var i = fs(t);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : X(i, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var i = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(o);
      case "ee":
        return X(o, 2);
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(o);
      case "cc":
        return X(o, n.length);
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var i = t.getUTCDay(), a = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(a);
      case "ii":
        return X(a, n.length);
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var i = t.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var i = t.getUTCHours(), a;
    switch (i === 12 ? a = st.noon : i === 0 ? a = st.midnight : a = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var i = t.getUTCHours(), a;
    switch (i >= 17 ? a = st.evening : i >= 12 ? a = st.afternoon : i >= 4 ? a = st.morning : a = st.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return qe.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : qe.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var i = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : X(i, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : X(i, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : qe.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : qe.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return qe.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      case "X":
        return Zi(o);
      case "XXXX":
      case "XX":
        return tt(o);
      case "XXXXX":
      case "XXX":
      default:
        return tt(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      case "x":
        return Zi(o);
      case "xxxx":
      case "xx":
        return tt(o);
      case "xxxxx":
      case "xxx":
      default:
        return tt(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Yi(o, ":");
      case "OOOO":
      default:
        return "GMT" + tt(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Yi(o, ":");
      case "zzzz":
      default:
        return "GMT" + tt(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, i) {
    var a = i._originalDate || t, o = Math.floor(a.getTime() / 1e3);
    return X(o, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, i) {
    var a = i._originalDate || t, o = a.getTime();
    return X(o, n.length);
  }
};
function Yi(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(i);
  var o = t || "";
  return n + String(i) + o + X(a, 2);
}
function Zi(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + X(Math.abs(e) / 60, 2);
  }
  return tt(e, t);
}
function tt(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", i = Math.abs(e), a = X(Math.floor(i / 60), 2), o = X(i % 60, 2);
  return r + a + n + o;
}
const xs = ws;
var Gi = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Po = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, As = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], i = r[1], a = r[2];
  if (!a)
    return Gi(t, n);
  var o;
  switch (i) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Gi(i, n)).replace("{{time}}", Po(a, n));
}, ks = {
  p: Po,
  P: As
};
const Cs = ks;
var Es = ["D", "DD"], Ss = ["YY", "YYYY"];
function Ns(e) {
  return Es.indexOf(e) !== -1;
}
function Ms(e) {
  return Ss.indexOf(e) !== -1;
}
function Ji(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Os = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ts = function(t, n, r) {
  var i, a = Os[t];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
const Do = Ts;
function Qe(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var Ps = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ds = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, zs = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Bs = {
  date: Qe({
    formats: Ps,
    defaultWidth: "full"
  }),
  time: Qe({
    formats: Ds,
    defaultWidth: "full"
  }),
  dateTime: Qe({
    formats: zs,
    defaultWidth: "full"
  })
};
const Ls = Bs;
var Is = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Fs = function(t, n, r, i) {
  return Is[t];
};
const zo = Fs;
function ze(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, o = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var l = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[s] || e.values[l];
    }
    var u = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[u];
  };
}
var Rs = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, js = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Vs = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Hs = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Qs = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Us = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ws = function(t, n) {
  var r = Number(t), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, qs = {
  ordinalNumber: Ws,
  era: ze({
    values: Rs,
    defaultWidth: "wide"
  }),
  quarter: ze({
    values: js,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ze({
    values: Vs,
    defaultWidth: "wide"
  }),
  day: ze({
    values: Hs,
    defaultWidth: "wide"
  }),
  dayPeriod: ze({
    values: Qs,
    defaultWidth: "wide",
    formattingValues: Us,
    defaultFormattingWidth: "wide"
  })
};
const Bo = qs;
function Be(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var o = a[0], l = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(l) ? Zs(l, function(c) {
      return c.test(o);
    }) : Ys(l, function(c) {
      return c.test(o);
    }), u;
    u = e.valueCallback ? e.valueCallback(s) : s, u = n.valueCallback ? n.valueCallback(u) : u;
    var d = t.slice(o.length);
    return {
      value: u,
      rest: d
    };
  };
}
function Ys(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function Zs(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Lo(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var i = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var l = t.slice(i.length);
    return {
      value: o,
      rest: l
    };
  };
}
var Gs = /^(\d+)(th|st|nd|rd)?/i, Js = /\d+/i, Xs = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ks = {
  any: [/^b/i, /^(a|c)/i]
}, _s = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, $s = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ec = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, tc = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, nc = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, rc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ic = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ac = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, oc = {
  ordinalNumber: Lo({
    matchPattern: Gs,
    parsePattern: Js,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Be({
    matchPatterns: Xs,
    defaultMatchWidth: "wide",
    parsePatterns: Ks,
    defaultParseWidth: "any"
  }),
  quarter: Be({
    matchPatterns: _s,
    defaultMatchWidth: "wide",
    parsePatterns: $s,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Be({
    matchPatterns: ec,
    defaultMatchWidth: "wide",
    parsePatterns: tc,
    defaultParseWidth: "any"
  }),
  day: Be({
    matchPatterns: nc,
    defaultMatchWidth: "wide",
    parsePatterns: rc,
    defaultParseWidth: "any"
  }),
  dayPeriod: Be({
    matchPatterns: ic,
    defaultMatchWidth: "any",
    parsePatterns: ac,
    defaultParseWidth: "any"
  })
};
const Io = oc;
var lc = {
  code: "en-US",
  formatDistance: Do,
  formatLong: Ls,
  formatRelative: zo,
  localize: Bo,
  match: Io,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const uc = lc;
var sc = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, cc = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, dc = /^'([^]*?)'?$/, fc = /''/g, hc = /[a-zA-Z]/;
function Sr(e, t, n) {
  var r, i, a, o, l, s, u, d, c, h, f, y, v, C, b, A, x, T;
  re(2, arguments);
  var N = String(t), k = jn(), B = (r = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : k.locale) !== null && r !== void 0 ? r : uc, U = it((a = (o = (l = (s = n == null ? void 0 : n.firstWeekContainsDate) !== null && s !== void 0 ? s : n == null || (u = n.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : k.firstWeekContainsDate) !== null && o !== void 0 ? o : (c = k.locale) === null || c === void 0 || (h = c.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(U >= 1 && U <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var I = it((f = (y = (v = (C = n == null ? void 0 : n.weekStartsOn) !== null && C !== void 0 ? C : n == null || (b = n.locale) === null || b === void 0 || (A = b.options) === null || A === void 0 ? void 0 : A.weekStartsOn) !== null && v !== void 0 ? v : k.weekStartsOn) !== null && y !== void 0 ? y : (x = k.locale) === null || x === void 0 || (T = x.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(I >= 0 && I <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!B.localize)
    throw new RangeError("locale must contain localize property");
  if (!B.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var R = ue(e);
  if (!ss(R))
    throw new RangeError("Invalid time value");
  var D = Er(R), z = cs(R, D), Q = {
    firstWeekContainsDate: U,
    weekStartsOn: I,
    locale: B,
    _originalDate: R
  }, Y = N.match(cc).map(function(L) {
    var Z = L[0];
    if (Z === "p" || Z === "P") {
      var ee = Cs[Z];
      return ee(L, B.formatLong);
    }
    return L;
  }).join("").match(sc).map(function(L) {
    if (L === "''")
      return "'";
    var Z = L[0];
    if (Z === "'")
      return mc(L);
    var ee = xs[Z];
    if (ee)
      return !(n != null && n.useAdditionalWeekYearTokens) && Ms(L) && Ji(L, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && Ns(L) && Ji(L, t, String(e)), ee(z, L, B.localize, Q);
    if (Z.match(hc))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Z + "`");
    return L;
  }).join("");
  return Y;
}
function mc(e) {
  var t = e.match(dc);
  return t ? t[1].replace(fc, "'") : e;
}
function Xi(e) {
  re(1, arguments);
  var t = ue(e), n = t.getHours();
  return n;
}
function pc(e, t) {
  re(2, arguments);
  var n = ue(e), r = ue(t);
  return n.getTime() < r.getTime();
}
function gc(e, t) {
  re(2, arguments);
  var n = ue(e), r = ue(t);
  return n.getFullYear() === r.getFullYear();
}
var yc = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, bc = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, vc = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wc = {
  date: Qe({
    formats: yc,
    defaultWidth: "full"
  }),
  time: Qe({
    formats: bc,
    defaultWidth: "full"
  }),
  dateTime: Qe({
    formats: vc,
    defaultWidth: "full"
  })
};
const xc = wc;
var Ac = {
  code: "en-GB",
  formatDistance: Do,
  formatLong: xc,
  formatRelative: zo,
  localize: Bo,
  match: Io,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const kc = Ac;
var Cc = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, Ec = function(t, n, r) {
  var i, a = Cc[t];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + i : i + " siden" : i;
};
const Sc = Ec;
var Nc = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, Mc = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Oc = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Tc = {
  date: Qe({
    formats: Nc,
    defaultWidth: "full"
  }),
  time: Qe({
    formats: Mc,
    defaultWidth: "full"
  }),
  dateTime: Qe({
    formats: Oc,
    defaultWidth: "full"
  })
};
const Pc = Tc;
var Dc = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, zc = function(t, n, r, i) {
  return Dc[t];
};
const Bc = zc;
var Lc = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, Ic = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Fc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, Rc = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, jc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, Vc = function(t, n) {
  var r = Number(t);
  return r + ".";
}, Hc = {
  ordinalNumber: Vc,
  era: ze({
    values: Lc,
    defaultWidth: "wide"
  }),
  quarter: ze({
    values: Ic,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ze({
    values: Fc,
    defaultWidth: "wide"
  }),
  day: ze({
    values: Rc,
    defaultWidth: "wide"
  }),
  dayPeriod: ze({
    values: jc,
    defaultWidth: "wide"
  })
};
const Qc = Hc;
var Uc = /^(\d+)\.?/i, Wc = /\d+/i, qc = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, Yc = {
  any: [/^f/i, /^e/i]
}, Zc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, Gc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Jc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, Xc = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Kc = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, _c = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, $c = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, ed = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, td = {
  ordinalNumber: Lo({
    matchPattern: Uc,
    parsePattern: Wc,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Be({
    matchPatterns: qc,
    defaultMatchWidth: "wide",
    parsePatterns: Yc,
    defaultParseWidth: "any"
  }),
  quarter: Be({
    matchPatterns: Zc,
    defaultMatchWidth: "wide",
    parsePatterns: Gc,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Be({
    matchPatterns: Jc,
    defaultMatchWidth: "wide",
    parsePatterns: Xc,
    defaultParseWidth: "any"
  }),
  day: Be({
    matchPatterns: Kc,
    defaultMatchWidth: "wide",
    parsePatterns: _c,
    defaultParseWidth: "any"
  }),
  dayPeriod: Be({
    matchPatterns: $c,
    defaultMatchWidth: "any",
    parsePatterns: ed,
    defaultParseWidth: "any"
  })
};
const nd = td;
var rd = {
  code: "nb",
  formatDistance: Sc,
  formatLong: Pc,
  formatRelative: Bc,
  localize: Qc,
  match: nd,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Ki = rd, ct = {
  todayDateMonth: "'Today', d. LLL",
  // Today, 1. jan
  todayDayDateMonth: "'Today', eee d. LLL",
  // Today, 1. jan
  tomorrowDateMonth: "'Tomorrow', d. LLL",
  // Tomorrow, 1. jan
  dayDateMonth: "eee d. LLL",
  // Monday 1. jan
  dayDateMonthYear: "eee d. LLL yyyy"
  // Monday 1. jan 2019
}, nr = {
  todayDateMonth: "'I dag', d. LLL",
  // Today, 1. jan
  todayDayDateMonth: "'I dag', eee d. LLL",
  // Today, 1. jan
  tomorrowDateMonth: "'I morgen', d. LLL",
  // Tomorrow, 1. jan
  dayDateMonth: "eee d. LLL",
  // Monday 1. jan
  dayDateMonthYear: "eee d. LLL yyyy"
  // Monday 1. jan 2019
}, id = (e) => {
  switch (e) {
    case "en-US":
    case "en-GB":
      return kc;
    case "nb-NO":
      return Ki;
    default:
      return Ki;
  }
}, ad = (e, t = /* @__PURE__ */ new Date(), n = "nb-NO") => pc(e, t) ? ct.dayDateMonthYear : ls(t, e) ? Xi(t) <= 5 && Xi(t) >= 0 ? n === "en-GB" ? ct.todayDayDateMonth : nr.todayDayDateMonth : n === "en-GB" ? ct.todayDateMonth : nr.todayDateMonth : os(e, t) === 1 ? n === "en-GB" ? ct.tomorrowDateMonth : nr.tomorrowDateMonth : gc(e, t) ? ct.dayDateMonth : ct.dayDateMonthYear, od = (e, t = "nb-NO", n = /* @__PURE__ */ new Date()) => {
  const r = Sr(e, ad(e, n, t), {
    locale: id(t)
  });
  return r.charAt(0).toUpperCase() + r.slice(1);
}, le = (e, t = "nb-NO", n = /* @__PURE__ */ new Date()) => od(e, t, n), Ve = (e) => /* @__PURE__ */ w.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("rect", { x: 2, y: 3, width: 14, height: 14, rx: 2.25214, fill: "currentColor" }), /* @__PURE__ */ w.createElement("path", { d: "M6 8H12", stroke: "white", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ w.createElement("path", { d: "M6 2.00012L6 4.00012", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ w.createElement("path", { d: "M12 2L12 4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ w.createElement("path", { d: "M6 12H9", stroke: "white", strokeWidth: 2, strokeLinecap: "round" })), _i = (e) => /* @__PURE__ */ w.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("g", null, /* @__PURE__ */ w.createElement("path", { d: "M9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM12 9.75H9C8.80109 9.75 8.61033 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9V6C8.25 5.80109 8.32902 5.61032 8.46967 5.46967C8.61033 5.32902 8.80109 5.25 9 5.25C9.19892 5.25 9.38968 5.32902 9.53033 5.46967C9.67099 5.61032 9.75 5.80109 9.75 6V8.25H12C12.1989 8.25 12.3897 8.32902 12.5303 8.46967C12.671 8.61032 12.75 8.80109 12.75 9C12.75 9.19891 12.671 9.38968 12.5303 9.53033C12.3897 9.67098 12.1989 9.75 12 9.75Z", fill: "currentColor" }))), p0 = {
  start_end_date_and_time: "start_end_date_and_time",
  start_date_and_time: "start_date_and_time",
  start_date: "start_date",
  start_end_date: "start_end_date",
  free_text: "free_text"
}, $i = ({
  timeZoneAdjustedStart: e,
  timeZoneAdjustedEnd: t,
  dateFormat: n,
  locale: r = "nb-NO",
  text: i,
  tzoneName: a = "Europe/Oslo",
  shouldShowTzoneDay: o = !1,
  shouldShowTimezone: l = !1,
  localTimeLabel: s,
  localTimeMessage: u,
  localTimeEquivalentMessage: d
}) => {
  const c = () => /* @__PURE__ */ m(
    "div",
    {
      className: `${a && l ? "group-hover:ui-flex" : ""} ui-hidden ui-absolute ui-bg-white ui-border ui-border-gray-300 ui-p-3 ui-min-w-[270px] ui-top-[42px] ui-right-[-52px] ui-rounded-md ui-z-10 ui-text-sm mt-1 before:ui-content-[''] before:ui-absolute before:ui-top-[-5px] before:ui-right-[110px] before:ui-rotate-45 before:ui-z-10 before:ui-w-2 before:ui-h-2 before:ui-bg-inherit before:ui-border-t before:ui-border-l before:ui-border-gray-300`,
      children: /* @__PURE__ */ M("div", { children: [
        u,
        /* @__PURE__ */ m("br", {}),
        /* @__PURE__ */ m("span", { style: { color: "grey" }, children: d })
      ] })
    }
  ), h = (f) => /* @__PURE__ */ M("div", { className: "ui-relative ui-group", children: [
    /* @__PURE__ */ M(
      ve,
      {
        hoverable: !!a && l,
        icon: /* @__PURE__ */ m(_i, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
        children: [
          Sr(f, "HH:mm"),
          !!a && l && /* @__PURE__ */ m(
            "span",
            {
              style: {
                marginLeft: "0.25rem",
                fontSize: "0.75rem",
                color: "#8C94A3"
              },
              children: s
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ m(c, {})
  ] });
  return /* @__PURE__ */ M(G.Fragment, { children: [
    n === "start_end_date_and_time" && le(e, r) !== le(t, r) && /* @__PURE__ */ m(G.Fragment, { children: /* @__PURE__ */ M(Pe, { children: [
      /* @__PURE__ */ m(
        ve,
        {
          icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
          children: le(e, r)
        }
      ),
      h(e),
      /* @__PURE__ */ m("div", { style: { display: "flex", alignItems: "center" }, children: "→" }),
      /* @__PURE__ */ m(
        ve,
        {
          icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
          children: le(t, r)
        }
      )
    ] }) }),
    n === "start_end_date_and_time" && le(e, r) === le(t, r) && /* @__PURE__ */ m(G.Fragment, { children: /* @__PURE__ */ M(Pe, { children: [
      /* @__PURE__ */ m(
        ve,
        {
          icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
          children: le(e, r)
        }
      ),
      h(e),
      /* @__PURE__ */ m("div", { style: { display: "flex", alignItems: "center" }, children: "→" }),
      /* @__PURE__ */ m(
        ve,
        {
          icon: /* @__PURE__ */ m(_i, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
          children: Sr(t, "HH:mm")
        }
      )
    ] }) }),
    n === "start_date_and_time" && /* @__PURE__ */ M(Pe, { children: [
      /* @__PURE__ */ m(
        ve,
        {
          icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
          children: le(e, r)
        }
      ),
      h(e)
    ] }),
    n === "start_date" && /* @__PURE__ */ m(Pe, { children: /* @__PURE__ */ M("div", { className: "ui-relative ui-group", children: [
      /* @__PURE__ */ M(
        ve,
        {
          hoverable: !!a && o,
          icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
          children: [
            le(e, r),
            !!a && o && /* @__PURE__ */ m(
              "span",
              {
                style: {
                  marginLeft: "0.25rem",
                  fontSize: "0.75rem",
                  color: "#8C94A3"
                },
                children: s
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ m(c, {})
    ] }) }),
    n === "start_end_date" && le(e, r) !== le(t, r) && /* @__PURE__ */ M(Pe, { children: [
      /* @__PURE__ */ M("div", { className: "ui-relative ui-group", children: [
        /* @__PURE__ */ M(
          ve,
          {
            hoverable: !!a && o,
            icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
            children: [
              le(e, r),
              !!a && o && /* @__PURE__ */ m(
                "span",
                {
                  style: {
                    marginLeft: "0.25rem",
                    fontSize: "0.75rem",
                    color: "#8C94A3"
                  },
                  children: s
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ m(c, {})
      ] }),
      /* @__PURE__ */ m("div", { style: { display: "flex", alignItems: "center" }, children: "→" }),
      /* @__PURE__ */ m(
        ve,
        {
          icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
          children: le(t, r)
        }
      )
    ] }),
    n === "start_end_date" && le(e, r) === le(t, r) && /* @__PURE__ */ m(Pe, { children: /* @__PURE__ */ M("div", { className: "ui-relative ui-group", children: [
      /* @__PURE__ */ M(
        ve,
        {
          hoverable: !!a && o,
          icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
          children: [
            le(e, r),
            !!a && o && /* @__PURE__ */ m(
              "span",
              {
                style: {
                  marginLeft: "0.25rem",
                  fontSize: "0.75rem",
                  color: "#8C94A3"
                },
                children: s
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ m(c, {})
    ] }) }),
    n === "free_text" && /* @__PURE__ */ m(Pe, { children: /* @__PURE__ */ m(
      ve,
      {
        icon: /* @__PURE__ */ m(Ve, { width: 16, height: 16, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[16px]" }),
        children: i
      }
    ) })
  ] });
}, g0 = ({ loadAnimation: e = !1 }) => /* @__PURE__ */ M(Pe, { children: [
  /* @__PURE__ */ m(It, { loadAnimation: e }),
  /* @__PURE__ */ m(It, { loadAnimation: e })
] });
/**
 * @remix-run/router v1.14.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Nr() {
  return Nr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nr.apply(this, arguments);
}
var ea;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(ea || (ea = {}));
function ne(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function At(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Mr(e) {
  let {
    pathname: t = "/",
    search: n = "",
    hash: r = ""
  } = e;
  return n && n !== "?" && (t += n.charAt(0) === "?" ? n : "?" + n), r && r !== "#" && (t += r.charAt(0) === "#" ? r : "#" + r), t;
}
function Fo(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substr(n), e = e.substr(0, n));
    let r = e.indexOf("?");
    r >= 0 && (t.search = e.substr(r), e = e.substr(0, r)), e && (t.pathname = e);
  }
  return t;
}
var ta;
(function(e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(ta || (ta = {}));
function na(e, t) {
  typeof e == "string" && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [n, r] = ld(e.path, e.caseSensitive, e.end), i = t.match(n);
  if (!i)
    return null;
  let a = i[0], o = a.replace(/(.)\/+$/, "$1"), l = i.slice(1);
  return {
    params: r.reduce((u, d, c) => {
      let {
        paramName: h,
        isOptional: f
      } = d;
      if (h === "*") {
        let v = l[c] || "";
        o = a.slice(0, a.length - v.length).replace(/(.)\/+$/, "$1");
      }
      const y = l[c];
      return f && !y ? u[h] = void 0 : u[h] = ud(y || "", h), u;
    }, {}),
    pathname: a,
    pathnameBase: o,
    pattern: e
  };
}
function ld(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !0), At(e === "*" || !e.endsWith("*") || e.endsWith("/*"), 'Route path "' + e + '" will be treated as if it were ' + ('"' + e.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + e.replace(/\*$/, "/*") + '".'));
  let r = [], i = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:(\w+)(\?)?/g, (o, l, s) => (r.push({
    paramName: l,
    isOptional: s != null
  }), s ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return e.endsWith("*") ? (r.push({
    paramName: "*"
  }), i += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? i += "\\/*$" : e !== "" && e !== "/" && (i += "(?:(?=\\/|$))"), [new RegExp(i, t ? void 0 : "i"), r];
}
function ud(e, t) {
  try {
    return decodeURIComponent(e);
  } catch (n) {
    return At(!1, 'The value for the URL param "' + t + '" will not be decoded because' + (' the string "' + e + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + n + ").")), e;
  }
}
function Ut(e, t) {
  if (t === "/")
    return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, r = e.charAt(n);
  return r && r !== "/" ? null : e.slice(n) || "/";
}
function sd(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: n,
    search: r = "",
    hash: i = ""
  } = typeof e == "string" ? Fo(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : cd(n, t) : t,
    search: fd(r),
    hash: hd(i)
  };
}
function cd(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((i) => {
    i === ".." ? n.length > 1 && n.pop() : i !== "." && n.push(i);
  }), n.length > 1 ? n.join("/") : "/";
}
function rr(e, t, n, r) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(r) + "].  Please separate it out to the ") + ("`to." + n + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function dd(e) {
  return e.filter((t, n) => n === 0 || t.route.path && t.route.path.length > 0);
}
function Ro(e, t) {
  let n = dd(e);
  return t ? n.map((r, i) => i === e.length - 1 ? r.pathname : r.pathnameBase) : n.map((r) => r.pathnameBase);
}
function jo(e, t, n, r) {
  r === void 0 && (r = !1);
  let i;
  typeof e == "string" ? i = Fo(e) : (i = Nr({}, e), ne(!i.pathname || !i.pathname.includes("?"), rr("?", "pathname", "search", i)), ne(!i.pathname || !i.pathname.includes("#"), rr("#", "pathname", "hash", i)), ne(!i.search || !i.search.includes("#"), rr("#", "search", "hash", i)));
  let a = e === "" || i.pathname === "", o = a ? "/" : i.pathname, l;
  if (o == null)
    l = n;
  else if (r) {
    let c = t.length === 0 ? [] : t[t.length - 1].replace(/^\//, "").split("/");
    if (o.startsWith("..")) {
      let h = o.split("/");
      for (; h[0] === ".."; )
        h.shift(), c.pop();
      i.pathname = h.join("/");
    }
    l = "/" + c.join("/");
  } else {
    let c = t.length - 1;
    if (o.startsWith("..")) {
      let h = o.split("/");
      for (; h[0] === ".."; )
        h.shift(), c -= 1;
      i.pathname = h.join("/");
    }
    l = c >= 0 ? t[c] : "/";
  }
  let s = sd(i, l), u = o && o !== "/" && o.endsWith("/"), d = (a || o === ".") && n.endsWith("/");
  return !s.pathname.endsWith("/") && (u || d) && (s.pathname += "/"), s;
}
const Kr = (e) => e.join("/").replace(/\/\/+/g, "/"), fd = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, hd = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e, Vo = ["post", "put", "patch", "delete"];
new Set(Vo);
const md = ["get", ...Vo];
new Set(md);
/**
 * React Router v6.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Or() {
  return Or = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Or.apply(this, arguments);
}
const Vn = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (Vn.displayName = "DataRouter");
const Ho = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (Ho.displayName = "DataRouterState");
const pd = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (pd.displayName = "Await");
const Ue = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (Ue.displayName = "Navigation");
const _r = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (_r.displayName = "Location");
const kt = /* @__PURE__ */ w.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (kt.displayName = "Route");
const gd = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (gd.displayName = "RouteError");
function yd(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t;
  $r() || (process.env.NODE_ENV !== "production" ? ne(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : ne(!1));
  let {
    basename: r,
    navigator: i
  } = w.useContext(Ue), {
    hash: a,
    pathname: o,
    search: l
  } = rn(e, {
    relative: n
  }), s = o;
  return r !== "/" && (s = o === "/" ? r : Kr([r, o])), i.createHref({
    pathname: s,
    search: l,
    hash: a
  });
}
function $r() {
  return w.useContext(_r) != null;
}
function nn() {
  return $r() || (process.env.NODE_ENV !== "production" ? ne(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : ne(!1)), w.useContext(_r).location;
}
const Qo = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function Uo(e) {
  w.useContext(Ue).static || w.useLayoutEffect(e);
}
function bd() {
  let {
    isDataRoute: e
  } = w.useContext(kt);
  return e ? kd() : vd();
}
function vd() {
  $r() || (process.env.NODE_ENV !== "production" ? ne(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : ne(!1));
  let e = w.useContext(Vn), {
    basename: t,
    future: n,
    navigator: r
  } = w.useContext(Ue), {
    matches: i
  } = w.useContext(kt), {
    pathname: a
  } = nn(), o = JSON.stringify(Ro(i, n.v7_relativeSplatPath)), l = w.useRef(!1);
  return Uo(() => {
    l.current = !0;
  }), w.useCallback(function(u, d) {
    if (d === void 0 && (d = {}), process.env.NODE_ENV !== "production" && At(l.current, Qo), !l.current)
      return;
    if (typeof u == "number") {
      r.go(u);
      return;
    }
    let c = jo(u, JSON.parse(o), a, d.relative === "path");
    e == null && t !== "/" && (c.pathname = c.pathname === "/" ? t : Kr([t, c.pathname])), (d.replace ? r.replace : r.push)(c, d.state, d);
  }, [t, r, o, a, e]);
}
function rn(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    future: r
  } = w.useContext(Ue), {
    matches: i
  } = w.useContext(kt), {
    pathname: a
  } = nn(), o = JSON.stringify(Ro(i, r.v7_relativeSplatPath));
  return w.useMemo(() => jo(e, JSON.parse(o), a, n === "path"), [e, o, a, n]);
}
var Wo = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
}(Wo || {}), ei = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
}(ei || {});
function qo(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function wd(e) {
  let t = w.useContext(Vn);
  return t || (process.env.NODE_ENV !== "production" ? ne(!1, qo(e)) : ne(!1)), t;
}
function xd(e) {
  let t = w.useContext(kt);
  return t || (process.env.NODE_ENV !== "production" ? ne(!1, qo(e)) : ne(!1)), t;
}
function Yo(e) {
  let t = xd(e), n = t.matches[t.matches.length - 1];
  return n.route.id || (process.env.NODE_ENV !== "production" ? ne(!1, e + ' can only be used on routes that contain a unique "id"') : ne(!1)), n.route.id;
}
function Ad() {
  return Yo(ei.UseRouteId);
}
function kd() {
  let {
    router: e
  } = wd(Wo.UseNavigateStable), t = Yo(ei.UseNavigateStable), n = w.useRef(!1);
  return Uo(() => {
    n.current = !0;
  }), w.useCallback(function(i, a) {
    a === void 0 && (a = {}), process.env.NODE_ENV !== "production" && At(n.current, Qo), n.current && (typeof i == "number" ? e.navigate(i) : e.navigate(i, Or({
      fromRouteId: t
    }, a)));
  }, [e, t]);
}
new Promise(() => {
});
/**
 * React Router DOM v6.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function vt() {
  return vt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vt.apply(this, arguments);
}
function ti(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
const bn = "get", vn = "application/x-www-form-urlencoded";
function Hn(e) {
  return e != null && typeof e.tagName == "string";
}
function Cd(e) {
  return Hn(e) && e.tagName.toLowerCase() === "button";
}
function Ed(e) {
  return Hn(e) && e.tagName.toLowerCase() === "form";
}
function Sd(e) {
  return Hn(e) && e.tagName.toLowerCase() === "input";
}
function Nd(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Md(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !Nd(e);
}
let dn = null;
function Od() {
  if (dn === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), dn = !1;
    } catch {
      dn = !0;
    }
  return dn;
}
const Td = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function ir(e) {
  return e != null && !Td.has(e) ? (process.env.NODE_ENV !== "production" && At(!1, '"' + e + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + vn + '"')), null) : e;
}
function Pd(e, t) {
  let n, r, i, a, o;
  if (Ed(e)) {
    let l = e.getAttribute("action");
    r = l ? Ut(l, t) : null, n = e.getAttribute("method") || bn, i = ir(e.getAttribute("enctype")) || vn, a = new FormData(e);
  } else if (Cd(e) || Sd(e) && (e.type === "submit" || e.type === "image")) {
    let l = e.form;
    if (l == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let s = e.getAttribute("formaction") || l.getAttribute("action");
    if (r = s ? Ut(s, t) : null, n = e.getAttribute("formmethod") || l.getAttribute("method") || bn, i = ir(e.getAttribute("formenctype")) || ir(l.getAttribute("enctype")) || vn, a = new FormData(l, e), !Od()) {
      let {
        name: u,
        type: d,
        value: c
      } = e;
      if (d === "image") {
        let h = u ? u + "." : "";
        a.append(h + "x", "0"), a.append(h + "y", "0");
      } else
        u && a.append(u, c);
    }
  } else {
    if (Hn(e))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    n = bn, r = null, i = vn, o = e;
  }
  return a && i === "text/plain" && (o = a, a = void 0), {
    action: r,
    method: n.toLowerCase(),
    encType: i,
    formData: a,
    body: o
  };
}
const Dd = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"], zd = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"], Bd = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"], Zo = /* @__PURE__ */ w.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (Zo.displayName = "ViewTransition");
const Ld = /* @__PURE__ */ w.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (Ld.displayName = "Fetchers");
process.env.NODE_ENV;
const Id = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Fd = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, ni = /* @__PURE__ */ w.forwardRef(function(t, n) {
  let {
    onClick: r,
    relative: i,
    reloadDocument: a,
    replace: o,
    state: l,
    target: s,
    to: u,
    preventScrollReset: d,
    unstable_viewTransition: c
  } = t, h = ti(t, Dd), {
    basename: f
  } = w.useContext(Ue), y, v = !1;
  if (typeof u == "string" && Fd.test(u) && (y = u, Id))
    try {
      let x = new URL(window.location.href), T = u.startsWith("//") ? new URL(x.protocol + u) : new URL(u), N = Ut(T.pathname, f);
      T.origin === x.origin && N != null ? u = N + T.search + T.hash : v = !0;
    } catch {
      process.env.NODE_ENV !== "production" && At(!1, '<Link to="' + u + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let C = yd(u, {
    relative: i
  }), b = Hd(u, {
    replace: o,
    state: l,
    target: s,
    preventScrollReset: d,
    relative: i,
    unstable_viewTransition: c
  });
  function A(x) {
    r && r(x), x.defaultPrevented || b(x);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ w.createElement("a", vt({}, h, {
      href: y || C,
      onClick: v || a ? r : A,
      ref: n,
      target: s
    }))
  );
});
process.env.NODE_ENV !== "production" && (ni.displayName = "Link");
const Rd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  let {
    "aria-current": r = "page",
    caseSensitive: i = !1,
    className: a = "",
    end: o = !1,
    style: l,
    to: s,
    unstable_viewTransition: u,
    children: d
  } = t, c = ti(t, zd), h = rn(s, {
    relative: c.relative
  }), f = nn(), y = w.useContext(Ho), {
    navigator: v
  } = w.useContext(Ue), C = y != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  Zd(h) && u === !0, b = v.encodeLocation ? v.encodeLocation(h).pathname : h.pathname, A = f.pathname, x = y && y.navigation && y.navigation.location ? y.navigation.location.pathname : null;
  i || (A = A.toLowerCase(), x = x ? x.toLowerCase() : null, b = b.toLowerCase());
  const T = b !== "/" && b.endsWith("/") ? b.length - 1 : b.length;
  let N = A === b || !o && A.startsWith(b) && A.charAt(T) === "/", k = x != null && (x === b || !o && x.startsWith(b) && x.charAt(b.length) === "/"), B = {
    isActive: N,
    isPending: k,
    isTransitioning: C
  }, U = N ? r : void 0, I;
  typeof a == "function" ? I = a(B) : I = [a, N ? "active" : null, k ? "pending" : null, C ? "transitioning" : null].filter(Boolean).join(" ");
  let R = typeof l == "function" ? l(B) : l;
  return /* @__PURE__ */ w.createElement(ni, vt({}, c, {
    "aria-current": U,
    className: I,
    ref: n,
    style: R,
    to: s,
    unstable_viewTransition: u
  }), typeof d == "function" ? d(B) : d);
});
process.env.NODE_ENV !== "production" && (Rd.displayName = "NavLink");
const jd = /* @__PURE__ */ w.forwardRef((e, t) => {
  let {
    fetcherKey: n,
    navigate: r,
    reloadDocument: i,
    replace: a,
    state: o,
    method: l = bn,
    action: s,
    onSubmit: u,
    relative: d,
    preventScrollReset: c,
    unstable_viewTransition: h
  } = e, f = ti(e, Bd), y = qd(), v = Yd(s, {
    relative: d
  }), C = l.toLowerCase() === "get" ? "get" : "post", b = (A) => {
    if (u && u(A), A.defaultPrevented)
      return;
    A.preventDefault();
    let x = A.nativeEvent.submitter, T = (x == null ? void 0 : x.getAttribute("formmethod")) || l;
    y(x || A.currentTarget, {
      fetcherKey: n,
      method: T,
      navigate: r,
      replace: a,
      state: o,
      relative: d,
      preventScrollReset: c,
      unstable_viewTransition: h
    });
  };
  return /* @__PURE__ */ w.createElement("form", vt({
    ref: t,
    method: C,
    action: v,
    onSubmit: i ? u : b
  }, f));
});
process.env.NODE_ENV !== "production" && (jd.displayName = "Form");
process.env.NODE_ENV;
var On;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(On || (On = {}));
var ra;
(function(e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(ra || (ra = {}));
function Vd(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function Go(e) {
  let t = w.useContext(Vn);
  return t || (process.env.NODE_ENV !== "production" ? ne(!1, Vd(e)) : ne(!1)), t;
}
function Hd(e, t) {
  let {
    target: n,
    replace: r,
    state: i,
    preventScrollReset: a,
    relative: o,
    unstable_viewTransition: l
  } = t === void 0 ? {} : t, s = bd(), u = nn(), d = rn(e, {
    relative: o
  });
  return w.useCallback((c) => {
    if (Md(c, n)) {
      c.preventDefault();
      let h = r !== void 0 ? r : Mr(u) === Mr(d);
      s(e, {
        replace: h,
        state: i,
        preventScrollReset: a,
        relative: o,
        unstable_viewTransition: l
      });
    }
  }, [u, s, d, r, i, n, e, a, o, l]);
}
function Qd() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let Ud = 0, Wd = () => "__" + String(++Ud) + "__";
function qd() {
  let {
    router: e
  } = Go(On.UseSubmit), {
    basename: t
  } = w.useContext(Ue), n = Ad();
  return w.useCallback(function(r, i) {
    i === void 0 && (i = {}), Qd();
    let {
      action: a,
      method: o,
      encType: l,
      formData: s,
      body: u
    } = Pd(r, t);
    if (i.navigate === !1) {
      let d = i.fetcherKey || Wd();
      e.fetch(d, n, i.action || a, {
        preventScrollReset: i.preventScrollReset,
        formData: s,
        body: u,
        formMethod: i.method || o,
        formEncType: i.encType || l,
        unstable_flushSync: i.unstable_flushSync
      });
    } else
      e.navigate(i.action || a, {
        preventScrollReset: i.preventScrollReset,
        formData: s,
        body: u,
        formMethod: i.method || o,
        formEncType: i.encType || l,
        replace: i.replace,
        state: i.state,
        fromRouteId: n,
        unstable_flushSync: i.unstable_flushSync,
        unstable_viewTransition: i.unstable_viewTransition
      });
  }, [e, t, n]);
}
function Yd(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    basename: r
  } = w.useContext(Ue), i = w.useContext(kt);
  i || (process.env.NODE_ENV !== "production" ? ne(!1, "useFormAction must be used inside a RouteContext") : ne(!1));
  let [a] = i.matches.slice(-1), o = vt({}, rn(e || ".", {
    relative: n
  })), l = nn();
  if (e == null) {
    o.search = l.search;
    let s = new URLSearchParams(o.search);
    s.has("index") && s.get("index") === "" && (s.delete("index"), o.search = s.toString() ? "?" + s.toString() : "");
  }
  return (!e || e === ".") && a.route.index && (o.search = o.search ? o.search.replace(/^\?/, "?index&") : "?index"), r !== "/" && (o.pathname = o.pathname === "/" ? r : Kr([r, o.pathname])), Mr(o);
}
function Zd(e, t) {
  t === void 0 && (t = {});
  let n = w.useContext(Zo);
  n == null && (process.env.NODE_ENV !== "production" ? ne(!1, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : ne(!1));
  let {
    basename: r
  } = Go(On.useViewTransitionState), i = rn(e, {
    relative: t.relative
  });
  if (!n.isTransitioning)
    return !1;
  let a = Ut(n.currentLocation.pathname, r) || n.currentLocation.pathname, o = Ut(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return na(i.pathname, o) != null || na(i.pathname, a) != null;
}
var Gd = Object.defineProperty, Jd = (e, t) => {
  for (var n in t)
    Gd(e, n, { get: t[n], enumerable: !0 });
}, Oe = {};
Jd(Oe, {
  assign: () => _d,
  colors: () => Xe,
  createStringInterpolator: () => si,
  skipAnimation: () => tl,
  to: () => el,
  willAdvance: () => ci
});
var ri = on(), V = (e) => an(e, ri), ii = on();
V.write = (e) => an(e, ii);
var Qn = on();
V.onStart = (e) => an(e, Qn);
var ai = on();
V.onFrame = (e) => an(e, ai);
var oi = on();
V.onFinish = (e) => an(e, oi);
var mt = [];
V.setTimeout = (e, t) => {
  const n = V.now() + t, r = () => {
    const a = mt.findIndex((o) => o.cancel == r);
    ~a && mt.splice(a, 1), Je -= ~a ? 1 : 0;
  }, i = { time: n, handler: e, cancel: r };
  return mt.splice(Jo(n), 0, i), Je += 1, Xo(), i;
};
var Jo = (e) => ~(~mt.findIndex((t) => t.time > e) || ~mt.length);
V.cancel = (e) => {
  Qn.delete(e), ai.delete(e), oi.delete(e), ri.delete(e), ii.delete(e);
};
V.sync = (e) => {
  Tr = !0, V.batchedUpdates(e), Tr = !1;
};
V.throttle = (e) => {
  let t;
  function n() {
    try {
      e(...t);
    } finally {
      t = null;
    }
  }
  function r(...i) {
    t = i, V.onStart(n);
  }
  return r.handler = e, r.cancel = () => {
    Qn.delete(n), t = null;
  }, r;
};
var li = typeof window < "u" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
V.use = (e) => li = e;
V.now = typeof performance < "u" ? () => performance.now() : Date.now;
V.batchedUpdates = (e) => e();
V.catch = console.error;
V.frameLoop = "always";
V.advance = () => {
  V.frameLoop !== "demand" ? console.warn(
    "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
  ) : _o();
};
var Ge = -1, Je = 0, Tr = !1;
function an(e, t) {
  Tr ? (t.delete(e), e(0)) : (t.add(e), Xo());
}
function Xo() {
  Ge < 0 && (Ge = 0, V.frameLoop !== "demand" && li(Ko));
}
function Xd() {
  Ge = -1;
}
function Ko() {
  ~Ge && (li(Ko), V.batchedUpdates(_o));
}
function _o() {
  const e = Ge;
  Ge = V.now();
  const t = Jo(Ge);
  if (t && ($o(mt.splice(0, t), (n) => n.handler()), Je -= t), !Je) {
    Xd();
    return;
  }
  Qn.flush(), ri.flush(e ? Math.min(64, Ge - e) : 16.667), ai.flush(), ii.flush(), oi.flush();
}
function on() {
  let e = /* @__PURE__ */ new Set(), t = e;
  return {
    add(n) {
      Je += t == e && !e.has(n) ? 1 : 0, e.add(n);
    },
    delete(n) {
      return Je -= t == e && e.has(n) ? 1 : 0, e.delete(n);
    },
    flush(n) {
      t.size && (e = /* @__PURE__ */ new Set(), Je -= t.size, $o(t, (r) => r(n) && e.add(r)), Je += e.size, t = e);
    }
  };
}
function $o(e, t) {
  e.forEach((n) => {
    try {
      t(n);
    } catch (r) {
      V.catch(r);
    }
  });
}
function Pr() {
}
var Kd = (e, t, n) => Object.defineProperty(e, t, { value: n, writable: !0, configurable: !0 }), O = {
  arr: Array.isArray,
  obj: (e) => !!e && e.constructor.name === "Object",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  und: (e) => e === void 0
};
function He(e, t) {
  if (O.arr(e)) {
    if (!O.arr(t) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  }
  return e === t;
}
var q = (e, t) => e.forEach(t);
function Ie(e, t, n) {
  if (O.arr(e)) {
    for (let r = 0; r < e.length; r++)
      t.call(n, e[r], `${r}`);
    return;
  }
  for (const r in e)
    e.hasOwnProperty(r) && t.call(n, e[r], r);
}
var ye = (e) => O.und(e) ? [] : O.arr(e) ? e : [e];
function Ft(e, t) {
  if (e.size) {
    const n = Array.from(e);
    e.clear(), q(n, t);
  }
}
var Lt = (e, ...t) => Ft(e, (n) => n(...t)), ui = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), si, el, Xe = null, tl = !1, ci = Pr, _d = (e) => {
  e.to && (el = e.to), e.now && (V.now = e.now), e.colors !== void 0 && (Xe = e.colors), e.skipAnimation != null && (tl = e.skipAnimation), e.createStringInterpolator && (si = e.createStringInterpolator), e.requestAnimationFrame && V.use(e.requestAnimationFrame), e.batchedUpdates && (V.batchedUpdates = e.batchedUpdates), e.willAdvance && (ci = e.willAdvance), e.frameLoop && (V.frameLoop = e.frameLoop);
}, Rt = /* @__PURE__ */ new Set(), Ae = [], ar = [], Tn = 0, Un = {
  get idle() {
    return !Rt.size && !Ae.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(e) {
    Tn > e.priority ? (Rt.add(e), V.onStart($d)) : (nl(e), V(Dr));
  },
  /** Advance all animations by the given time. */
  advance: Dr,
  /** Call this when an animation's priority changes. */
  sort(e) {
    if (Tn)
      V.onFrame(() => Un.sort(e));
    else {
      const t = Ae.indexOf(e);
      ~t && (Ae.splice(t, 1), rl(e));
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    Ae = [], Rt.clear();
  }
};
function $d() {
  Rt.forEach(nl), Rt.clear(), V(Dr);
}
function nl(e) {
  Ae.includes(e) || rl(e);
}
function rl(e) {
  Ae.splice(
    ef(Ae, (t) => t.priority > e.priority),
    0,
    e
  );
}
function Dr(e) {
  const t = ar;
  for (let n = 0; n < Ae.length; n++) {
    const r = Ae[n];
    Tn = r.priority, r.idle || (ci(r), r.advance(e), r.idle || t.push(r));
  }
  return Tn = 0, ar = Ae, ar.length = 0, Ae = t, Ae.length > 0;
}
function ef(e, t) {
  const n = e.findIndex(t);
  return n < 0 ? e.length : n;
}
var tf = (e, t, n) => Math.min(Math.max(n, e), t), nf = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
}, Me = "[-+]?\\d*\\.?\\d+", Pn = Me + "%";
function Wn(...e) {
  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rf = new RegExp("rgb" + Wn(Me, Me, Me)), af = new RegExp("rgba" + Wn(Me, Me, Me, Me)), of = new RegExp("hsl" + Wn(Me, Pn, Pn)), lf = new RegExp(
  "hsla" + Wn(Me, Pn, Pn, Me)
), uf = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, sf = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, cf = /^#([0-9a-fA-F]{6})$/, df = /^#([0-9a-fA-F]{8})$/;
function ff(e) {
  let t;
  return typeof e == "number" ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = cf.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : Xe && Xe[e] !== void 0 ? Xe[e] : (t = rf.exec(e)) ? (dt(t[1]) << 24 | // r
  dt(t[2]) << 16 | // g
  dt(t[3]) << 8 | // b
  255) >>> // a
  0 : (t = af.exec(e)) ? (dt(t[1]) << 24 | // r
  dt(t[2]) << 16 | // g
  dt(t[3]) << 8 | // b
  oa(t[4])) >>> // a
  0 : (t = uf.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    "ff",
    // a
    16
  ) >>> 0 : (t = df.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = sf.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    t[4] + t[4],
    // a
    16
  ) >>> 0 : (t = of.exec(e)) ? (ia(
    aa(t[1]),
    // h
    fn(t[2]),
    // s
    fn(t[3])
    // l
  ) | 255) >>> // a
  0 : (t = lf.exec(e)) ? (ia(
    aa(t[1]),
    // h
    fn(t[2]),
    // s
    fn(t[3])
    // l
  ) | oa(t[4])) >>> // a
  0 : null;
}
function or(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function ia(e, t, n) {
  const r = n < 0.5 ? n * (1 + t) : n + t - n * t, i = 2 * n - r, a = or(i, r, e + 1 / 3), o = or(i, r, e), l = or(i, r, e - 1 / 3);
  return Math.round(a * 255) << 24 | Math.round(o * 255) << 16 | Math.round(l * 255) << 8;
}
function dt(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function aa(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function oa(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(t * 255);
}
function fn(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function la(e) {
  let t = ff(e);
  if (t === null)
    return e;
  t = t || 0;
  const n = (t & 4278190080) >>> 24, r = (t & 16711680) >>> 16, i = (t & 65280) >>> 8, a = (t & 255) / 255;
  return `rgba(${n}, ${r}, ${i}, ${a})`;
}
var Wt = (e, t, n) => {
  if (O.fun(e))
    return e;
  if (O.arr(e))
    return Wt({
      range: e,
      output: t,
      extrapolate: n
    });
  if (O.str(e.output[0]))
    return si(e);
  const r = e, i = r.output, a = r.range || [0, 1], o = r.extrapolateLeft || r.extrapolate || "extend", l = r.extrapolateRight || r.extrapolate || "extend", s = r.easing || ((u) => u);
  return (u) => {
    const d = mf(u, a);
    return hf(
      u,
      a[d],
      a[d + 1],
      i[d],
      i[d + 1],
      s,
      o,
      l,
      r.map
    );
  };
};
function hf(e, t, n, r, i, a, o, l, s) {
  let u = s ? s(e) : e;
  if (u < t) {
    if (o === "identity")
      return u;
    o === "clamp" && (u = t);
  }
  if (u > n) {
    if (l === "identity")
      return u;
    l === "clamp" && (u = n);
  }
  return r === i ? r : t === n ? e <= t ? r : i : (t === -1 / 0 ? u = -u : n === 1 / 0 ? u = u - t : u = (u - t) / (n - t), u = a(u), r === -1 / 0 ? u = -u : i === 1 / 0 ? u = u + r : u = u * (i - r) + r, u);
}
function mf(e, t) {
  for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n)
    ;
  return n - 1;
}
var pf = (e, t = "end") => (n) => {
  n = t === "end" ? Math.min(n, 0.999) : Math.max(n, 1e-3);
  const r = n * e, i = t === "end" ? Math.floor(r) : Math.ceil(r);
  return tf(0, 1, i / e);
}, Dn = 1.70158, hn = Dn * 1.525, ua = Dn + 1, sa = 2 * Math.PI / 3, ca = 2 * Math.PI / 4.5, mn = (e) => e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375, gf = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => 1 - (1 - e) * (1 - e),
  easeInOutQuad: (e) => e < 0.5 ? 2 * e * e : 1 - Math.pow(-2 * e + 2, 2) / 2,
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => 1 - Math.pow(1 - e, 3),
  easeInOutCubic: (e) => e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2,
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => 1 - Math.pow(1 - e, 4),
  easeInOutQuart: (e) => e < 0.5 ? 8 * e * e * e * e : 1 - Math.pow(-2 * e + 2, 4) / 2,
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => 1 - Math.pow(1 - e, 5),
  easeInOutQuint: (e) => e < 0.5 ? 16 * e * e * e * e * e : 1 - Math.pow(-2 * e + 2, 5) / 2,
  easeInSine: (e) => 1 - Math.cos(e * Math.PI / 2),
  easeOutSine: (e) => Math.sin(e * Math.PI / 2),
  easeInOutSine: (e) => -(Math.cos(Math.PI * e) - 1) / 2,
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * e - 10),
  easeOutExpo: (e) => e === 1 ? 1 : 1 - Math.pow(2, -10 * e),
  easeInOutExpo: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? Math.pow(2, 20 * e - 10) / 2 : (2 - Math.pow(2, -20 * e + 10)) / 2,
  easeInCirc: (e) => 1 - Math.sqrt(1 - Math.pow(e, 2)),
  easeOutCirc: (e) => Math.sqrt(1 - Math.pow(e - 1, 2)),
  easeInOutCirc: (e) => e < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * e, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * e + 2, 2)) + 1) / 2,
  easeInBack: (e) => ua * e * e * e - Dn * e * e,
  easeOutBack: (e) => 1 + ua * Math.pow(e - 1, 3) + Dn * Math.pow(e - 1, 2),
  easeInOutBack: (e) => e < 0.5 ? Math.pow(2 * e, 2) * ((hn + 1) * 2 * e - hn) / 2 : (Math.pow(2 * e - 2, 2) * ((hn + 1) * (e * 2 - 2) + hn) + 2) / 2,
  easeInElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : -Math.pow(2, 10 * e - 10) * Math.sin((e * 10 - 10.75) * sa),
  easeOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : Math.pow(2, -10 * e) * Math.sin((e * 10 - 0.75) * sa) + 1,
  easeInOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? -(Math.pow(2, 20 * e - 10) * Math.sin((20 * e - 11.125) * ca)) / 2 : Math.pow(2, -20 * e + 10) * Math.sin((20 * e - 11.125) * ca) / 2 + 1,
  easeInBounce: (e) => 1 - mn(1 - e),
  easeOutBounce: mn,
  easeInOutBounce: (e) => e < 0.5 ? (1 - mn(1 - 2 * e)) / 2 : (1 + mn(2 * e - 1)) / 2,
  steps: pf
}, qt = Symbol.for("FluidValue.get"), wt = Symbol.for("FluidValue.observers"), we = (e) => !!(e && e[qt]), de = (e) => e && e[qt] ? e[qt]() : e, da = (e) => e[wt] || null;
function yf(e, t) {
  e.eventObserved ? e.eventObserved(t) : e(t);
}
function Yt(e, t) {
  const n = e[wt];
  n && n.forEach((r) => {
    yf(r, t);
  });
}
var il = class {
  constructor(e) {
    if (!e && !(e = this.get))
      throw Error("Unknown getter");
    bf(this, e);
  }
}, bf = (e, t) => al(e, qt, t);
function Ct(e, t) {
  if (e[qt]) {
    let n = e[wt];
    n || al(e, wt, n = /* @__PURE__ */ new Set()), n.has(t) || (n.add(t), e.observerAdded && e.observerAdded(n.size, t));
  }
  return t;
}
function Zt(e, t) {
  const n = e[wt];
  if (n && n.has(t)) {
    const r = n.size - 1;
    r ? n.delete(t) : e[wt] = null, e.observerRemoved && e.observerRemoved(r, t);
  }
}
var al = (e, t, n) => Object.defineProperty(e, t, {
  value: n,
  writable: !0,
  configurable: !0
}), wn = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, vf = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, fa = new RegExp(`(${wn.source})(%|[a-z]+)`, "i"), wf = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, qn = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, ol = (e) => {
  const [t, n] = xf(e);
  if (!t || ui())
    return e;
  const r = window.getComputedStyle(document.documentElement).getPropertyValue(t);
  if (r)
    return r.trim();
  if (n && n.startsWith("--")) {
    const i = window.getComputedStyle(document.documentElement).getPropertyValue(n);
    return i || e;
  } else {
    if (n && qn.test(n))
      return ol(n);
    if (n)
      return n;
  }
  return e;
}, xf = (e) => {
  const t = qn.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}, lr, Af = (e, t, n, r, i) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${i})`, ll = (e) => {
  lr || (lr = Xe ? (
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(Xe).join("|")})(?!\\w)`, "g")
  ) : (
    // never match
    /^\b$/
  ));
  const t = e.output.map((a) => de(a).replace(qn, ol).replace(vf, la).replace(lr, la)), n = t.map((a) => a.match(wn).map(Number)), i = n[0].map(
    (a, o) => n.map((l) => {
      if (!(o in l))
        throw Error('The arity of each "output" value must be equal');
      return l[o];
    })
  ).map(
    (a) => Wt({ ...e, output: a })
  );
  return (a) => {
    var s;
    const o = !fa.test(t[0]) && ((s = t.find((u) => fa.test(u))) == null ? void 0 : s.replace(wn, ""));
    let l = 0;
    return t[0].replace(
      wn,
      () => `${i[l++](a)}${o || ""}`
    ).replace(wf, Af);
  };
}, di = "react-spring: ", ul = (e) => {
  const t = e;
  let n = !1;
  if (typeof t != "function")
    throw new TypeError(`${di}once requires a function parameter`);
  return (...r) => {
    n || (t(...r), n = !0);
  };
}, kf = ul(console.warn);
function Cf() {
  kf(
    `${di}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var Ef = ul(console.warn);
function Sf() {
  Ef(
    `${di}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function Yn(e) {
  return O.str(e) && (e[0] == "#" || /\d/.test(e) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !ui() && qn.test(e) || e in (Xe || {}));
}
var fi = ui() ? xt : Au, Nf = () => {
  const e = ge(!1);
  return fi(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
};
function sl() {
  const e = Jr()[1], t = Nf();
  return () => {
    t.current && e(Math.random());
  };
}
function Mf(e, t) {
  const [n] = Jr(
    () => ({
      inputs: t,
      result: e()
    })
  ), r = ge(), i = r.current;
  let a = i;
  return a ? t && a.inputs && Of(t, a.inputs) || (a = {
    inputs: t,
    result: e()
  }) : a = n, xt(() => {
    r.current = a, i == n && (n.inputs = n.result = void 0);
  }, [a]), a.result;
}
function Of(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var cl = (e) => xt(e, Tf), Tf = [];
function ha(e) {
  const t = ge();
  return xt(() => {
    t.current = e;
  }), t.current;
}
var Gt = Symbol.for("Animated:node"), Pf = (e) => !!e && e[Gt] === e, De = (e) => e && e[Gt], hi = (e, t) => Kd(e, Gt, t), Zn = (e) => e && e[Gt] && e[Gt].getPayload(), dl = class {
  constructor() {
    hi(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
}, ln = class extends dl {
  constructor(e) {
    super(), this._value = e, this.done = !0, this.durationProgress = 0, O.num(this._value) && (this.lastPosition = this._value);
  }
  /** @internal */
  static create(e) {
    return new ln(e);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(e, t) {
    return O.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value === e ? !1 : (this._value = e, !0);
  }
  reset() {
    const { done: e } = this;
    this.done = !1, O.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
  }
}, Jt = class extends ln {
  constructor(e) {
    super(0), this._string = null, this._toString = Wt({
      output: [e, e]
    });
  }
  /** @internal */
  static create(e) {
    return new Jt(e);
  }
  getValue() {
    const e = this._string;
    return e ?? (this._string = this._toString(this._value));
  }
  setValue(e) {
    if (O.str(e)) {
      if (e == this._string)
        return !1;
      this._string = e, this._value = 1;
    } else if (super.setValue(e))
      this._string = null;
    else
      return !1;
    return !0;
  }
  reset(e) {
    e && (this._toString = Wt({
      output: [this.getValue(), e]
    })), this._value = 0, super.reset();
  }
}, zn = { dependencies: null }, Gn = class extends dl {
  constructor(e) {
    super(), this.source = e, this.setValue(e);
  }
  getValue(e) {
    const t = {};
    return Ie(this.source, (n, r) => {
      Pf(n) ? t[r] = n.getValue(e) : we(n) ? t[r] = de(n) : e || (t[r] = n);
    }), t;
  }
  /** Replace the raw object data */
  setValue(e) {
    this.source = e, this.payload = this._makePayload(e);
  }
  reset() {
    this.payload && q(this.payload, (e) => e.reset());
  }
  /** Create a payload set. */
  _makePayload(e) {
    if (e) {
      const t = /* @__PURE__ */ new Set();
      return Ie(e, this._addToPayload, t), Array.from(t);
    }
  }
  /** Add to a payload set. */
  _addToPayload(e) {
    zn.dependencies && we(e) && zn.dependencies.add(e);
    const t = Zn(e);
    t && q(t, (n) => this.add(n));
  }
}, fl = class extends Gn {
  constructor(e) {
    super(e);
  }
  /** @internal */
  static create(e) {
    return new fl(e);
  }
  getValue() {
    return this.source.map((e) => e.getValue());
  }
  setValue(e) {
    const t = this.getPayload();
    return e.length == t.length ? t.map((n, r) => n.setValue(e[r])).some(Boolean) : (super.setValue(e.map(Df)), !0);
  }
};
function Df(e) {
  return (Yn(e) ? Jt : ln).create(e);
}
function zr(e) {
  const t = De(e);
  return t ? t.constructor : O.arr(e) ? fl : Yn(e) ? Jt : ln;
}
var ma = (e, t) => {
  const n = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !O.fun(e) || e.prototype && e.prototype.isReactComponent
  );
  return ku((r, i) => {
    const a = ge(null), o = n && // eslint-disable-next-line react-hooks/rules-of-hooks
    Ar(
      (y) => {
        a.current = Lf(i, y);
      },
      [i]
    ), [l, s] = Bf(r, t), u = sl(), d = () => {
      const y = a.current;
      if (n && !y)
        return;
      (y ? t.applyAnimatedValues(y, l.getValue(!0)) : !1) === !1 && u();
    }, c = new zf(d, s), h = ge();
    fi(() => (h.current = c, q(s, (y) => Ct(y, c)), () => {
      h.current && (q(
        h.current.deps,
        (y) => Zt(y, h.current)
      ), V.cancel(h.current.update));
    })), xt(d, []), cl(() => () => {
      const y = h.current;
      q(y.deps, (v) => Zt(v, y));
    });
    const f = t.getComponentProps(l.getValue());
    return /* @__PURE__ */ w.createElement(e, { ...f, ref: o });
  });
}, zf = class {
  constructor(e, t) {
    this.update = e, this.deps = t;
  }
  eventObserved(e) {
    e.type == "change" && V.write(this.update);
  }
};
function Bf(e, t) {
  const n = /* @__PURE__ */ new Set();
  return zn.dependencies = n, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new Gn(e), zn.dependencies = null, [e, n];
}
function Lf(e, t) {
  return e && (O.fun(e) ? e(t) : e.current = t), t;
}
var pa = Symbol.for("AnimatedComponent"), If = (e, {
  applyAnimatedValues: t = () => !1,
  createAnimatedStyle: n = (i) => new Gn(i),
  getComponentProps: r = (i) => i
} = {}) => {
  const i = {
    applyAnimatedValues: t,
    createAnimatedStyle: n,
    getComponentProps: r
  }, a = (o) => {
    const l = ga(o) || "Anonymous";
    return O.str(o) ? o = a[o] || (a[o] = ma(o, i)) : o = o[pa] || (o[pa] = ma(o, i)), o.displayName = `Animated(${l})`, o;
  };
  return Ie(e, (o, l) => {
    O.arr(e) && (l = ga(o)), a[l] = a(o);
  }), {
    animated: a
  };
}, ga = (e) => O.str(e) ? e : e && O.str(e.displayName) ? e.displayName : O.fun(e) && e.name || null;
function nt(e, ...t) {
  return O.fun(e) ? e(...t) : e;
}
var jt = (e, t) => e === !0 || !!(t && e && (O.fun(e) ? e(t) : ye(e).includes(t))), hl = (e, t) => O.obj(e) ? t && e[t] : e, ml = (e, t) => e.default === !0 ? e[t] : e.default ? e.default[t] : void 0, Ff = (e) => e, mi = (e, t = Ff) => {
  let n = Rf;
  e.default && e.default !== !0 && (e = e.default, n = Object.keys(e));
  const r = {};
  for (const i of n) {
    const a = t(e[i], i);
    O.und(a) || (r[i] = a);
  }
  return r;
}, Rf = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
], jf = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function Vf(e) {
  const t = {};
  let n = 0;
  if (Ie(e, (r, i) => {
    jf[i] || (t[i] = r, n++);
  }), n)
    return t;
}
function pl(e) {
  const t = Vf(e);
  if (t) {
    const n = { to: t };
    return Ie(e, (r, i) => i in t || (n[i] = r)), n;
  }
  return { ...e };
}
function Xt(e) {
  return e = de(e), O.arr(e) ? e.map(Xt) : Yn(e) ? Oe.createStringInterpolator({
    range: [0, 1],
    output: [e, e]
  })(1) : e;
}
function Hf(e) {
  for (const t in e)
    return !0;
  return !1;
}
function Br(e) {
  return O.fun(e) || O.arr(e) && O.obj(e[0]);
}
function Qf(e, t) {
  var n;
  (n = e.ref) == null || n.delete(e), t == null || t.delete(e);
}
function Uf(e, t) {
  var n;
  t && e.ref !== t && ((n = e.ref) == null || n.delete(e), t.add(e), e.ref = t);
}
var Wf = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
}, Lr = {
  ...Wf.default,
  mass: 1,
  damping: 1,
  easing: gf.linear,
  clamp: !1
}, qf = class {
  constructor() {
    this.velocity = 0, Object.assign(this, Lr);
  }
};
function Yf(e, t, n) {
  n && (n = { ...n }, ya(n, t), t = { ...n, ...t }), ya(e, t), Object.assign(e, t);
  for (const o in Lr)
    e[o] == null && (e[o] = Lr[o]);
  let { frequency: r, damping: i } = e;
  const { mass: a } = e;
  return O.und(r) || (r < 0.01 && (r = 0.01), i < 0 && (i = 0), e.tension = Math.pow(2 * Math.PI / r, 2) * a, e.friction = 4 * Math.PI * i * a / r), e;
}
function ya(e, t) {
  if (!O.und(t.decay))
    e.duration = void 0;
  else {
    const n = !O.und(t.tension) || !O.und(t.friction);
    (n || !O.und(t.frequency) || !O.und(t.damping) || !O.und(t.mass)) && (e.duration = void 0, e.decay = void 0), n && (e.frequency = void 0);
  }
}
var ba = [], Zf = class {
  constructor() {
    this.changed = !1, this.values = ba, this.toValues = null, this.fromValues = ba, this.config = new qf(), this.immediate = !1;
  }
};
function gl(e, { key: t, props: n, defaultProps: r, state: i, actions: a }) {
  return new Promise((o, l) => {
    let s, u, d = jt(n.cancel ?? (r == null ? void 0 : r.cancel), t);
    if (d)
      f();
    else {
      O.und(n.pause) || (i.paused = jt(n.pause, t));
      let y = r == null ? void 0 : r.pause;
      y !== !0 && (y = i.paused || jt(y, t)), s = nt(n.delay || 0, t), y ? (i.resumeQueue.add(h), a.pause()) : (a.resume(), h());
    }
    function c() {
      i.resumeQueue.add(h), i.timeouts.delete(u), u.cancel(), s = u.time - V.now();
    }
    function h() {
      s > 0 && !Oe.skipAnimation ? (i.delayed = !0, u = V.setTimeout(f, s), i.pauseQueue.add(c), i.timeouts.add(u)) : f();
    }
    function f() {
      i.delayed && (i.delayed = !1), i.pauseQueue.delete(c), i.timeouts.delete(u), e <= (i.cancelId || 0) && (d = !0);
      try {
        a.start({ ...n, callId: e, cancel: d }, o);
      } catch (y) {
        l(y);
      }
    }
  });
}
var pi = (e, t) => t.length == 1 ? t[0] : t.some((n) => n.cancelled) ? pt(e.get()) : t.every((n) => n.noop) ? yl(e.get()) : Ne(
  e.get(),
  t.every((n) => n.finished)
), yl = (e) => ({
  value: e,
  noop: !0,
  finished: !0,
  cancelled: !1
}), Ne = (e, t, n = !1) => ({
  value: e,
  finished: t,
  cancelled: n
}), pt = (e) => ({
  value: e,
  cancelled: !0,
  finished: !1
});
function bl(e, t, n, r) {
  const { callId: i, parentId: a, onRest: o } = t, { asyncTo: l, promise: s } = n;
  return !a && e === l && !t.reset ? s : n.promise = (async () => {
    n.asyncId = i, n.asyncTo = e;
    const u = mi(
      t,
      (C, b) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        b === "onRest" ? void 0 : C
      )
    );
    let d, c;
    const h = new Promise(
      (C, b) => (d = C, c = b)
    ), f = (C) => {
      const b = (
        // The `cancel` prop or `stop` method was used.
        i <= (n.cancelId || 0) && pt(r) || // The async `to` prop was replaced.
        i !== n.asyncId && Ne(r, !1)
      );
      if (b)
        throw C.result = b, c(C), C;
    }, y = (C, b) => {
      const A = new va(), x = new wa();
      return (async () => {
        if (Oe.skipAnimation)
          throw Kt(n), x.result = Ne(r, !1), c(x), x;
        f(A);
        const T = O.obj(C) ? { ...C } : { ...b, to: C };
        T.parentId = i, Ie(u, (k, B) => {
          O.und(T[B]) && (T[B] = k);
        });
        const N = await r.start(T);
        return f(A), n.paused && await new Promise((k) => {
          n.resumeQueue.add(k);
        }), N;
      })();
    };
    let v;
    if (Oe.skipAnimation)
      return Kt(n), Ne(r, !1);
    try {
      let C;
      O.arr(e) ? C = (async (b) => {
        for (const A of b)
          await y(A);
      })(e) : C = Promise.resolve(e(y, r.stop.bind(r))), await Promise.all([C.then(d), h]), v = Ne(r.get(), !0, !1);
    } catch (C) {
      if (C instanceof va)
        v = C.result;
      else if (C instanceof wa)
        v = C.result;
      else
        throw C;
    } finally {
      i == n.asyncId && (n.asyncId = a, n.asyncTo = a ? l : void 0, n.promise = a ? s : void 0);
    }
    return O.fun(o) && V.batchedUpdates(() => {
      o(v, r, r.item);
    }), v;
  })();
}
function Kt(e, t) {
  Ft(e.timeouts, (n) => n.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
}
var va = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
}, wa = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, Ir = (e) => e instanceof gi, Gf = 1, gi = class extends il {
  constructor() {
    super(...arguments), this.id = Gf++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(e) {
    this._priority != e && (this._priority = e, this._onPriorityChange(e));
  }
  /** Get the current value */
  get() {
    const e = De(this);
    return e && e.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...e) {
    return Oe.to(this, e);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...e) {
    return Cf(), Oe.to(this, e);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(e) {
    e == 1 && this._attach();
  }
  observerRemoved(e) {
    e == 0 && this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(e, t = !1) {
    Yt(this, {
      type: "change",
      parent: this,
      value: e,
      idle: t
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(e) {
    this.idle || Un.sort(this), Yt(this, {
      type: "priority",
      parent: this,
      priority: e
    });
  }
}, at = Symbol.for("SpringPhase"), vl = 1, Fr = 2, Rr = 4, ur = (e) => (e[at] & vl) > 0, Ye = (e) => (e[at] & Fr) > 0, Tt = (e) => (e[at] & Rr) > 0, xa = (e, t) => t ? e[at] |= Fr | vl : e[at] &= ~Fr, Aa = (e, t) => t ? e[at] |= Rr : e[at] &= ~Rr, Jf = class extends gi {
  constructor(e, t) {
    if (super(), this.animation = new Zf(), this.defaultProps = {}, this._state = {
      paused: !1,
      delayed: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !O.und(e) || !O.und(t)) {
      const n = O.obj(e) ? { ...e } : { ...t, from: e };
      O.und(n.default) && (n.default = !0), this.start(n);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(Ye(this) || this._state.asyncTo) || Tt(this);
  }
  get goal() {
    return de(this.animation.to);
  }
  get velocity() {
    const e = De(this);
    return e instanceof ln ? e.lastVelocity || 0 : e.getPayload().map((t) => t.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return ur(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return Ye(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return Tt(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(e) {
    let t = !0, n = !1;
    const r = this.animation;
    let { toValues: i } = r;
    const { config: a } = r, o = Zn(r.to);
    !o && we(r.to) && (i = ye(de(r.to))), r.values.forEach((u, d) => {
      if (u.done)
        return;
      const c = (
        // Animated strings always go from 0 to 1.
        u.constructor == Jt ? 1 : o ? o[d].lastPosition : i[d]
      );
      let h = r.immediate, f = c;
      if (!h) {
        if (f = u.lastPosition, a.tension <= 0) {
          u.done = !0;
          return;
        }
        let y = u.elapsedTime += e;
        const v = r.fromValues[d], C = u.v0 != null ? u.v0 : u.v0 = O.arr(a.velocity) ? a.velocity[d] : a.velocity;
        let b;
        const A = a.precision || (v == c ? 5e-3 : Math.min(1, Math.abs(c - v) * 1e-3));
        if (O.und(a.duration))
          if (a.decay) {
            const x = a.decay === !0 ? 0.998 : a.decay, T = Math.exp(-(1 - x) * y);
            f = v + C / (1 - x) * (1 - T), h = Math.abs(u.lastPosition - f) <= A, b = C * T;
          } else {
            b = u.lastVelocity == null ? C : u.lastVelocity;
            const x = a.restVelocity || A / 10, T = a.clamp ? 0 : a.bounce, N = !O.und(T), k = v == c ? u.v0 > 0 : v < c;
            let B, U = !1;
            const I = 1, R = Math.ceil(e / I);
            for (let D = 0; D < R && (B = Math.abs(b) > x, !(!B && (h = Math.abs(c - f) <= A, h))); ++D) {
              N && (U = f == c || f > c == k, U && (b = -b * T, f = c));
              const z = -a.tension * 1e-6 * (f - c), Q = -a.friction * 1e-3 * b, Y = (z + Q) / a.mass;
              b = b + Y * I, f = f + b * I;
            }
          }
        else {
          let x = 1;
          a.duration > 0 && (this._memoizedDuration !== a.duration && (this._memoizedDuration = a.duration, u.durationProgress > 0 && (u.elapsedTime = a.duration * u.durationProgress, y = u.elapsedTime += e)), x = (a.progress || 0) + y / this._memoizedDuration, x = x > 1 ? 1 : x < 0 ? 0 : x, u.durationProgress = x), f = v + a.easing(x) * (c - v), b = (f - u.lastPosition) / e, h = x == 1;
        }
        u.lastVelocity = b, Number.isNaN(f) && (console.warn("Got NaN while animating:", this), h = !0);
      }
      o && !o[d].done && (h = !1), h ? u.done = !0 : t = !1, u.setValue(f, a.round) && (n = !0);
    });
    const l = De(this), s = l.getValue();
    if (t) {
      const u = de(r.to);
      (s !== u || n) && !a.decay ? (l.setValue(u), this._onChange(u)) : n && a.decay && this._onChange(s), this._stop();
    } else
      n && this._onChange(s);
  }
  /** Set the current value, while stopping the current animation */
  set(e) {
    return V.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: !0 });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: !1 });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (Ye(this)) {
      const { to: e, config: t } = this.animation;
      V.batchedUpdates(() => {
        this._onStart(), t.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, t) {
    let n;
    return O.und(e) ? (n = this.queue || [], this.queue = []) : n = [O.obj(e) ? e : { ...t, to: e }], Promise.all(
      n.map((r) => this._update(r))
    ).then((r) => pi(this, r));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(e) {
    const { to: t } = this.animation;
    return this._focus(this.get()), Kt(this._state, e && this._lastCallId), V.batchedUpdates(() => this._stop(t, e)), this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: !0 });
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(e) {
    const t = this.key || "";
    let { to: n, from: r } = e;
    n = O.obj(n) ? n[t] : n, (n == null || Br(n)) && (n = void 0), r = O.obj(r) ? r[t] : r, r == null && (r = void 0);
    const i = { to: n, from: r };
    return ur(this) || (e.reverse && ([n, r] = [r, n]), r = de(r), O.und(r) ? De(this) || this._set(n) : this._set(r)), i;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...e }, t) {
    const { key: n, defaultProps: r } = this;
    e.default && Object.assign(
      r,
      mi(
        e,
        (o, l) => /^on/.test(l) ? hl(o, n) : o
      )
    ), Ca(this, e, "onProps"), Dt(this, "onProps", e, this);
    const i = this._prepareNode(e);
    if (Object.isFrozen(this))
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    const a = this._state;
    return gl(++this._lastCallId, {
      key: n,
      props: e,
      defaultProps: r,
      state: a,
      actions: {
        pause: () => {
          Tt(this) || (Aa(this, !0), Lt(a.pauseQueue), Dt(
            this,
            "onPause",
            Ne(this, Pt(this, this.animation.to)),
            this
          ));
        },
        resume: () => {
          Tt(this) && (Aa(this, !1), Ye(this) && this._resume(), Lt(a.resumeQueue), Dt(
            this,
            "onResume",
            Ne(this, Pt(this, this.animation.to)),
            this
          ));
        },
        start: this._merge.bind(this, i)
      }
    }).then((o) => {
      if (e.loop && o.finished && !(t && o.noop)) {
        const l = wl(e);
        if (l)
          return this._update(l, !0);
      }
      return o;
    });
  }
  /** Merge props into the current animation */
  _merge(e, t, n) {
    if (t.cancel)
      return this.stop(!0), n(pt(this));
    const r = !O.und(e.to), i = !O.und(e.from);
    if (r || i)
      if (t.callId > this._lastToId)
        this._lastToId = t.callId;
      else
        return n(pt(this));
    const { key: a, defaultProps: o, animation: l } = this, { to: s, from: u } = l;
    let { to: d = s, from: c = u } = e;
    i && !r && (!t.default || O.und(d)) && (d = c), t.reverse && ([d, c] = [c, d]);
    const h = !He(c, u);
    h && (l.from = c), c = de(c);
    const f = !He(d, s);
    f && this._focus(d);
    const y = Br(t.to), { config: v } = l, { decay: C, velocity: b } = v;
    (r || i) && (v.velocity = 0), t.config && !y && Yf(
      v,
      nt(t.config, a),
      // Avoid calling the same "config" prop twice.
      t.config !== o.config ? nt(o.config, a) : void 0
    );
    let A = De(this);
    if (!A || O.und(d))
      return n(Ne(this, !0));
    const x = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      O.und(t.reset) ? i && !t.default : !O.und(c) && jt(t.reset, a)
    ), T = x ? c : this.get(), N = Xt(d), k = O.num(N) || O.arr(N) || Yn(N), B = !y && (!k || jt(o.immediate || t.immediate, a));
    if (f) {
      const D = zr(d);
      if (D !== A.constructor)
        if (B)
          A = this._set(N);
        else
          throw Error(
            `Cannot animate between ${A.constructor.name} and ${D.name}, as the "to" prop suggests`
          );
    }
    const U = A.constructor;
    let I = we(d), R = !1;
    if (!I) {
      const D = x || !ur(this) && h;
      (f || D) && (R = He(Xt(T), N), I = !R), (!He(l.immediate, B) && !B || !He(v.decay, C) || !He(v.velocity, b)) && (I = !0);
    }
    if (R && Ye(this) && (l.changed && !x ? I = !0 : I || this._stop(s)), !y && ((I || we(s)) && (l.values = A.getPayload(), l.toValues = we(d) ? null : U == Jt ? [1] : ye(N)), l.immediate != B && (l.immediate = B, !B && !x && this._set(s)), I)) {
      const { onRest: D } = l;
      q(Kf, (Q) => Ca(this, t, Q));
      const z = Ne(this, Pt(this, s));
      Lt(this._pendingCalls, z), this._pendingCalls.add(n), l.changed && V.batchedUpdates(() => {
        var Q;
        l.changed = !x, D == null || D(z, this), x ? nt(o.onRest, z) : (Q = l.onStart) == null || Q.call(l, z, this);
      });
    }
    x && this._set(T), y ? n(bl(t.to, t, this._state, this)) : I ? this._start() : Ye(this) && !f ? this._pendingCalls.add(n) : n(yl(T));
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(e) {
    const t = this.animation;
    e !== t.to && (da(this) && this._detach(), t.to = e, da(this) && this._attach());
  }
  _attach() {
    let e = 0;
    const { to: t } = this.animation;
    we(t) && (Ct(t, this), Ir(t) && (e = t.priority + 1)), this.priority = e;
  }
  _detach() {
    const { to: e } = this.animation;
    we(e) && Zt(e, this);
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(e, t = !0) {
    const n = de(e);
    if (!O.und(n)) {
      const r = De(this);
      if (!r || !He(n, r.getValue())) {
        const i = zr(n);
        !r || r.constructor != i ? hi(this, i.create(n)) : r.setValue(n), r && V.batchedUpdates(() => {
          this._onChange(n, t);
        });
      }
    }
    return De(this);
  }
  _onStart() {
    const e = this.animation;
    e.changed || (e.changed = !0, Dt(
      this,
      "onStart",
      Ne(this, Pt(this, e.to)),
      this
    ));
  }
  _onChange(e, t) {
    t || (this._onStart(), nt(this.animation.onChange, e, this)), nt(this.defaultProps.onChange, e, this), super._onChange(e, t);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const e = this.animation;
    De(this).reset(de(e.to)), e.immediate || (e.fromValues = e.values.map((t) => t.lastPosition)), Ye(this) || (xa(this, !0), Tt(this) || this._resume());
  }
  _resume() {
    Oe.skipAnimation ? this.finish() : Un.start(this);
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(e, t) {
    if (Ye(this)) {
      xa(this, !1);
      const n = this.animation;
      q(n.values, (i) => {
        i.done = !0;
      }), n.toValues && (n.onChange = n.onPause = n.onResume = void 0), Yt(this, {
        type: "idle",
        parent: this
      });
      const r = t ? pt(this.get()) : Ne(this.get(), Pt(this, e ?? n.to));
      Lt(this._pendingCalls, r), n.changed && (n.changed = !1, Dt(this, "onRest", r, this));
    }
  }
};
function Pt(e, t) {
  const n = Xt(t), r = Xt(e.get());
  return He(r, n);
}
function wl(e, t = e.loop, n = e.to) {
  const r = nt(t);
  if (r) {
    const i = r !== !0 && pl(r), a = (i || e).reverse, o = !i || i.reset;
    return _t({
      ...e,
      loop: t,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !a || Br(n) ? n : void 0,
      // Ignore the "from" prop except on reset.
      from: o ? e.from : void 0,
      reset: o,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...i
    });
  }
}
function _t(e) {
  const { to: t, from: n } = e = pl(e), r = /* @__PURE__ */ new Set();
  return O.obj(t) && ka(t, r), O.obj(n) && ka(n, r), e.keys = r.size ? Array.from(r) : null, e;
}
function Xf(e) {
  const t = _t(e);
  return O.und(t.default) && (t.default = mi(t)), t;
}
function ka(e, t) {
  Ie(e, (n, r) => n != null && t.add(r));
}
var Kf = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function Ca(e, t, n) {
  e.animation[n] = t[n] !== ml(t, n) ? hl(t[n], e.key) : void 0;
}
function Dt(e, t, ...n) {
  var r, i, a, o;
  (i = (r = e.animation)[t]) == null || i.call(r, ...n), (o = (a = e.defaultProps)[t]) == null || o.call(a, ...n);
}
var _f = ["onStart", "onChange", "onRest"], $f = 1, eh = class {
  constructor(e, t) {
    this.id = $f++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = {
      paused: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    }, this._onFrame = this._onFrame.bind(this), t && (this._flush = t), e && this.start({ default: !0, ...e });
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((e) => e.idle && !e.isDelayed && !e.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(e) {
    this._item = e;
  }
  /** Get the current values of our springs */
  get() {
    const e = {};
    return this.each((t, n) => e[n] = t.get()), e;
  }
  /** Set the current values without animating. */
  set(e) {
    for (const t in e) {
      const n = e[t];
      O.und(n) || this.springs[t].set(n);
    }
  }
  /** Push an update onto the queue of each value. */
  update(e) {
    return e && this.queue.push(_t(e)), this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(e) {
    let { queue: t } = this;
    return e ? t = ye(e).map(_t) : this.queue = [], this._flush ? this._flush(this, t) : (El(this, t), jr(this, t));
  }
  /** @internal */
  stop(e, t) {
    if (e !== !!e && (t = e), t) {
      const n = this.springs;
      q(ye(t), (r) => n[r].stop(!!e));
    } else
      Kt(this._state, this._lastAsyncId), this.each((n) => n.stop(!!e));
    return this;
  }
  /** Freeze the active animation in time */
  pause(e) {
    if (O.und(e))
      this.start({ pause: !0 });
    else {
      const t = this.springs;
      q(ye(e), (n) => t[n].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(e) {
    if (O.und(e))
      this.start({ pause: !1 });
    else {
      const t = this.springs;
      q(ye(e), (n) => t[n].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(e) {
    Ie(this.springs, e);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart: e, onChange: t, onRest: n } = this._events, r = this._active.size > 0, i = this._changed.size > 0;
    (r && !this._started || i && !this._started) && (this._started = !0, Ft(e, ([l, s]) => {
      s.value = this.get(), l(s, this, this._item);
    }));
    const a = !r && this._started, o = i || a && n.size ? this.get() : null;
    i && t.size && Ft(t, ([l, s]) => {
      s.value = o, l(s, this, this._item);
    }), a && (this._started = !1, Ft(n, ([l, s]) => {
      s.value = o, l(s, this, this._item);
    }));
  }
  /** @internal */
  eventObserved(e) {
    if (e.type == "change")
      this._changed.add(e.parent), e.idle || this._active.add(e.parent);
    else if (e.type == "idle")
      this._active.delete(e.parent);
    else
      return;
    V.onFrame(this._onFrame);
  }
};
function jr(e, t) {
  return Promise.all(t.map((n) => xl(e, n))).then(
    (n) => pi(e, n)
  );
}
async function xl(e, t, n) {
  const { keys: r, to: i, from: a, loop: o, onRest: l, onResolve: s } = t, u = O.obj(t.default) && t.default;
  o && (t.loop = !1), i === !1 && (t.to = null), a === !1 && (t.from = null);
  const d = O.arr(i) || O.fun(i) ? i : void 0;
  d ? (t.to = void 0, t.onRest = void 0, u && (u.onRest = void 0)) : q(_f, (v) => {
    const C = t[v];
    if (O.fun(C)) {
      const b = e._events[v];
      t[v] = ({ finished: A, cancelled: x }) => {
        const T = b.get(C);
        T ? (A || (T.finished = !1), x && (T.cancelled = !0)) : b.set(C, {
          value: null,
          finished: A || !1,
          cancelled: x || !1
        });
      }, u && (u[v] = t[v]);
    }
  });
  const c = e._state;
  t.pause === !c.paused ? (c.paused = t.pause, Lt(t.pause ? c.pauseQueue : c.resumeQueue)) : c.paused && (t.pause = !0);
  const h = (r || Object.keys(e.springs)).map(
    (v) => e.springs[v].start(t)
  ), f = t.cancel === !0 || ml(t, "cancel") === !0;
  (d || f && c.asyncId) && h.push(
    gl(++e._lastAsyncId, {
      props: t,
      state: c,
      actions: {
        pause: Pr,
        resume: Pr,
        start(v, C) {
          f ? (Kt(c, e._lastAsyncId), C(pt(e))) : (v.onRest = l, C(
            bl(
              d,
              v,
              c,
              e
            )
          ));
        }
      }
    })
  ), c.paused && await new Promise((v) => {
    c.resumeQueue.add(v);
  });
  const y = pi(e, await Promise.all(h));
  if (o && y.finished && !(n && y.noop)) {
    const v = wl(t, o, i);
    if (v)
      return El(e, [v]), xl(e, v, !0);
  }
  return s && V.batchedUpdates(() => s(y, e, e.item)), y;
}
function Ea(e, t) {
  const n = { ...e.springs };
  return t && q(ye(t), (r) => {
    O.und(r.keys) && (r = _t(r)), O.obj(r.to) || (r = { ...r, to: void 0 }), Cl(n, r, (i) => kl(i));
  }), Al(e, n), n;
}
function Al(e, t) {
  Ie(t, (n, r) => {
    e.springs[r] || (e.springs[r] = n, Ct(n, e));
  });
}
function kl(e, t) {
  const n = new Jf();
  return n.key = e, t && Ct(n, t), n;
}
function Cl(e, t, n) {
  t.keys && q(t.keys, (r) => {
    (e[r] || (e[r] = n(r)))._prepareNode(t);
  });
}
function El(e, t) {
  q(t, (n) => {
    Cl(e.springs, n, (r) => kl(r, e));
  });
}
var Jn = ({
  children: e,
  ...t
}) => {
  const n = Ao(Bn), r = t.pause || !!n.pause, i = t.immediate || !!n.immediate;
  t = Mf(() => ({ pause: r, immediate: i }), [r, i]);
  const { Provider: a } = Bn;
  return /* @__PURE__ */ w.createElement(a, { value: t }, e);
}, Bn = th(Jn, {});
Jn.Provider = Bn.Provider;
Jn.Consumer = Bn.Consumer;
function th(e, t) {
  return Object.assign(e, w.createContext(t)), e.Provider._context = e, e.Consumer._context = e, e;
}
var nh = () => {
  const e = [], t = function(r) {
    Sf();
    const i = [];
    return q(e, (a, o) => {
      if (O.und(r))
        i.push(a.start());
      else {
        const l = n(r, a, o);
        l && i.push(a.start(l));
      }
    }), i;
  };
  t.current = e, t.add = function(r) {
    e.includes(r) || e.push(r);
  }, t.delete = function(r) {
    const i = e.indexOf(r);
    ~i && e.splice(i, 1);
  }, t.pause = function() {
    return q(e, (r) => r.pause(...arguments)), this;
  }, t.resume = function() {
    return q(e, (r) => r.resume(...arguments)), this;
  }, t.set = function(r) {
    q(e, (i, a) => {
      const o = O.fun(r) ? r(a, i) : r;
      o && i.set(o);
    });
  }, t.start = function(r) {
    const i = [];
    return q(e, (a, o) => {
      if (O.und(r))
        i.push(a.start());
      else {
        const l = this._getProps(r, a, o);
        l && i.push(a.start(l));
      }
    }), i;
  }, t.stop = function() {
    return q(e, (r) => r.stop(...arguments)), this;
  }, t.update = function(r) {
    return q(e, (i, a) => i.update(this._getProps(r, i, a))), this;
  };
  const n = function(r, i, a) {
    return O.fun(r) ? r(a, i) : r;
  };
  return t._getProps = n, t;
};
function rh(e, t, n) {
  const r = O.fun(t) && t;
  r && !n && (n = []);
  const i = cn(
    () => r || arguments.length == 3 ? nh() : void 0,
    []
  ), a = ge(0), o = sl(), l = cn(
    () => ({
      ctrls: [],
      queue: [],
      flush(b, A) {
        const x = Ea(b, A);
        return a.current > 0 && !l.queue.length && !Object.keys(x).some((N) => !b.springs[N]) ? jr(b, A) : new Promise((N) => {
          Al(b, x), l.queue.push(() => {
            N(jr(b, A));
          }), o();
        });
      }
    }),
    []
  ), s = ge([...l.ctrls]), u = [], d = ha(e) || 0;
  cn(() => {
    q(s.current.slice(e, d), (b) => {
      Qf(b, i), b.stop(!0);
    }), s.current.length = e, c(d, e);
  }, [e]), cn(() => {
    c(0, Math.min(d, e));
  }, n);
  function c(b, A) {
    for (let x = b; x < A; x++) {
      const T = s.current[x] || (s.current[x] = new eh(null, l.flush)), N = r ? r(x, T) : t[x];
      N && (u[x] = Xf(N));
    }
  }
  const h = s.current.map((b, A) => Ea(b, u[A])), f = Ao(Jn), y = ha(f), v = f !== y && Hf(f);
  fi(() => {
    a.current++, l.ctrls = s.current;
    const { queue: b } = l;
    b.length && (l.queue = [], q(b, (A) => A())), q(s.current, (A, x) => {
      i == null || i.add(A), v && A.start({ default: f });
      const T = u[x];
      T && (Uf(A, T.ref), A.ref ? A.queue.push(T) : A.start(T));
    });
  }), cl(() => () => {
    q(l.ctrls, (b) => b.stop(!0));
  });
  const C = h.map((b) => ({ ...b }));
  return i ? [C, i] : C;
}
function Sa(e, t) {
  const n = O.fun(e), [[r], i] = rh(
    1,
    n ? e : [e],
    n ? t || [] : t
  );
  return n || arguments.length == 2 ? [r, i] : r;
}
var ih = class extends gi {
  constructor(e, t) {
    super(), this.source = e, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = Wt(...t);
    const n = this._get(), r = zr(n);
    hi(this, r.create(n));
  }
  advance(e) {
    const t = this._get(), n = this.get();
    He(t, n) || (De(this).setValue(t), this._onChange(t, this.idle)), !this.idle && Na(this._active) && sr(this);
  }
  _get() {
    const e = O.arr(this.source) ? this.source.map(de) : ye(de(this.source));
    return this.calc(...e);
  }
  _start() {
    this.idle && !Na(this._active) && (this.idle = !1, q(Zn(this), (e) => {
      e.done = !1;
    }), Oe.skipAnimation ? (V.batchedUpdates(() => this.advance()), sr(this)) : Un.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let e = 1;
    q(ye(this.source), (t) => {
      we(t) && Ct(t, this), Ir(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
    }), this.priority = e, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    q(ye(this.source), (e) => {
      we(e) && Zt(e, this);
    }), this._active.clear(), sr(this);
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : e.type == "idle" ? this._active.delete(e.parent) : e.type == "priority" && (this.priority = ye(this.source).reduce(
      (t, n) => Math.max(t, (Ir(n) ? n.priority : 0) + 1),
      0
    ));
  }
};
function ah(e) {
  return e.idle !== !1;
}
function Na(e) {
  return !e.size || Array.from(e).every(ah);
}
function sr(e) {
  e.idle || (e.idle = !0, q(Zn(e), (t) => {
    t.done = !0;
  }), Yt(e, {
    type: "idle",
    parent: e
  }));
}
Oe.assign({
  createStringInterpolator: ll,
  to: (e, t) => new ih(e, t)
});
var Sl = /^--/;
function oh(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !Sl.test(e) && !(Vt.hasOwnProperty(e) && Vt[e]) ? t + "px" : ("" + t).trim();
}
var Ma = {};
function lh(e, t) {
  if (!e.nodeType || !e.setAttribute)
    return !1;
  const n = e.nodeName === "filter" || e.parentNode && e.parentNode.nodeName === "filter", { style: r, children: i, scrollTop: a, scrollLeft: o, viewBox: l, ...s } = t, u = Object.values(s), d = Object.keys(s).map(
    (c) => n || e.hasAttribute(c) ? c : Ma[c] || (Ma[c] = c.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (h) => "-" + h.toLowerCase()
    ))
  );
  i !== void 0 && (e.textContent = i);
  for (const c in r)
    if (r.hasOwnProperty(c)) {
      const h = oh(c, r[c]);
      Sl.test(c) ? e.style.setProperty(c, h) : e.style[c] = h;
    }
  d.forEach((c, h) => {
    e.setAttribute(c, u[h]);
  }), a !== void 0 && (e.scrollTop = a), o !== void 0 && (e.scrollLeft = o), l !== void 0 && e.setAttribute("viewBox", l);
}
var Vt = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, uh = (e, t) => e + t.charAt(0).toUpperCase() + t.substring(1), sh = ["Webkit", "Ms", "Moz", "O"];
Vt = Object.keys(Vt).reduce((e, t) => (sh.forEach((n) => e[uh(n, t)] = e[t]), e), Vt);
var ch = /^(matrix|translate|scale|rotate|skew)/, dh = /^(translate)/, fh = /^(rotate|skew)/, cr = (e, t) => O.num(e) && e !== 0 ? e + t : e, xn = (e, t) => O.arr(e) ? e.every((n) => xn(n, t)) : O.num(e) ? e === t : parseFloat(e) === t, hh = class extends Gn {
  constructor({ x: e, y: t, z: n, ...r }) {
    const i = [], a = [];
    (e || t || n) && (i.push([e || 0, t || 0, n || 0]), a.push((o) => [
      `translate3d(${o.map((l) => cr(l, "px")).join(",")})`,
      // prettier-ignore
      xn(o, 0)
    ])), Ie(r, (o, l) => {
      if (l === "transform")
        i.push([o || ""]), a.push((s) => [s, s === ""]);
      else if (ch.test(l)) {
        if (delete r[l], O.und(o))
          return;
        const s = dh.test(l) ? "px" : fh.test(l) ? "deg" : "";
        i.push(ye(o)), a.push(
          l === "rotate3d" ? ([u, d, c, h]) => [
            `rotate3d(${u},${d},${c},${cr(h, s)})`,
            xn(h, 0)
          ] : (u) => [
            `${l}(${u.map((d) => cr(d, s)).join(",")})`,
            xn(u, l.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    }), i.length && (r.transform = new mh(i, a)), super(r);
  }
}, mh = class extends il {
  constructor(e, t) {
    super(), this.inputs = e, this.transforms = t, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let e = "", t = !0;
    return q(this.inputs, (n, r) => {
      const i = de(n[0]), [a, o] = this.transforms[r](
        O.arr(i) ? i : n.map(de)
      );
      e += " " + a, t = t && o;
    }), t ? "none" : e;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(e) {
    e == 1 && q(
      this.inputs,
      (t) => q(
        t,
        (n) => we(n) && Ct(n, this)
      )
    );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(e) {
    e == 0 && q(
      this.inputs,
      (t) => q(
        t,
        (n) => we(n) && Zt(n, this)
      )
    );
  }
  eventObserved(e) {
    e.type == "change" && (this._value = null), Yt(this, e);
  }
}, ph = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
Oe.assign({
  batchedUpdates: Cu,
  createStringInterpolator: ll,
  colors: nf
});
var gh = If(ph, {
  applyAnimatedValues: lh,
  createAnimatedStyle: (e) => new hh(e),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop: e, scrollLeft: t, ...n }) => n
}), Oa = gh.animated;
const y0 = {
  NORMAL: "normal",
  INHERIT: "white",
  GREEN: "green",
  RED: "red",
  BLUE: "blue",
  BLACK: "black",
  DISABLED: "disabled"
}, Nl = {
  NORMAL: "ui-text-neutral-900 ui-bg-buttonNormal ui-border ui-border-gray-300 hover:ui-opacity-95 active:ui-opacity-90",
  INHERIT: "ui-text-neutral-900 ui-bg-inherit ui-border ui-border-gray-300 hover:ui-opacity-95 active:ui-opacity-90",
  GREEN: "ui-text-zinc-50 ui-bg-buttonGreen ui-border-0 hover:ui-opacity-95 active:ui-opacity-90",
  RED: "ui-text-zinc-50 ui-bg-buttonRed ui-border-0 hover:ui-opacity-95 active:ui-opacity-90",
  BLUE: "ui-text-zinc-50 ui-bg-cornflowerBlue ui-border-0 hover:ui-opacity-95 active:ui-opacity-90",
  BLACK: "ui-text-white ui-bg-buttonBlack ui-border-0 hover:ui-opacity-95 active:ui-opacity-90",
  DISABLED: "ui-text-zinc-300 ui-bg-buttonGrey ui-border-0 hover:ui-cursor-default"
}, b0 = ({
  onClick: e,
  theme: t = "NORMAL",
  loading: n = !1,
  type: r = "button",
  disabled: i = !1,
  children: a,
  className: o
}) => {
  const l = Sa({ from: { opacity: 0 }, opacity: n ? 1 : 0 }), s = Sa({ from: { opacity: 1 }, opacity: n ? 0 : 1 });
  return /* @__PURE__ */ M(
    "button",
    {
      type: r,
      disabled: i,
      onClick: e,
      className: `ui-relative ui-flex ui-items-center ui-outline-none ui-user-select-none ui-cursor-pointer ui-min-h-[48px] ui-rounded-md hover:ui-no-underline ui-px-5 ui-py-2 ${Nl[t]} ${o || ""}`,
      children: [
        n && /* @__PURE__ */ m(
          Oa.div,
          {
            className: "ui-top-0 ui-left-0 ui-right-0 ui-bottom-0 ui-flex ui-justify-center ui-items-center ui-absolute",
            style: { ...l },
            children: /* @__PURE__ */ m(bt, { size: "small", theme: "white" })
          }
        ),
        /* @__PURE__ */ m(
          Oa.span,
          {
            style: s,
            className: `ui-flex ui-justify-between ui-items-center ui-justify-items-center ui-w-full ${n ? "ui-visibility-hidden" : ""}`,
            children: a
          }
        )
      ]
    }
  );
}, v0 = ({ to: e, theme: t = "NORMAL", children: n, className: r }) => /* @__PURE__ */ m(
  ni,
  {
    to: e,
    className: `ui-relative ui-flex ui-items-center ui-outline-none ui-user-select-none ui-cursor-pointer ui-min-h-[48px] ui-rounded-md hover:ui-no-underline ui-px-5 ui-py-2 ${Nl[t]} ${r}`,
    children: /* @__PURE__ */ m("span", { className: "ui-flex ui-justify-between ui-items-center ui-justify-items-center ui-w-full", children: n })
  }
);
function yh(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const bh = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, vh = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, wh = {};
function Ta(e, t) {
  return ((t || wh).jsx ? vh : bh).test(e);
}
const xh = /[ \t\n\f\r]/g;
function Ah(e) {
  return typeof e == "object" ? e.type === "text" ? Pa(e.value) : !1 : Pa(e);
}
function Pa(e) {
  return e.replace(xh, "") === "";
}
class un {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
un.prototype.property = {};
un.prototype.normal = {};
un.prototype.space = null;
function Ml(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new un(n, r, t);
}
function Vr(e) {
  return e.toLowerCase();
}
class ke {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
ke.prototype.space = null;
ke.prototype.boolean = !1;
ke.prototype.booleanish = !1;
ke.prototype.overloadedBoolean = !1;
ke.prototype.number = !1;
ke.prototype.commaSeparated = !1;
ke.prototype.spaceSeparated = !1;
ke.prototype.commaOrSpaceSeparated = !1;
ke.prototype.mustUseProperty = !1;
ke.prototype.defined = !1;
let kh = 0;
const H = ot(), ae = ot(), Ol = ot(), S = ot(), _ = ot(), gt = ot(), pe = ot();
function ot() {
  return 2 ** ++kh;
}
const Hr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: H,
  booleanish: ae,
  commaOrSpaceSeparated: pe,
  commaSeparated: gt,
  number: S,
  overloadedBoolean: Ol,
  spaceSeparated: _
}, Symbol.toStringTag, { value: "Module" })), dr = Object.keys(Hr);
class yi extends ke {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), Da(this, "space", i), typeof r == "number")
      for (; ++a < dr.length; ) {
        const o = dr[a];
        Da(this, dr[a], (r & Hr[o]) === Hr[o]);
      }
  }
}
yi.prototype.defined = !0;
function Da(e, t, n) {
  n && (e[t] = n);
}
const Ch = {}.hasOwnProperty;
function Et(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (Ch.call(e.properties, r)) {
      const i = e.properties[r], a = new yi(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[Vr(r)] = r, n[Vr(a.attribute)] = r;
    }
  return new un(t, n, e.space);
}
const Tl = Et({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Pl = Et({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Dl(e, t) {
  return t in e ? e[t] : t;
}
function zl(e, t) {
  return Dl(e, t.toLowerCase());
}
const Bl = Et({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: zl,
  properties: { xmlns: null, xmlnsXLink: null }
}), Ll = Et({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: ae,
    ariaAutoComplete: null,
    ariaBusy: ae,
    ariaChecked: ae,
    ariaColCount: S,
    ariaColIndex: S,
    ariaColSpan: S,
    ariaControls: _,
    ariaCurrent: null,
    ariaDescribedBy: _,
    ariaDetails: null,
    ariaDisabled: ae,
    ariaDropEffect: _,
    ariaErrorMessage: null,
    ariaExpanded: ae,
    ariaFlowTo: _,
    ariaGrabbed: ae,
    ariaHasPopup: null,
    ariaHidden: ae,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: _,
    ariaLevel: S,
    ariaLive: null,
    ariaModal: ae,
    ariaMultiLine: ae,
    ariaMultiSelectable: ae,
    ariaOrientation: null,
    ariaOwns: _,
    ariaPlaceholder: null,
    ariaPosInSet: S,
    ariaPressed: ae,
    ariaReadOnly: ae,
    ariaRelevant: null,
    ariaRequired: ae,
    ariaRoleDescription: _,
    ariaRowCount: S,
    ariaRowIndex: S,
    ariaRowSpan: S,
    ariaSelected: ae,
    ariaSetSize: S,
    ariaSort: null,
    ariaValueMax: S,
    ariaValueMin: S,
    ariaValueNow: S,
    ariaValueText: null,
    role: null
  }
}), Eh = Et({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: zl,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: gt,
    acceptCharset: _,
    accessKey: _,
    action: null,
    allow: null,
    allowFullScreen: H,
    allowPaymentRequest: H,
    allowUserMedia: H,
    alt: null,
    as: null,
    async: H,
    autoCapitalize: null,
    autoComplete: _,
    autoFocus: H,
    autoPlay: H,
    blocking: _,
    capture: H,
    charSet: null,
    checked: H,
    cite: null,
    className: _,
    cols: S,
    colSpan: null,
    content: null,
    contentEditable: ae,
    controls: H,
    controlsList: _,
    coords: S | gt,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: H,
    defer: H,
    dir: null,
    dirName: null,
    disabled: H,
    download: Ol,
    draggable: ae,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: H,
    formTarget: null,
    headers: _,
    height: S,
    hidden: H,
    high: S,
    href: null,
    hrefLang: null,
    htmlFor: _,
    httpEquiv: _,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: H,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: H,
    itemId: null,
    itemProp: _,
    itemRef: _,
    itemScope: H,
    itemType: _,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: H,
    low: S,
    manifest: null,
    max: null,
    maxLength: S,
    media: null,
    method: null,
    min: null,
    minLength: S,
    multiple: H,
    muted: H,
    name: null,
    nonce: null,
    noModule: H,
    noValidate: H,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: H,
    optimum: S,
    pattern: null,
    ping: _,
    placeholder: null,
    playsInline: H,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: H,
    referrerPolicy: null,
    rel: _,
    required: H,
    reversed: H,
    rows: S,
    rowSpan: S,
    sandbox: _,
    scope: null,
    scoped: H,
    seamless: H,
    selected: H,
    shadowRootDelegatesFocus: H,
    shadowRootMode: null,
    shape: null,
    size: S,
    sizes: null,
    slot: null,
    span: S,
    spellCheck: ae,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: S,
    step: null,
    style: null,
    tabIndex: S,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: H,
    useMap: null,
    value: ae,
    width: S,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: _,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: S,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: S,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: H,
    // Lists. Use CSS to reduce space between items instead
    declare: H,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: S,
    // `<img>` and `<object>`
    leftMargin: S,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: S,
    // `<body>`
    marginWidth: S,
    // `<body>`
    noResize: H,
    // `<frame>`
    noHref: H,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: H,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: H,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: S,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ae,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: S,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: S,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: H,
    disableRemotePlayback: H,
    prefix: null,
    property: null,
    results: S,
    security: null,
    unselectable: null
  }
}), Sh = Et({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Dl,
  properties: {
    about: pe,
    accentHeight: S,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: S,
    amplitude: S,
    arabicForm: null,
    ascent: S,
    attributeName: null,
    attributeType: null,
    azimuth: S,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: S,
    by: null,
    calcMode: null,
    capHeight: S,
    className: _,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: S,
    diffuseConstant: S,
    direction: null,
    display: null,
    dur: null,
    divisor: S,
    dominantBaseline: null,
    download: H,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: S,
    enableBackground: null,
    end: null,
    event: null,
    exponent: S,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: S,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: gt,
    g2: gt,
    glyphName: gt,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: S,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: S,
    horizOriginX: S,
    horizOriginY: S,
    id: null,
    ideographic: S,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: S,
    k: S,
    k1: S,
    k2: S,
    k3: S,
    k4: S,
    kernelMatrix: pe,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: S,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: S,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: S,
    overlineThickness: S,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: S,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: _,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: S,
    pointsAtY: S,
    pointsAtZ: S,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: pe,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: pe,
    rev: pe,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: pe,
    requiredFeatures: pe,
    requiredFonts: pe,
    requiredFormats: pe,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: S,
    specularExponent: S,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: S,
    strikethroughThickness: S,
    string: null,
    stroke: null,
    strokeDashArray: pe,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: S,
    strokeOpacity: S,
    strokeWidth: null,
    style: null,
    surfaceScale: S,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: pe,
    tabIndex: S,
    tableValues: null,
    target: null,
    targetX: S,
    targetY: S,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: pe,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: S,
    underlineThickness: S,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: S,
    values: null,
    vAlphabetic: S,
    vMathematical: S,
    vectorEffect: null,
    vHanging: S,
    vIdeographic: S,
    version: null,
    vertAdvY: S,
    vertOriginX: S,
    vertOriginY: S,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: S,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Nh = /^data[-\w.:]+$/i, za = /-[a-z]/g, Mh = /[A-Z]/g;
function Oh(e, t) {
  const n = Vr(t);
  let r = t, i = ke;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Nh.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(za, Ph);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!za.test(a)) {
        let o = a.replace(Mh, Th);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = yi;
  }
  return new i(r, t);
}
function Th(e) {
  return "-" + e.toLowerCase();
}
function Ph(e) {
  return e.charAt(1).toUpperCase();
}
const Dh = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, zh = Ml([Pl, Tl, Bl, Ll, Eh], "html"), bi = Ml([Pl, Tl, Bl, Ll, Sh], "svg");
function Bh(e) {
  return e.join(" ").trim();
}
var Ba = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Lh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Il = {}, La = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Ih = /\n/g, Fh = /^\s*/, Rh = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, jh = /^:\s*/, Vh = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Hh = /^[;\s]*/, Qh = /^\s+|\s+$/g, Uh = `
`, Ia = "/", Fa = "*", rt = "", Wh = "comment", qh = "declaration", Yh = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function i(y) {
    var v = y.match(Ih);
    v && (n += v.length);
    var C = y.lastIndexOf(Uh);
    r = ~C ? y.length - C : r + y.length;
  }
  function a() {
    var y = { line: n, column: r };
    return function(v) {
      return v.position = new o(y), u(), v;
    };
  }
  function o(y) {
    this.start = y, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function l(y) {
    var v = new Error(
      t.source + ":" + n + ":" + r + ": " + y
    );
    if (v.reason = y, v.filename = t.source, v.line = n, v.column = r, v.source = e, !t.silent)
      throw v;
  }
  function s(y) {
    var v = y.exec(e);
    if (v) {
      var C = v[0];
      return i(C), e = e.slice(C.length), v;
    }
  }
  function u() {
    s(Fh);
  }
  function d(y) {
    var v;
    for (y = y || []; v = c(); )
      v !== !1 && y.push(v);
    return y;
  }
  function c() {
    var y = a();
    if (!(Ia != e.charAt(0) || Fa != e.charAt(1))) {
      for (var v = 2; rt != e.charAt(v) && (Fa != e.charAt(v) || Ia != e.charAt(v + 1)); )
        ++v;
      if (v += 2, rt === e.charAt(v - 1))
        return l("End of comment missing");
      var C = e.slice(2, v - 2);
      return r += 2, i(C), e = e.slice(v), r += 2, y({
        type: Wh,
        comment: C
      });
    }
  }
  function h() {
    var y = a(), v = s(Rh);
    if (v) {
      if (c(), !s(jh))
        return l("property missing ':'");
      var C = s(Vh), b = y({
        type: qh,
        property: Ra(v[0].replace(La, rt)),
        value: C ? Ra(C[0].replace(La, rt)) : rt
      });
      return s(Hh), b;
    }
  }
  function f() {
    var y = [];
    d(y);
    for (var v; v = h(); )
      v !== !1 && (y.push(v), d(y));
    return y;
  }
  return u(), f();
};
function Ra(e) {
  return e ? e.replace(Qh, rt) : rt;
}
var Zh = Ba && Ba.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Il, "__esModule", { value: !0 });
var Gh = Zh(Yh);
function Jh(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, Gh.default)(e), i = typeof t == "function";
  return r.forEach(function(a) {
    if (a.type === "declaration") {
      var o = a.property, l = a.value;
      i ? t(o, l, a) : l && (n = n || {}, n[o] = l);
    }
  }), n;
}
var ja = Il.default = Jh;
const Xh = ja.default || ja, Fl = Rl("end"), vi = Rl("start");
function Rl(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function Kh(e) {
  const t = vi(e), n = Fl(e);
  if (t && n)
    return { start: t, end: n };
}
function Ht(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Va(e.position) : "start" in e || "end" in e ? Va(e) : "line" in e || "column" in e ? Qr(e) : "";
}
function Qr(e) {
  return Ha(e && e.line) + ":" + Ha(e && e.column);
}
function Va(e) {
  return Qr(e && e.start) + "-" + Qr(e && e.end);
}
function Ha(e) {
  return e && typeof e == "number" ? e : 1;
}
class se extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", a = {}, o = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof t == "string" ? i = t : !a.cause && t && (o = !0, i = t.message, a.cause = t), !a.ruleId && !a.source && typeof r == "string") {
      const s = r.indexOf(":");
      s === -1 ? a.ruleId = r : (a.source = r.slice(0, s), a.ruleId = r.slice(s + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const s = a.ancestors[a.ancestors.length - 1];
      s && (a.place = s.position);
    }
    const l = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = l ? l.line : void 0, this.name = Ht(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = o && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
se.prototype.file = "";
se.prototype.name = "";
se.prototype.reason = "";
se.prototype.message = "";
se.prototype.stack = "";
se.prototype.column = void 0;
se.prototype.line = void 0;
se.prototype.ancestors = void 0;
se.prototype.cause = void 0;
se.prototype.fatal = void 0;
se.prototype.place = void 0;
se.prototype.ruleId = void 0;
se.prototype.source = void 0;
const wi = {}.hasOwnProperty, _h = /* @__PURE__ */ new Map(), $h = /[A-Z]/g, em = /-([a-z])/g, tm = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), nm = /* @__PURE__ */ new Set(["td", "th"]), jl = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function rm(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = dm(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = cm(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? bi : zh,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, a = Vl(i, e, void 0);
  return a && typeof a != "string" ? a : i.create(
    e,
    i.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function Vl(e, t, n) {
  if (t.type === "element")
    return im(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return am(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return lm(e, t, n);
  if (t.type === "mdxjsEsm")
    return om(e, t);
  if (t.type === "root")
    return um(e, t, n);
  if (t.type === "text")
    return sm(e, t);
}
function im(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = bi, e.schema = i), e.ancestors.push(t);
  const a = Ql(e, t.tagName, !1), o = fm(e, t);
  let l = Ai(e, t);
  return tm.has(t.tagName) && (l = l.filter(function(s) {
    return typeof s == "string" ? !Ah(s) : !0;
  })), Hl(e, o, a, t), xi(o, l), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function am(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  $t(e, t.position);
}
function om(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  $t(e, t.position);
}
function lm(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = bi, e.schema = i), e.ancestors.push(t);
  const a = t.name === null ? e.Fragment : Ql(e, t.name, !0), o = hm(e, t), l = Ai(e, t);
  return Hl(e, o, a, t), xi(o, l), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function um(e, t, n) {
  const r = {};
  return xi(r, Ai(e, t)), e.create(t, e.Fragment, r, n);
}
function sm(e, t) {
  return t.value;
}
function Hl(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function xi(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function cm(e, t, n) {
  return r;
  function r(i, a, o, l) {
    const u = Array.isArray(o.children) ? n : t;
    return l ? u(a, o, l) : u(a, o);
  }
}
function dm(e, t) {
  return n;
  function n(r, i, a, o) {
    const l = Array.isArray(a.children), s = vi(r);
    return t(
      i,
      a,
      o,
      l,
      {
        columnNumber: s ? s.column - 1 : void 0,
        fileName: e,
        lineNumber: s ? s.line : void 0
      },
      void 0
    );
  }
}
function fm(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && wi.call(t.properties, i)) {
      const a = mm(e, i, t.properties[i]);
      if (a) {
        const [o, l] = a;
        e.tableCellAlignToStyle && o === "align" && typeof l == "string" && nm.has(t.tagName) ? r = l : n[o] = l;
      }
    }
  if (r) {
    const a = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    a[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function hm(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const a = r.data.estree.body[0];
        a.type;
        const o = a.expression;
        o.type;
        const l = o.properties[0];
        l.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        $t(e, t.position);
    else {
      const i = r.name;
      let a;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const l = r.value.data.estree.body[0];
          l.type, a = e.evaluater.evaluateExpression(l.expression);
        } else
          $t(e, t.position);
      else
        a = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      a;
    }
  return n;
}
function Ai(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : _h;
  for (; ++r < t.children.length; ) {
    const a = t.children[r];
    let o;
    if (e.passKeys) {
      const s = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (s) {
        const u = i.get(s) || 0;
        o = s + "-" + u, i.set(s, u + 1);
      }
    }
    const l = Vl(e, a, o);
    l !== void 0 && n.push(l);
  }
  return n;
}
function mm(e, t, n) {
  const r = Oh(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? yh(n) : Bh(n)), r.property === "style") {
      let i = typeof n == "object" ? n : pm(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = gm(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? Dh[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function pm(e, t) {
  const n = {};
  try {
    Xh(t, r);
  } catch (i) {
    if (!e.ignoreInvalidStyle) {
      const a = (
        /** @type {Error} */
        i
      ), o = new se("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: a,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw o.file = e.filePath || void 0, o.url = jl + "#cannot-parse-style-attribute", o;
    }
  }
  return n;
  function r(i, a) {
    let o = i;
    o.slice(0, 2) !== "--" && (o.slice(0, 4) === "-ms-" && (o = "ms-" + o.slice(4)), o = o.replace(em, bm)), n[o] = a;
  }
}
function Ql(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let a = -1, o;
    for (; ++a < i.length; ) {
      const l = Ta(i[a]) ? { type: "Identifier", name: i[a] } : { type: "Literal", value: i[a] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: l,
        computed: !!(a && l.type === "Literal"),
        optional: !1
      } : l;
    }
    r = o;
  } else
    r = Ta(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return wi.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  $t(e);
}
function $t(e, t) {
  const n = new se(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = jl + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function gm(e) {
  const t = {};
  let n;
  for (n in e)
    wi.call(e, n) && (t[ym(n)] = e[n]);
  return t;
}
function ym(e) {
  let t = e.replace($h, vm);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function bm(e, t) {
  return t.toUpperCase();
}
function vm(e) {
  return "-" + e.toLowerCase();
}
const fr = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, wm = {};
function xm(e, t) {
  const n = t || wm, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Ul(e, r, i);
}
function Ul(e, t, n) {
  if (Am(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Qa(e.children, t, n);
  }
  return Array.isArray(e) ? Qa(e, t, n) : "";
}
function Qa(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Ul(e[i], t, n);
  return r.join("");
}
function Am(e) {
  return !!(e && typeof e == "object");
}
const Ua = document.createElement("i");
function ki(e) {
  const t = "&" + e + ";";
  Ua.innerHTML = t;
  const n = Ua.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Fe(e, t, n, r) {
  const i = e.length;
  let a = 0, o;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); a < r.length; )
      o = r.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function xe(e, t) {
  return e.length > 0 ? (Fe(e, e.length, 0, t), e) : t;
}
const Wa = {}.hasOwnProperty;
function km(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    Cm(t, e[n]);
  return t;
}
function Cm(e, t) {
  let n;
  for (n in t) {
    const i = (Wa.call(e, n) ? e[n] : void 0) || (e[n] = {}), a = t[n];
    let o;
    if (a)
      for (o in a) {
        Wa.call(i, o) || (i[o] = []);
        const l = a[o];
        Em(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function Em(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Fe(e, 0, 0, r);
}
function Wl(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function yt(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Sm = Ke(/\p{P}/u), Le = Ke(/[A-Za-z]/), be = Ke(/[\dA-Za-z]/), Nm = Ke(/[#-'*+\--9=?A-Z^-~]/);
function Ur(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Wr = Ke(/\d/), Mm = Ke(/[\dA-Fa-f]/), ql = Ke(/[!-/:-@[-`{-~]/);
function F(e) {
  return e !== null && e < -2;
}
function fe(e) {
  return e !== null && (e < 0 || e === 32);
}
function J(e) {
  return e === -2 || e === -1 || e === 32;
}
function Om(e) {
  return ql(e) || Sm(e);
}
const Tm = Ke(/\s/);
function Ke(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function St(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const a = e.charCodeAt(n);
    let o = "";
    if (a === 37 && be(e.charCodeAt(n + 1)) && be(e.charCodeAt(n + 2)))
      i = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const l = e.charCodeAt(n + 1);
      a < 56320 && l > 56319 && l < 57344 ? (o = String.fromCharCode(a, l), i = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, o = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function $(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(s) {
    return J(s) ? (e.enter(n), l(s)) : t(s);
  }
  function l(s) {
    return J(s) && a++ < i ? (e.consume(s), l) : (e.exit(n), t(s));
  }
}
const Pm = {
  tokenize: Dm
};
function Dm(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), $(e, t, "linePrefix");
  }
  function i(l) {
    return e.enter("paragraph"), a(l);
  }
  function a(l) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = s), n = s, o(l);
  }
  function o(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return F(l) ? (e.consume(l), e.exit("chunkText"), a) : (e.consume(l), o);
  }
}
const zm = {
  tokenize: Bm
}, qa = {
  tokenize: Lm
};
function Bm(e) {
  const t = this, n = [];
  let r = 0, i, a, o;
  return l;
  function l(x) {
    if (r < n.length) {
      const T = n[r];
      return t.containerState = T[1], e.attempt(
        T[0].continuation,
        s,
        u
      )(x);
    }
    return u(x);
  }
  function s(x) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && A();
      const T = t.events.length;
      let N = T, k;
      for (; N--; )
        if (t.events[N][0] === "exit" && t.events[N][1].type === "chunkFlow") {
          k = t.events[N][1].end;
          break;
        }
      b(r);
      let B = T;
      for (; B < t.events.length; )
        t.events[B][1].end = Object.assign({}, k), B++;
      return Fe(
        t.events,
        N + 1,
        0,
        t.events.slice(T)
      ), t.events.length = B, u(x);
    }
    return l(x);
  }
  function u(x) {
    if (r === n.length) {
      if (!i)
        return h(x);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return y(x);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      qa,
      d,
      c
    )(x);
  }
  function d(x) {
    return i && A(), b(r), h(x);
  }
  function c(x) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, y(x);
  }
  function h(x) {
    return t.containerState = {}, e.attempt(
      qa,
      f,
      y
    )(x);
  }
  function f(x) {
    return r++, n.push([t.currentConstruct, t.containerState]), h(x);
  }
  function y(x) {
    if (x === null) {
      i && A(), b(0), e.consume(x);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: a,
      _tokenizer: i
    }), v(x);
  }
  function v(x) {
    if (x === null) {
      C(e.exit("chunkFlow"), !0), b(0), e.consume(x);
      return;
    }
    return F(x) ? (e.consume(x), C(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, l) : (e.consume(x), v);
  }
  function C(x, T) {
    const N = t.sliceStream(x);
    if (T && N.push(null), x.previous = a, a && (a.next = x), a = x, i.defineSkip(x.start), i.write(N), t.parser.lazy[x.start.line]) {
      let k = i.events.length;
      for (; k--; )
        if (
          // The token starts before the line ending…
          i.events[k][1].start.offset < o && // …and either is not ended yet…
          (!i.events[k][1].end || // …or ends after it.
          i.events[k][1].end.offset > o)
        )
          return;
      const B = t.events.length;
      let U = B, I, R;
      for (; U--; )
        if (t.events[U][0] === "exit" && t.events[U][1].type === "chunkFlow") {
          if (I) {
            R = t.events[U][1].end;
            break;
          }
          I = !0;
        }
      for (b(r), k = B; k < t.events.length; )
        t.events[k][1].end = Object.assign({}, R), k++;
      Fe(
        t.events,
        U + 1,
        0,
        t.events.slice(B)
      ), t.events.length = k;
    }
  }
  function b(x) {
    let T = n.length;
    for (; T-- > x; ) {
      const N = n[T];
      t.containerState = N[1], N[0].exit.call(t, e);
    }
    n.length = x;
  }
  function A() {
    i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function Lm(e, t, n) {
  return $(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Ya(e) {
  if (e === null || fe(e) || Tm(e))
    return 1;
  if (Om(e))
    return 2;
}
function Ci(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (t = a(t, n), r.push(a));
  }
  return t;
}
const qr = {
  name: "attention",
  tokenize: Fm,
  resolveAll: Im
};
function Im(e, t) {
  let n = -1, r, i, a, o, l, s, u, d;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          s = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const c = Object.assign({}, e[r][1].end), h = Object.assign({}, e[n][1].start);
          Za(c, -s), Za(h, s), o = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: c,
            end: Object.assign({}, e[r][1].end)
          }, l = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: h
          }, a = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: Object.assign({}, o.start),
            end: Object.assign({}, l.end)
          }, e[r][1].end = Object.assign({}, o.start), e[n][1].start = Object.assign({}, l.end), u = [], e[r][1].end.offset - e[r][1].start.offset && (u = xe(u, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), u = xe(u, [
            ["enter", i, t],
            ["enter", o, t],
            ["exit", o, t],
            ["enter", a, t]
          ]), u = xe(
            u,
            Ci(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), u = xe(u, [
            ["exit", a, t],
            ["enter", l, t],
            ["exit", l, t],
            ["exit", i, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (d = 2, u = xe(u, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : d = 0, Fe(e, r - 1, n - r + 3, u), n = r + u.length - d - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function Fm(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Ya(r);
  let a;
  return o;
  function o(s) {
    return a = s, e.enter("attentionSequence"), l(s);
  }
  function l(s) {
    if (s === a)
      return e.consume(s), l;
    const u = e.exit("attentionSequence"), d = Ya(s), c = !d || d === 2 && i || n.includes(s), h = !i || i === 2 && d || n.includes(r);
    return u._open = !!(a === 42 ? c : c && (i || !h)), u._close = !!(a === 42 ? h : h && (d || !c)), t(s);
  }
}
function Za(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Rm = {
  name: "autolink",
  tokenize: jm
};
function jm(e, t, n) {
  let r = 0;
  return i;
  function i(f) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(f) {
    return Le(f) ? (e.consume(f), o) : u(f);
  }
  function o(f) {
    return f === 43 || f === 45 || f === 46 || be(f) ? (r = 1, l(f)) : u(f);
  }
  function l(f) {
    return f === 58 ? (e.consume(f), r = 0, s) : (f === 43 || f === 45 || f === 46 || be(f)) && r++ < 32 ? (e.consume(f), l) : (r = 0, u(f));
  }
  function s(f) {
    return f === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), t) : f === null || f === 32 || f === 60 || Ur(f) ? n(f) : (e.consume(f), s);
  }
  function u(f) {
    return f === 64 ? (e.consume(f), d) : Nm(f) ? (e.consume(f), u) : n(f);
  }
  function d(f) {
    return be(f) ? c(f) : n(f);
  }
  function c(f) {
    return f === 46 ? (e.consume(f), r = 0, d) : f === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), t) : h(f);
  }
  function h(f) {
    if ((f === 45 || be(f)) && r++ < 63) {
      const y = f === 45 ? h : c;
      return e.consume(f), y;
    }
    return n(f);
  }
}
const Xn = {
  tokenize: Vm,
  partial: !0
};
function Vm(e, t, n) {
  return r;
  function r(a) {
    return J(a) ? $(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || F(a) ? t(a) : n(a);
  }
}
const Yl = {
  name: "blockQuote",
  tokenize: Hm,
  continuation: {
    tokenize: Qm
  },
  exit: Um
};
function Hm(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const l = r.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return n(o);
  }
  function a(o) {
    return J(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function Qm(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return J(o) ? $(
      e,
      a,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(o) : a(o);
  }
  function a(o) {
    return e.attempt(Yl, t, n)(o);
  }
}
function Um(e) {
  e.exit("blockQuote");
}
const Zl = {
  name: "characterEscape",
  tokenize: Wm
};
function Wm(e, t, n) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return ql(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
const Gl = {
  name: "characterReference",
  tokenize: qm
};
function qm(e, t, n) {
  const r = this;
  let i = 0, a, o;
  return l;
  function l(c) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(c), e.exit("characterReferenceMarker"), s;
  }
  function s(c) {
    return c === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(c), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), a = 31, o = be, d(c));
  }
  function u(c) {
    return c === 88 || c === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(c), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = Mm, d) : (e.enter("characterReferenceValue"), a = 7, o = Wr, d(c));
  }
  function d(c) {
    if (c === 59 && i) {
      const h = e.exit("characterReferenceValue");
      return o === be && !ki(r.sliceSerialize(h)) ? n(c) : (e.enter("characterReferenceMarker"), e.consume(c), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(c) && i++ < a ? (e.consume(c), d) : n(c);
  }
}
const Ga = {
  tokenize: Zm,
  partial: !0
}, Ja = {
  name: "codeFenced",
  tokenize: Ym,
  concrete: !0
};
function Ym(e, t, n) {
  const r = this, i = {
    tokenize: N,
    partial: !0
  };
  let a = 0, o = 0, l;
  return s;
  function s(k) {
    return u(k);
  }
  function u(k) {
    const B = r.events[r.events.length - 1];
    return a = B && B[1].type === "linePrefix" ? B[2].sliceSerialize(B[1], !0).length : 0, l = k, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(k);
  }
  function d(k) {
    return k === l ? (o++, e.consume(k), d) : o < 3 ? n(k) : (e.exit("codeFencedFenceSequence"), J(k) ? $(e, c, "whitespace")(k) : c(k));
  }
  function c(k) {
    return k === null || F(k) ? (e.exit("codeFencedFence"), r.interrupt ? t(k) : e.check(Ga, v, T)(k)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(k));
  }
  function h(k) {
    return k === null || F(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), c(k)) : J(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), $(e, f, "whitespace")(k)) : k === 96 && k === l ? n(k) : (e.consume(k), h);
  }
  function f(k) {
    return k === null || F(k) ? c(k) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), y(k));
  }
  function y(k) {
    return k === null || F(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), c(k)) : k === 96 && k === l ? n(k) : (e.consume(k), y);
  }
  function v(k) {
    return e.attempt(i, T, C)(k);
  }
  function C(k) {
    return e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), b;
  }
  function b(k) {
    return a > 0 && J(k) ? $(
      e,
      A,
      "linePrefix",
      a + 1
    )(k) : A(k);
  }
  function A(k) {
    return k === null || F(k) ? e.check(Ga, v, T)(k) : (e.enter("codeFlowValue"), x(k));
  }
  function x(k) {
    return k === null || F(k) ? (e.exit("codeFlowValue"), A(k)) : (e.consume(k), x);
  }
  function T(k) {
    return e.exit("codeFenced"), t(k);
  }
  function N(k, B, U) {
    let I = 0;
    return R;
    function R(L) {
      return k.enter("lineEnding"), k.consume(L), k.exit("lineEnding"), D;
    }
    function D(L) {
      return k.enter("codeFencedFence"), J(L) ? $(
        k,
        z,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(L) : z(L);
    }
    function z(L) {
      return L === l ? (k.enter("codeFencedFenceSequence"), Q(L)) : U(L);
    }
    function Q(L) {
      return L === l ? (I++, k.consume(L), Q) : I >= o ? (k.exit("codeFencedFenceSequence"), J(L) ? $(k, Y, "whitespace")(L) : Y(L)) : U(L);
    }
    function Y(L) {
      return L === null || F(L) ? (k.exit("codeFencedFence"), B(L)) : U(L);
    }
  }
}
function Zm(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
const hr = {
  name: "codeIndented",
  tokenize: Jm
}, Gm = {
  tokenize: Xm,
  partial: !0
};
function Jm(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), $(e, a, "linePrefix", 4 + 1)(u);
  }
  function a(u) {
    const d = r.events[r.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? o(u) : n(u);
  }
  function o(u) {
    return u === null ? s(u) : F(u) ? e.attempt(Gm, o, s)(u) : (e.enter("codeFlowValue"), l(u));
  }
  function l(u) {
    return u === null || F(u) ? (e.exit("codeFlowValue"), o(u)) : (e.consume(u), l);
  }
  function s(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function Xm(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : F(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : $(e, a, "linePrefix", 4 + 1)(o);
  }
  function a(o) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(o) : F(o) ? i(o) : n(o);
  }
}
const Km = {
  name: "codeText",
  tokenize: ep,
  resolve: _m,
  previous: $m
};
function _m(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function $m(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function ep(e, t, n) {
  let r = 0, i, a;
  return o;
  function o(c) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(c);
  }
  function l(c) {
    return c === 96 ? (e.consume(c), r++, l) : (e.exit("codeTextSequence"), s(c));
  }
  function s(c) {
    return c === null ? n(c) : c === 32 ? (e.enter("space"), e.consume(c), e.exit("space"), s) : c === 96 ? (a = e.enter("codeTextSequence"), i = 0, d(c)) : F(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), s) : (e.enter("codeTextData"), u(c));
  }
  function u(c) {
    return c === null || c === 32 || c === 96 || F(c) ? (e.exit("codeTextData"), s(c)) : (e.consume(c), u);
  }
  function d(c) {
    return c === 96 ? (e.consume(c), i++, d) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(c)) : (a.type = "codeTextData", u(c));
  }
}
function Jl(e) {
  const t = {};
  let n = -1, r, i, a, o, l, s, u;
  for (; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (s = r[1]._tokenizer.events, a = 0, a < s.length && s[a][1].type === "lineEndingBlank" && (a += 2), a < s.length && s[a][1].type === "content"))
      for (; ++a < s.length && s[a][1].type !== "content"; )
        s[a][1].type === "chunkText" && (s[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, tp(e, n)), n = t[n], u = !0);
    else if (r[1]._container) {
      for (a = n, i = void 0; a-- && (o = e[a], o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
      i && (r[1].end = Object.assign({}, e[i][1].start), l = e.slice(i, n), l.unshift(r), Fe(e, i, n - i + 1, l));
    }
  }
  return !u;
}
function tp(e, t) {
  const n = e[t][1], r = e[t][2];
  let i = t - 1;
  const a = [], o = n._tokenizer || r.parser[n.contentType](n.start), l = o.events, s = [], u = {};
  let d, c, h = -1, f = n, y = 0, v = 0;
  const C = [v];
  for (; f; ) {
    for (; e[++i][1] !== f; )
      ;
    a.push(i), f._tokenizer || (d = r.sliceStream(f), f.next || d.push(null), c && o.defineSkip(f.start), f._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(d), f._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), c = f, f = f.next;
  }
  for (f = n; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (v = h + 1, C.push(v), f._tokenizer = void 0, f.previous = void 0, f = f.next);
  for (o.events = [], f ? (f._tokenizer = void 0, f.previous = void 0) : C.pop(), h = C.length; h--; ) {
    const b = l.slice(C[h], C[h + 1]), A = a.pop();
    s.unshift([A, A + b.length - 1]), Fe(e, A, 2, b);
  }
  for (h = -1; ++h < s.length; )
    u[y + s[h][0]] = y + s[h][1], y += s[h][1] - s[h][0] - 1;
  return u;
}
const np = {
  tokenize: ap,
  resolve: ip
}, rp = {
  tokenize: op,
  partial: !0
};
function ip(e) {
  return Jl(e), e;
}
function ap(e, t) {
  let n;
  return r;
  function r(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(l);
  }
  function i(l) {
    return l === null ? a(l) : F(l) ? e.check(
      rp,
      o,
      a
    )(l) : (e.consume(l), i);
  }
  function a(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function o(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function op(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), $(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || F(o))
      return n(o);
    const l = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function Xl(e, t, n, r, i, a, o, l, s) {
  const u = s || Number.POSITIVE_INFINITY;
  let d = 0;
  return c;
  function c(b) {
    return b === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(b), e.exit(a), h) : b === null || b === 32 || b === 41 || Ur(b) ? n(b) : (e.enter(r), e.enter(o), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(b));
  }
  function h(b) {
    return b === 62 ? (e.enter(a), e.consume(b), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), f(b));
  }
  function f(b) {
    return b === 62 ? (e.exit("chunkString"), e.exit(l), h(b)) : b === null || b === 60 || F(b) ? n(b) : (e.consume(b), b === 92 ? y : f);
  }
  function y(b) {
    return b === 60 || b === 62 || b === 92 ? (e.consume(b), f) : f(b);
  }
  function v(b) {
    return !d && (b === null || b === 41 || fe(b)) ? (e.exit("chunkString"), e.exit(l), e.exit(o), e.exit(r), t(b)) : d < u && b === 40 ? (e.consume(b), d++, v) : b === 41 ? (e.consume(b), d--, v) : b === null || b === 32 || b === 40 || Ur(b) ? n(b) : (e.consume(b), b === 92 ? C : v);
  }
  function C(b) {
    return b === 40 || b === 41 || b === 92 ? (e.consume(b), v) : v(b);
  }
}
function Kl(e, t, n, r, i, a) {
  const o = this;
  let l = 0, s;
  return u;
  function u(f) {
    return e.enter(r), e.enter(i), e.consume(f), e.exit(i), e.enter(a), d;
  }
  function d(f) {
    return l > 999 || f === null || f === 91 || f === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    f === 94 && !l && "_hiddenFootnoteSupport" in o.parser.constructs ? n(f) : f === 93 ? (e.exit(a), e.enter(i), e.consume(f), e.exit(i), e.exit(r), t) : F(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), c(f));
  }
  function c(f) {
    return f === null || f === 91 || f === 93 || F(f) || l++ > 999 ? (e.exit("chunkString"), d(f)) : (e.consume(f), s || (s = !J(f)), f === 92 ? h : c);
  }
  function h(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), l++, c) : c(f);
  }
}
function _l(e, t, n, r, i, a) {
  let o;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(r), e.enter(i), e.consume(h), e.exit(i), o = h === 40 ? 41 : h, s) : n(h);
  }
  function s(h) {
    return h === o ? (e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : (e.enter(a), u(h));
  }
  function u(h) {
    return h === o ? (e.exit(a), s(o)) : h === null ? n(h) : F(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), $(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === o || h === null || F(h) ? (e.exit("chunkString"), u(h)) : (e.consume(h), h === 92 ? c : d);
  }
  function c(h) {
    return h === o || h === 92 ? (e.consume(h), d) : d(h);
  }
}
function Qt(e, t) {
  let n;
  return r;
  function r(i) {
    return F(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : J(i) ? $(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
const lp = {
  name: "definition",
  tokenize: sp
}, up = {
  tokenize: cp,
  partial: !0
};
function sp(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(f) {
    return e.enter("definition"), o(f);
  }
  function o(f) {
    return Kl.call(
      r,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(f);
  }
  function l(f) {
    return i = yt(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), f === 58 ? (e.enter("definitionMarker"), e.consume(f), e.exit("definitionMarker"), s) : n(f);
  }
  function s(f) {
    return fe(f) ? Qt(e, u)(f) : u(f);
  }
  function u(f) {
    return Xl(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(f);
  }
  function d(f) {
    return e.attempt(up, c, c)(f);
  }
  function c(f) {
    return J(f) ? $(e, h, "whitespace")(f) : h(f);
  }
  function h(f) {
    return f === null || F(f) ? (e.exit("definition"), r.parser.defined.push(i), t(f)) : n(f);
  }
}
function cp(e, t, n) {
  return r;
  function r(l) {
    return fe(l) ? Qt(e, i)(l) : n(l);
  }
  function i(l) {
    return _l(
      e,
      a,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(l);
  }
  function a(l) {
    return J(l) ? $(e, o, "whitespace")(l) : o(l);
  }
  function o(l) {
    return l === null || F(l) ? t(l) : n(l);
  }
}
const dp = {
  name: "hardBreakEscape",
  tokenize: fp
};
function fp(e, t, n) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return F(a) ? (e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
const hp = {
  name: "headingAtx",
  tokenize: pp,
  resolve: mp
};
function mp(e, t) {
  let n = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Fe(e, r, n - r + 1, [
    ["enter", i, t],
    ["enter", a, t],
    ["exit", a, t],
    ["exit", i, t]
  ])), e;
}
function pp(e, t, n) {
  let r = 0;
  return i;
  function i(d) {
    return e.enter("atxHeading"), a(d);
  }
  function a(d) {
    return e.enter("atxHeadingSequence"), o(d);
  }
  function o(d) {
    return d === 35 && r++ < 6 ? (e.consume(d), o) : d === null || fe(d) ? (e.exit("atxHeadingSequence"), l(d)) : n(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), s(d)) : d === null || F(d) ? (e.exit("atxHeading"), t(d)) : J(d) ? $(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), u(d));
  }
  function s(d) {
    return d === 35 ? (e.consume(d), s) : (e.exit("atxHeadingSequence"), l(d));
  }
  function u(d) {
    return d === null || d === 35 || fe(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), u);
  }
}
const gp = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Xa = ["pre", "script", "style", "textarea"], yp = {
  name: "htmlFlow",
  tokenize: xp,
  resolveTo: wp,
  concrete: !0
}, bp = {
  tokenize: kp,
  partial: !0
}, vp = {
  tokenize: Ap,
  partial: !0
};
function wp(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function xp(e, t, n) {
  const r = this;
  let i, a, o, l, s;
  return u;
  function u(p) {
    return d(p);
  }
  function d(p) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(p), c;
  }
  function c(p) {
    return p === 33 ? (e.consume(p), h) : p === 47 ? (e.consume(p), a = !0, v) : p === 63 ? (e.consume(p), i = 3, r.interrupt ? t : g) : Le(p) ? (e.consume(p), o = String.fromCharCode(p), C) : n(p);
  }
  function h(p) {
    return p === 45 ? (e.consume(p), i = 2, f) : p === 91 ? (e.consume(p), i = 5, l = 0, y) : Le(p) ? (e.consume(p), i = 4, r.interrupt ? t : g) : n(p);
  }
  function f(p) {
    return p === 45 ? (e.consume(p), r.interrupt ? t : g) : n(p);
  }
  function y(p) {
    const Ee = "CDATA[";
    return p === Ee.charCodeAt(l++) ? (e.consume(p), l === Ee.length ? r.interrupt ? t : z : y) : n(p);
  }
  function v(p) {
    return Le(p) ? (e.consume(p), o = String.fromCharCode(p), C) : n(p);
  }
  function C(p) {
    if (p === null || p === 47 || p === 62 || fe(p)) {
      const Ee = p === 47, _e = o.toLowerCase();
      return !Ee && !a && Xa.includes(_e) ? (i = 1, r.interrupt ? t(p) : z(p)) : gp.includes(o.toLowerCase()) ? (i = 6, Ee ? (e.consume(p), b) : r.interrupt ? t(p) : z(p)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(p) : a ? A(p) : x(p));
    }
    return p === 45 || be(p) ? (e.consume(p), o += String.fromCharCode(p), C) : n(p);
  }
  function b(p) {
    return p === 62 ? (e.consume(p), r.interrupt ? t : z) : n(p);
  }
  function A(p) {
    return J(p) ? (e.consume(p), A) : R(p);
  }
  function x(p) {
    return p === 47 ? (e.consume(p), R) : p === 58 || p === 95 || Le(p) ? (e.consume(p), T) : J(p) ? (e.consume(p), x) : R(p);
  }
  function T(p) {
    return p === 45 || p === 46 || p === 58 || p === 95 || be(p) ? (e.consume(p), T) : N(p);
  }
  function N(p) {
    return p === 61 ? (e.consume(p), k) : J(p) ? (e.consume(p), N) : x(p);
  }
  function k(p) {
    return p === null || p === 60 || p === 61 || p === 62 || p === 96 ? n(p) : p === 34 || p === 39 ? (e.consume(p), s = p, B) : J(p) ? (e.consume(p), k) : U(p);
  }
  function B(p) {
    return p === s ? (e.consume(p), s = null, I) : p === null || F(p) ? n(p) : (e.consume(p), B);
  }
  function U(p) {
    return p === null || p === 34 || p === 39 || p === 47 || p === 60 || p === 61 || p === 62 || p === 96 || fe(p) ? N(p) : (e.consume(p), U);
  }
  function I(p) {
    return p === 47 || p === 62 || J(p) ? x(p) : n(p);
  }
  function R(p) {
    return p === 62 ? (e.consume(p), D) : n(p);
  }
  function D(p) {
    return p === null || F(p) ? z(p) : J(p) ? (e.consume(p), D) : n(p);
  }
  function z(p) {
    return p === 45 && i === 2 ? (e.consume(p), Z) : p === 60 && i === 1 ? (e.consume(p), ee) : p === 62 && i === 4 ? (e.consume(p), he) : p === 63 && i === 3 ? (e.consume(p), g) : p === 93 && i === 5 ? (e.consume(p), Ce) : F(p) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(
      bp,
      ie,
      Q
    )(p)) : p === null || F(p) ? (e.exit("htmlFlowData"), Q(p)) : (e.consume(p), z);
  }
  function Q(p) {
    return e.check(
      vp,
      Y,
      ie
    )(p);
  }
  function Y(p) {
    return e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), L;
  }
  function L(p) {
    return p === null || F(p) ? Q(p) : (e.enter("htmlFlowData"), z(p));
  }
  function Z(p) {
    return p === 45 ? (e.consume(p), g) : z(p);
  }
  function ee(p) {
    return p === 47 ? (e.consume(p), o = "", te) : z(p);
  }
  function te(p) {
    if (p === 62) {
      const Ee = o.toLowerCase();
      return Xa.includes(Ee) ? (e.consume(p), he) : z(p);
    }
    return Le(p) && o.length < 8 ? (e.consume(p), o += String.fromCharCode(p), te) : z(p);
  }
  function Ce(p) {
    return p === 93 ? (e.consume(p), g) : z(p);
  }
  function g(p) {
    return p === 62 ? (e.consume(p), he) : p === 45 && i === 2 ? (e.consume(p), g) : z(p);
  }
  function he(p) {
    return p === null || F(p) ? (e.exit("htmlFlowData"), ie(p)) : (e.consume(p), he);
  }
  function ie(p) {
    return e.exit("htmlFlow"), t(p);
  }
}
function Ap(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return F(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : n(o);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
function kp(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Xn, t, n);
  }
}
const Cp = {
  name: "htmlText",
  tokenize: Ep
};
function Ep(e, t, n) {
  const r = this;
  let i, a, o;
  return l;
  function l(g) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(g), s;
  }
  function s(g) {
    return g === 33 ? (e.consume(g), u) : g === 47 ? (e.consume(g), N) : g === 63 ? (e.consume(g), x) : Le(g) ? (e.consume(g), U) : n(g);
  }
  function u(g) {
    return g === 45 ? (e.consume(g), d) : g === 91 ? (e.consume(g), a = 0, y) : Le(g) ? (e.consume(g), A) : n(g);
  }
  function d(g) {
    return g === 45 ? (e.consume(g), f) : n(g);
  }
  function c(g) {
    return g === null ? n(g) : g === 45 ? (e.consume(g), h) : F(g) ? (o = c, ee(g)) : (e.consume(g), c);
  }
  function h(g) {
    return g === 45 ? (e.consume(g), f) : c(g);
  }
  function f(g) {
    return g === 62 ? Z(g) : g === 45 ? h(g) : c(g);
  }
  function y(g) {
    const he = "CDATA[";
    return g === he.charCodeAt(a++) ? (e.consume(g), a === he.length ? v : y) : n(g);
  }
  function v(g) {
    return g === null ? n(g) : g === 93 ? (e.consume(g), C) : F(g) ? (o = v, ee(g)) : (e.consume(g), v);
  }
  function C(g) {
    return g === 93 ? (e.consume(g), b) : v(g);
  }
  function b(g) {
    return g === 62 ? Z(g) : g === 93 ? (e.consume(g), b) : v(g);
  }
  function A(g) {
    return g === null || g === 62 ? Z(g) : F(g) ? (o = A, ee(g)) : (e.consume(g), A);
  }
  function x(g) {
    return g === null ? n(g) : g === 63 ? (e.consume(g), T) : F(g) ? (o = x, ee(g)) : (e.consume(g), x);
  }
  function T(g) {
    return g === 62 ? Z(g) : x(g);
  }
  function N(g) {
    return Le(g) ? (e.consume(g), k) : n(g);
  }
  function k(g) {
    return g === 45 || be(g) ? (e.consume(g), k) : B(g);
  }
  function B(g) {
    return F(g) ? (o = B, ee(g)) : J(g) ? (e.consume(g), B) : Z(g);
  }
  function U(g) {
    return g === 45 || be(g) ? (e.consume(g), U) : g === 47 || g === 62 || fe(g) ? I(g) : n(g);
  }
  function I(g) {
    return g === 47 ? (e.consume(g), Z) : g === 58 || g === 95 || Le(g) ? (e.consume(g), R) : F(g) ? (o = I, ee(g)) : J(g) ? (e.consume(g), I) : Z(g);
  }
  function R(g) {
    return g === 45 || g === 46 || g === 58 || g === 95 || be(g) ? (e.consume(g), R) : D(g);
  }
  function D(g) {
    return g === 61 ? (e.consume(g), z) : F(g) ? (o = D, ee(g)) : J(g) ? (e.consume(g), D) : I(g);
  }
  function z(g) {
    return g === null || g === 60 || g === 61 || g === 62 || g === 96 ? n(g) : g === 34 || g === 39 ? (e.consume(g), i = g, Q) : F(g) ? (o = z, ee(g)) : J(g) ? (e.consume(g), z) : (e.consume(g), Y);
  }
  function Q(g) {
    return g === i ? (e.consume(g), i = void 0, L) : g === null ? n(g) : F(g) ? (o = Q, ee(g)) : (e.consume(g), Q);
  }
  function Y(g) {
    return g === null || g === 34 || g === 39 || g === 60 || g === 61 || g === 96 ? n(g) : g === 47 || g === 62 || fe(g) ? I(g) : (e.consume(g), Y);
  }
  function L(g) {
    return g === 47 || g === 62 || fe(g) ? I(g) : n(g);
  }
  function Z(g) {
    return g === 62 ? (e.consume(g), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(g);
  }
  function ee(g) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), te;
  }
  function te(g) {
    return J(g) ? $(
      e,
      Ce,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(g) : Ce(g);
  }
  function Ce(g) {
    return e.enter("htmlTextData"), o(g);
  }
}
const Ei = {
  name: "labelEnd",
  tokenize: Pp,
  resolveTo: Tp,
  resolveAll: Op
}, Sp = {
  tokenize: Dp
}, Np = {
  tokenize: zp
}, Mp = {
  tokenize: Bp
};
function Op(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function Tp(e, t) {
  let n = e.length, r = 0, i, a, o, l;
  for (; n--; )
    if (i = e[n][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (o = n);
  const s = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, u = {
    type: "label",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[o][1].end)
  }, d = {
    type: "labelText",
    start: Object.assign({}, e[a + r + 2][1].end),
    end: Object.assign({}, e[o - 2][1].start)
  };
  return l = [
    ["enter", s, t],
    ["enter", u, t]
  ], l = xe(l, e.slice(a + 1, a + r + 3)), l = xe(l, [["enter", d, t]]), l = xe(
    l,
    Ci(
      t.parser.constructs.insideSpan.null,
      e.slice(a + r + 4, o - 3),
      t
    )
  ), l = xe(l, [
    ["exit", d, t],
    e[o - 2],
    e[o - 1],
    ["exit", u, t]
  ]), l = xe(l, e.slice(o + 1)), l = xe(l, [["exit", s, t]]), Fe(e, a, e.length, l), e;
}
function Pp(e, t, n) {
  const r = this;
  let i = r.events.length, a, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return l;
  function l(h) {
    return a ? a._inactive ? c(h) : (o = r.parser.defined.includes(
      yt(
        r.sliceSerialize({
          start: a.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), s) : n(h);
  }
  function s(h) {
    return h === 40 ? e.attempt(
      Sp,
      d,
      o ? d : c
    )(h) : h === 91 ? e.attempt(
      Np,
      d,
      o ? u : c
    )(h) : o ? d(h) : c(h);
  }
  function u(h) {
    return e.attempt(
      Mp,
      d,
      c
    )(h);
  }
  function d(h) {
    return t(h);
  }
  function c(h) {
    return a._balanced = !0, n(h);
  }
}
function Dp(e, t, n) {
  return r;
  function r(c) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(c), e.exit("resourceMarker"), i;
  }
  function i(c) {
    return fe(c) ? Qt(e, a)(c) : a(c);
  }
  function a(c) {
    return c === 41 ? d(c) : Xl(
      e,
      o,
      l,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(c);
  }
  function o(c) {
    return fe(c) ? Qt(e, s)(c) : d(c);
  }
  function l(c) {
    return n(c);
  }
  function s(c) {
    return c === 34 || c === 39 || c === 40 ? _l(
      e,
      u,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(c) : d(c);
  }
  function u(c) {
    return fe(c) ? Qt(e, d)(c) : d(c);
  }
  function d(c) {
    return c === 41 ? (e.enter("resourceMarker"), e.consume(c), e.exit("resourceMarker"), e.exit("resource"), t) : n(c);
  }
}
function zp(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return Kl.call(
      r,
      e,
      a,
      o,
      "reference",
      "referenceMarker",
      "referenceString"
    )(l);
  }
  function a(l) {
    return r.parser.defined.includes(
      yt(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(l) : n(l);
  }
  function o(l) {
    return n(l);
  }
}
function Bp(e, t, n) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
const Lp = {
  name: "labelStartImage",
  tokenize: Ip,
  resolveAll: Ei.resolveAll
};
function Ip(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), a;
  }
  function a(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), o) : n(l);
  }
  function o(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
  }
}
const Fp = {
  name: "labelStartLink",
  tokenize: Rp,
  resolveAll: Ei.resolveAll
};
function Rp(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const mr = {
  name: "lineEnding",
  tokenize: jp
};
function jp(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), $(e, t, "linePrefix");
  }
}
const An = {
  name: "thematicBreak",
  tokenize: Vp
};
function Vp(e, t, n) {
  let r = 0, i;
  return a;
  function a(u) {
    return e.enter("thematicBreak"), o(u);
  }
  function o(u) {
    return i = u, l(u);
  }
  function l(u) {
    return u === i ? (e.enter("thematicBreakSequence"), s(u)) : r >= 3 && (u === null || F(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function s(u) {
    return u === i ? (e.consume(u), r++, s) : (e.exit("thematicBreakSequence"), J(u) ? $(e, l, "whitespace")(u) : l(u));
  }
}
const ce = {
  name: "list",
  tokenize: Up,
  continuation: {
    tokenize: Wp
  },
  exit: Yp
}, Hp = {
  tokenize: Zp,
  partial: !0
}, Qp = {
  tokenize: qp,
  partial: !0
};
function Up(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return l;
  function l(f) {
    const y = r.containerState.type || (f === 42 || f === 43 || f === 45 ? "listUnordered" : "listOrdered");
    if (y === "listUnordered" ? !r.containerState.marker || f === r.containerState.marker : Wr(f)) {
      if (r.containerState.type || (r.containerState.type = y, e.enter(y, {
        _container: !0
      })), y === "listUnordered")
        return e.enter("listItemPrefix"), f === 42 || f === 45 ? e.check(An, n, u)(f) : u(f);
      if (!r.interrupt || f === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(f);
    }
    return n(f);
  }
  function s(f) {
    return Wr(f) && ++o < 10 ? (e.consume(f), s) : (!r.interrupt || o < 2) && (r.containerState.marker ? f === r.containerState.marker : f === 41 || f === 46) ? (e.exit("listItemValue"), u(f)) : n(f);
  }
  function u(f) {
    return e.enter("listItemMarker"), e.consume(f), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || f, e.check(
      Xn,
      // Can’t be empty when interrupting.
      r.interrupt ? n : d,
      e.attempt(
        Hp,
        h,
        c
      )
    );
  }
  function d(f) {
    return r.containerState.initialBlankLine = !0, a++, h(f);
  }
  function c(f) {
    return J(f) ? (e.enter("listItemPrefixWhitespace"), e.consume(f), e.exit("listItemPrefixWhitespace"), h) : n(f);
  }
  function h(f) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(f);
  }
}
function Wp(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Xn, i, a);
  function i(l) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, $(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(l);
  }
  function a(l) {
    return r.containerState.furtherBlankLines || !J(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(Qp, t, o)(l));
  }
  function o(l) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, $(
      e,
      e.attempt(ce, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(l);
  }
}
function qp(e, t, n) {
  const r = this;
  return $(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(a) : n(a);
  }
}
function Yp(e) {
  e.exit(this.containerState.type);
}
function Zp(e, t, n) {
  const r = this;
  return $(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function i(a) {
    const o = r.events[r.events.length - 1];
    return !J(a) && o && o[1].type === "listItemPrefixWhitespace" ? t(a) : n(a);
  }
}
const Ka = {
  name: "setextUnderline",
  tokenize: Jp,
  resolveTo: Gp
};
function Gp(e, t) {
  let n = e.length, r, i, a;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  const o = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", o, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[a][1].end)) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function Jp(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(u) {
    let d = r.events.length, c;
    for (; d--; )
      if (r.events[d][1].type !== "lineEnding" && r.events[d][1].type !== "linePrefix" && r.events[d][1].type !== "content") {
        c = r.events[d][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || c) ? (e.enter("setextHeadingLine"), i = u, o(u)) : n(u);
  }
  function o(u) {
    return e.enter("setextHeadingLineSequence"), l(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), l) : (e.exit("setextHeadingLineSequence"), J(u) ? $(e, s, "lineSuffix")(u) : s(u));
  }
  function s(u) {
    return u === null || F(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const Xp = {
  tokenize: Kp
};
function Kp(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Xn,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      $(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(np, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const _p = {
  resolveAll: eu()
}, $p = $l("string"), eg = $l("text");
function $l(e) {
  return {
    tokenize: t,
    resolveAll: eu(
      e === "text" ? tg : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], a = n.attempt(i, o, l);
    return o;
    function o(d) {
      return u(d) ? a(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        n.consume(d);
        return;
      }
      return n.enter("data"), n.consume(d), s;
    }
    function s(d) {
      return u(d) ? (n.exit("data"), a(d)) : (n.consume(d), s);
    }
    function u(d) {
      if (d === null)
        return !0;
      const c = i[d];
      let h = -1;
      if (c)
        for (; ++h < c.length; ) {
          const f = c[h];
          if (!f.previous || f.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function eu(e) {
  return t;
  function t(n, r) {
    let i = -1, a;
    for (; ++i <= n.length; )
      a === void 0 ? n[i] && n[i][1].type === "data" && (a = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== a + 2 && (n[a][1].end = n[i - 1][1].end, n.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(n, r) : n;
  }
}
function tg(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let a = i.length, o = -1, l = 0, s;
      for (; a--; ) {
        const u = i[a];
        if (typeof u == "string") {
          for (o = u.length; u.charCodeAt(o - 1) === 32; )
            l++, o--;
          if (o)
            break;
          o = -1;
        } else if (u === -2)
          s = !0, l++;
        else if (u !== -1) {
          a++;
          break;
        }
      }
      if (l) {
        const u = {
          type: n === e.length || s || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - l,
            offset: r.end.offset - l,
            _index: r.start._index + a,
            _bufferIndex: a ? o : r.start._bufferIndex + o
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, u.start), r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(
          n,
          0,
          ["enter", u, t],
          ["exit", u, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function ng(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, a = [];
  let o = [], l = [];
  const s = {
    consume: A,
    enter: x,
    exit: T,
    attempt: B(N),
    check: B(k),
    interrupt: B(k, {
      interrupt: !0
    })
  }, u = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: f,
    sliceSerialize: h,
    now: y,
    defineSkip: v,
    write: c
  };
  let d = t.tokenize.call(u, s);
  return t.resolveAll && a.push(t), u;
  function c(D) {
    return o = xe(o, D), C(), o[o.length - 1] !== null ? [] : (U(t, 0), u.events = Ci(a, u.events, u), u.events);
  }
  function h(D, z) {
    return ig(f(D), z);
  }
  function f(D) {
    return rg(o, D);
  }
  function y() {
    const { line: D, column: z, offset: Q, _index: Y, _bufferIndex: L } = r;
    return {
      line: D,
      column: z,
      offset: Q,
      _index: Y,
      _bufferIndex: L
    };
  }
  function v(D) {
    i[D.line] = D.column, R();
  }
  function C() {
    let D;
    for (; r._index < o.length; ) {
      const z = o[r._index];
      if (typeof z == "string")
        for (D = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === D && r._bufferIndex < z.length; )
          b(z.charCodeAt(r._bufferIndex));
      else
        b(z);
    }
  }
  function b(D) {
    d = d(D);
  }
  function A(D) {
    F(D) ? (r.line++, r.column = 1, r.offset += D === -3 ? 2 : 1, R()) : D !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = D;
  }
  function x(D, z) {
    const Q = z || {};
    return Q.type = D, Q.start = y(), u.events.push(["enter", Q, u]), l.push(Q), Q;
  }
  function T(D) {
    const z = l.pop();
    return z.end = y(), u.events.push(["exit", z, u]), z;
  }
  function N(D, z) {
    U(D, z.from);
  }
  function k(D, z) {
    z.restore();
  }
  function B(D, z) {
    return Q;
    function Q(Y, L, Z) {
      let ee, te, Ce, g;
      return Array.isArray(Y) ? ie(Y) : "tokenize" in Y ? (
        // @ts-expect-error Looks like a construct.
        ie([Y])
      ) : he(Y);
      function he(oe) {
        return Nt;
        function Nt(We) {
          const lt = We !== null && oe[We], $e = We !== null && oe.null, $n = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(lt) ? lt : lt ? [lt] : [],
            ...Array.isArray($e) ? $e : $e ? [$e] : []
          ];
          return ie($n)(We);
        }
      }
      function ie(oe) {
        return ee = oe, te = 0, oe.length === 0 ? Z : p(oe[te]);
      }
      function p(oe) {
        return Nt;
        function Nt(We) {
          return g = I(), Ce = oe, oe.partial || (u.currentConstruct = oe), oe.name && u.parser.constructs.disable.null.includes(oe.name) ? _e() : oe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            z ? Object.assign(Object.create(u), z) : u,
            s,
            Ee,
            _e
          )(We);
        }
      }
      function Ee(oe) {
        return D(Ce, g), L;
      }
      function _e(oe) {
        return g.restore(), ++te < ee.length ? p(ee[te]) : Z;
      }
    }
  }
  function U(D, z) {
    D.resolveAll && !a.includes(D) && a.push(D), D.resolve && Fe(
      u.events,
      z,
      u.events.length - z,
      D.resolve(u.events.slice(z), u)
    ), D.resolveTo && (u.events = D.resolveTo(u.events, u));
  }
  function I() {
    const D = y(), z = u.previous, Q = u.currentConstruct, Y = u.events.length, L = Array.from(l);
    return {
      restore: Z,
      from: Y
    };
    function Z() {
      r = D, u.previous = z, u.currentConstruct = Q, u.events.length = Y, l = L, R();
    }
  }
  function R() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function rg(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex;
  let o;
  if (n === i)
    o = [e[n].slice(r, a)];
  else {
    if (o = e.slice(n, i), r > -1) {
      const l = o[0];
      typeof l == "string" ? o[0] = l.slice(r) : o.shift();
    }
    a > 0 && o.push(e[i].slice(0, a));
  }
  return o;
}
function ig(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const a = e[n];
    let o;
    if (typeof a == "string")
      o = a;
    else
      switch (a) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i)
            continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(a);
      }
    i = a === -2, r.push(o);
  }
  return r.join("");
}
const ag = {
  42: ce,
  43: ce,
  45: ce,
  48: ce,
  49: ce,
  50: ce,
  51: ce,
  52: ce,
  53: ce,
  54: ce,
  55: ce,
  56: ce,
  57: ce,
  62: Yl
}, og = {
  91: lp
}, lg = {
  [-2]: hr,
  [-1]: hr,
  32: hr
}, ug = {
  35: hp,
  42: An,
  45: [Ka, An],
  60: yp,
  61: Ka,
  95: An,
  96: Ja,
  126: Ja
}, sg = {
  38: Gl,
  92: Zl
}, cg = {
  [-5]: mr,
  [-4]: mr,
  [-3]: mr,
  33: Lp,
  38: Gl,
  42: qr,
  60: [Rm, Cp],
  91: Fp,
  92: [dp, Zl],
  93: Ei,
  95: qr,
  96: Km
}, dg = {
  null: [qr, _p]
}, fg = {
  null: [42, 95]
}, hg = {
  null: []
}, mg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: fg,
  contentInitial: og,
  disable: hg,
  document: ag,
  flow: ug,
  flowInitial: lg,
  insideSpan: dg,
  string: sg,
  text: cg
}, Symbol.toStringTag, { value: "Module" }));
function pg(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    km([mg, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(Pm),
    document: i(zm),
    flow: i(Xp),
    string: i($p),
    text: i(eg)
  };
  return r;
  function i(a) {
    return o;
    function o(l) {
      return ng(r, a, l);
    }
  }
}
function gg(e) {
  for (; !Jl(e); )
    ;
  return e;
}
const _a = /[\0\t\n\r]/g;
function yg() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(a, o, l) {
    const s = [];
    let u, d, c, h, f;
    for (a = t + (typeof a == "string" ? a.toString() : new TextDecoder(o || void 0).decode(a)), c = 0, t = "", n && (a.charCodeAt(0) === 65279 && c++, n = void 0); c < a.length; ) {
      if (_a.lastIndex = c, u = _a.exec(a), h = u && u.index !== void 0 ? u.index : a.length, f = a.charCodeAt(h), !u) {
        t = a.slice(c);
        break;
      }
      if (f === 10 && c === h && r)
        s.push(-3), r = void 0;
      else
        switch (r && (s.push(-5), r = void 0), c < h && (s.push(a.slice(c, h)), e += h - c), f) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, s.push(-2); e++ < d; )
              s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      c = h + 1;
    }
    return l && (r && s.push(-5), t && s.push(t), s.push(null)), s;
  }
}
const bg = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function vg(e) {
  return e.replace(bg, wg);
}
function wg(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), a = i === 120 || i === 88;
    return Wl(n.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return ki(n) || e;
}
const tu = {}.hasOwnProperty;
function xg(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), Ag(n)(
    gg(
      pg(n).document().write(yg()(e, t, !0))
    )
  );
}
function Ag(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(Bi),
      autolinkProtocol: I,
      autolinkEmail: I,
      atxHeading: a(Pi),
      blockQuote: a(lt),
      characterEscape: I,
      characterReference: I,
      codeFenced: a($e),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: a($e, o),
      codeText: a($n, o),
      codeTextData: I,
      data: I,
      codeFlowValue: I,
      definition: a(mu),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: a(pu),
      hardBreakEscape: a(Di),
      hardBreakTrailing: a(Di),
      htmlFlow: a(zi, o),
      htmlFlowData: I,
      htmlText: a(zi, o),
      htmlTextData: I,
      image: a(gu),
      label: o,
      link: a(Bi),
      listItem: a(yu),
      listItemValue: h,
      listOrdered: a(Li, c),
      listUnordered: a(Li),
      paragraph: a(bu),
      reference: p,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: a(Pi),
      strong: a(vu),
      thematicBreak: a(xu)
    },
    exit: {
      atxHeading: s(),
      atxHeadingSequence: N,
      autolink: s(),
      autolinkEmail: We,
      autolinkProtocol: Nt,
      blockQuote: s(),
      characterEscapeValue: R,
      characterReferenceMarkerHexadecimal: _e,
      characterReferenceMarkerNumeric: _e,
      characterReferenceValue: oe,
      codeFenced: s(C),
      codeFencedFence: v,
      codeFencedFenceInfo: f,
      codeFencedFenceMeta: y,
      codeFlowValue: R,
      codeIndented: s(b),
      codeText: s(L),
      codeTextData: R,
      data: R,
      definition: s(),
      definitionDestinationString: T,
      definitionLabelString: A,
      definitionTitleString: x,
      emphasis: s(),
      hardBreakEscape: s(z),
      hardBreakTrailing: s(z),
      htmlFlow: s(Q),
      htmlFlowData: R,
      htmlText: s(Y),
      htmlTextData: R,
      image: s(ee),
      label: Ce,
      labelText: te,
      lineEnding: D,
      link: s(Z),
      listItem: s(),
      listOrdered: s(),
      listUnordered: s(),
      paragraph: s(),
      referenceString: Ee,
      resourceDestinationString: g,
      resourceTitleString: he,
      resource: ie,
      setextHeading: s(U),
      setextHeadingLineSequence: B,
      setextHeadingText: k,
      strong: s(),
      thematicBreak: s()
    }
  };
  nu(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(E) {
    let P = {
      type: "root",
      children: []
    };
    const j = {
      stack: [P],
      tokenStack: [],
      config: t,
      enter: l,
      exit: u,
      buffer: o,
      resume: d,
      data: n
    }, W = [];
    let K = -1;
    for (; ++K < E.length; )
      if (E[K][1].type === "listOrdered" || E[K][1].type === "listUnordered")
        if (E[K][0] === "enter")
          W.push(K);
        else {
          const Se = W.pop();
          K = i(E, Se, K);
        }
    for (K = -1; ++K < E.length; ) {
      const Se = t[E[K][0]];
      tu.call(Se, E[K][1].type) && Se[E[K][1].type].call(
        Object.assign(
          {
            sliceSerialize: E[K][2].sliceSerialize
          },
          j
        ),
        E[K][1]
      );
    }
    if (j.tokenStack.length > 0) {
      const Se = j.tokenStack[j.tokenStack.length - 1];
      (Se[1] || $a).call(j, void 0, Se[0]);
    }
    for (P.position = {
      start: Ze(
        E.length > 0 ? E[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: Ze(
        E.length > 0 ? E[E.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, K = -1; ++K < t.transforms.length; )
      P = t.transforms[K](P) || P;
    return P;
  }
  function i(E, P, j) {
    let W = P - 1, K = -1, Se = !1, et, Re, Mt, Ot;
    for (; ++W <= j; ) {
      const me = E[W];
      switch (me[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          me[0] === "enter" ? K++ : K--, Ot = void 0;
          break;
        }
        case "lineEndingBlank": {
          me[0] === "enter" && (et && !Ot && !K && !Mt && (Mt = W), Ot = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Ot = void 0;
      }
      if (!K && me[0] === "enter" && me[1].type === "listItemPrefix" || K === -1 && me[0] === "exit" && (me[1].type === "listUnordered" || me[1].type === "listOrdered")) {
        if (et) {
          let ut = W;
          for (Re = void 0; ut--; ) {
            const je = E[ut];
            if (je[1].type === "lineEnding" || je[1].type === "lineEndingBlank") {
              if (je[0] === "exit")
                continue;
              Re && (E[Re][1].type = "lineEndingBlank", Se = !0), je[1].type = "lineEnding", Re = ut;
            } else if (!(je[1].type === "linePrefix" || je[1].type === "blockQuotePrefix" || je[1].type === "blockQuotePrefixWhitespace" || je[1].type === "blockQuoteMarker" || je[1].type === "listItemIndent"))
              break;
          }
          Mt && (!Re || Mt < Re) && (et._spread = !0), et.end = Object.assign(
            {},
            Re ? E[Re][1].start : me[1].end
          ), E.splice(Re || W, 0, ["exit", et, me[2]]), W++, j++;
        }
        if (me[1].type === "listItemPrefix") {
          const ut = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, me[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          et = ut, E.splice(W, 0, ["enter", ut, me[2]]), W++, j++, Mt = void 0, Ot = !0;
        }
      }
    }
    return E[P][1]._spread = Se, j;
  }
  function a(E, P) {
    return j;
    function j(W) {
      l.call(this, E(W), W), P && P.call(this, W);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(E, P, j) {
    this.stack[this.stack.length - 1].children.push(E), this.stack.push(E), this.tokenStack.push([P, j]), E.position = {
      start: Ze(P.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function s(E) {
    return P;
    function P(j) {
      E && E.call(this, j), u.call(this, j);
    }
  }
  function u(E, P) {
    const j = this.stack.pop(), W = this.tokenStack.pop();
    if (W)
      W[0].type !== E.type && (P ? P.call(this, E, W[0]) : (W[1] || $a).call(this, E, W[0]));
    else
      throw new Error(
        "Cannot close `" + E.type + "` (" + Ht({
          start: E.start,
          end: E.end
        }) + "): it’s not open"
      );
    j.position.end = Ze(E.end);
  }
  function d() {
    return xm(this.stack.pop());
  }
  function c() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(E) {
    if (this.data.expectingFirstListItemValue) {
      const P = this.stack[this.stack.length - 2];
      P.start = Number.parseInt(this.sliceSerialize(E), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function f() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.lang = E;
  }
  function y() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.meta = E;
  }
  function v() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function C() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = E.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function b() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = E.replace(/(\r?\n|\r)$/g, "");
  }
  function A(E) {
    const P = this.resume(), j = this.stack[this.stack.length - 1];
    j.label = P, j.identifier = yt(
      this.sliceSerialize(E)
    ).toLowerCase();
  }
  function x() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.title = E;
  }
  function T() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.url = E;
  }
  function N(E) {
    const P = this.stack[this.stack.length - 1];
    if (!P.depth) {
      const j = this.sliceSerialize(E).length;
      P.depth = j;
    }
  }
  function k() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function B(E) {
    const P = this.stack[this.stack.length - 1];
    P.depth = this.sliceSerialize(E).codePointAt(0) === 61 ? 1 : 2;
  }
  function U() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function I(E) {
    const j = this.stack[this.stack.length - 1].children;
    let W = j[j.length - 1];
    (!W || W.type !== "text") && (W = wu(), W.position = {
      start: Ze(E.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, j.push(W)), this.stack.push(W);
  }
  function R(E) {
    const P = this.stack.pop();
    P.value += this.sliceSerialize(E), P.position.end = Ze(E.end);
  }
  function D(E) {
    const P = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const j = P.children[P.children.length - 1];
      j.position.end = Ze(E.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(P.type) && (I.call(this, E), R.call(this, E));
  }
  function z() {
    this.data.atHardBreak = !0;
  }
  function Q() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = E;
  }
  function Y() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = E;
  }
  function L() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = E;
  }
  function Z() {
    const E = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const P = this.data.referenceType || "shortcut";
      E.type += "Reference", E.referenceType = P, delete E.url, delete E.title;
    } else
      delete E.identifier, delete E.label;
    this.data.referenceType = void 0;
  }
  function ee() {
    const E = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const P = this.data.referenceType || "shortcut";
      E.type += "Reference", E.referenceType = P, delete E.url, delete E.title;
    } else
      delete E.identifier, delete E.label;
    this.data.referenceType = void 0;
  }
  function te(E) {
    const P = this.sliceSerialize(E), j = this.stack[this.stack.length - 2];
    j.label = vg(P), j.identifier = yt(P).toLowerCase();
  }
  function Ce() {
    const E = this.stack[this.stack.length - 1], P = this.resume(), j = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, j.type === "link") {
      const W = E.children;
      j.children = W;
    } else
      j.alt = P;
  }
  function g() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.url = E;
  }
  function he() {
    const E = this.resume(), P = this.stack[this.stack.length - 1];
    P.title = E;
  }
  function ie() {
    this.data.inReference = void 0;
  }
  function p() {
    this.data.referenceType = "collapsed";
  }
  function Ee(E) {
    const P = this.resume(), j = this.stack[this.stack.length - 1];
    j.label = P, j.identifier = yt(
      this.sliceSerialize(E)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function _e(E) {
    this.data.characterReferenceType = E.type;
  }
  function oe(E) {
    const P = this.sliceSerialize(E), j = this.data.characterReferenceType;
    let W;
    j ? (W = Wl(
      P,
      j === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : W = ki(P);
    const K = this.stack.pop();
    K.value += W, K.position.end = Ze(E.end);
  }
  function Nt(E) {
    R.call(this, E);
    const P = this.stack[this.stack.length - 1];
    P.url = this.sliceSerialize(E);
  }
  function We(E) {
    R.call(this, E);
    const P = this.stack[this.stack.length - 1];
    P.url = "mailto:" + this.sliceSerialize(E);
  }
  function lt() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function $e() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function $n() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function mu() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function pu() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Pi() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Di() {
    return {
      type: "break"
    };
  }
  function zi() {
    return {
      type: "html",
      value: ""
    };
  }
  function gu() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Bi() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Li(E) {
    return {
      type: "list",
      ordered: E.type === "listOrdered",
      start: null,
      spread: E._spread,
      children: []
    };
  }
  function yu(E) {
    return {
      type: "listItem",
      spread: E._spread,
      checked: null,
      children: []
    };
  }
  function bu() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function vu() {
    return {
      type: "strong",
      children: []
    };
  }
  function wu() {
    return {
      type: "text",
      value: ""
    };
  }
  function xu() {
    return {
      type: "thematicBreak"
    };
  }
}
function Ze(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function nu(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? nu(e, r) : kg(e, r);
  }
}
function kg(e, t) {
  let n;
  for (n in t)
    if (tu.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function $a(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + Ht({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + Ht({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + Ht({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function Cg(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return xg(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function Eg(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Sg(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function Ng(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function Mg(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Og(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Tg(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = St(r.toLowerCase()), a = e.footnoteOrder.indexOf(r);
  let o, l = e.footnoteCounts.get(r);
  l === void 0 ? (l = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, l += 1, e.footnoteCounts.set(r, l);
  const s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, s);
  const u = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(t, u), e.applyData(t, u);
}
function Pg(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Dg(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function ru(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), a = i[0];
  a && a.type === "text" ? a.value = "[" + a.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function zg(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return ru(e, t);
  const i = { src: St(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function Bg(e, t) {
  const n = { src: St(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function Lg(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Ig(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return ru(e, t);
  const i = { href: St(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function Fg(e, t) {
  const n = { href: St(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Rg(e, t, n) {
  const r = e.all(t), i = n ? jg(n) : iu(t), a = {}, o = [];
  if (typeof t.checked == "boolean") {
    const d = r[0];
    let c;
    d && d.type === "element" && d.tagName === "p" ? c = d : (c = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(c)), c.children.length > 0 && c.children.unshift({ type: "text", value: " " }), c.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < r.length; ) {
    const d = r[l];
    (i || l !== 0 || d.type !== "element" || d.tagName !== "p") && o.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !i ? o.push(...d.children) : o.push(d);
  }
  const s = r[r.length - 1];
  s && (i || s.type !== "element" || s.tagName !== "p") && o.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(t, u), e.applyData(t, u);
}
function jg(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = iu(n[r]);
  }
  return t;
}
function iu(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function Vg(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function Hg(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Qg(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Ug(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Wg(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], o), i.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, l = vi(t.children[1]), s = Fl(t.children[t.children.length - 1]);
    l && s && (o.position = { start: l, end: s }), i.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function qg(e, t, n) {
  const r = n ? n.children : void 0, a = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, l = o ? o.length : t.children.length;
  let s = -1;
  const u = [];
  for (; ++s < l; ) {
    const c = t.children[s], h = {}, f = o ? o[s] : void 0;
    f && (h.align = f);
    let y = { type: "element", tagName: a, properties: h, children: [] };
    c && (y.children = e.all(c), e.patch(c, y), y = e.applyData(c, y)), u.push(y);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, d), e.applyData(t, d);
}
function Yg(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const eo = 9, to = 32;
function Zg(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const a = [];
  for (; r; )
    a.push(
      no(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return a.push(no(t.slice(i), i > 0, !1)), a.join("");
}
function no(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let a = e.codePointAt(r);
    for (; a === eo || a === to; )
      r++, a = e.codePointAt(r);
  }
  if (n) {
    let a = e.codePointAt(i - 1);
    for (; a === eo || a === to; )
      i--, a = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function Gg(e, t) {
  const n = { type: "text", value: Zg(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Jg(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Xg = {
  blockquote: Eg,
  break: Sg,
  code: Ng,
  delete: Mg,
  emphasis: Og,
  footnoteReference: Tg,
  heading: Pg,
  html: Dg,
  imageReference: zg,
  image: Bg,
  inlineCode: Lg,
  linkReference: Ig,
  link: Fg,
  listItem: Rg,
  list: Vg,
  paragraph: Hg,
  // @ts-expect-error: root is different, but hard to type.
  root: Qg,
  strong: Ug,
  table: Wg,
  tableCell: Yg,
  tableRow: qg,
  text: Gg,
  thematicBreak: Jg,
  toml: pn,
  yaml: pn,
  definition: pn,
  footnoteDefinition: pn
};
function pn() {
}
const au = -1, Kn = 0, Ln = 1, In = 2, Si = 3, Ni = 4, Mi = 5, Oi = 6, ou = 7, lu = 8, ro = typeof self == "object" ? self : globalThis, Kg = (e, t) => {
  const n = (i, a) => (e.set(a, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [a, o] = t[i];
    switch (a) {
      case Kn:
      case au:
        return n(o, i);
      case Ln: {
        const l = n([], i);
        for (const s of o)
          l.push(r(s));
        return l;
      }
      case In: {
        const l = n({}, i);
        for (const [s, u] of o)
          l[r(s)] = r(u);
        return l;
      }
      case Si:
        return n(new Date(o), i);
      case Ni: {
        const { source: l, flags: s } = o;
        return n(new RegExp(l, s), i);
      }
      case Mi: {
        const l = n(/* @__PURE__ */ new Map(), i);
        for (const [s, u] of o)
          l.set(r(s), r(u));
        return l;
      }
      case Oi: {
        const l = n(/* @__PURE__ */ new Set(), i);
        for (const s of o)
          l.add(r(s));
        return l;
      }
      case ou: {
        const { name: l, message: s } = o;
        return n(new ro[l](s), i);
      }
      case lu:
        return n(BigInt(o), i);
      case "BigInt":
        return n(Object(BigInt(o)), i);
    }
    return n(new ro[a](o), i);
  };
  return r;
}, io = (e) => Kg(/* @__PURE__ */ new Map(), e)(0), ft = "", { toString: _g } = {}, { keys: $g } = Object, zt = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [Kn, t];
  const n = _g.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Ln, ft];
    case "Object":
      return [In, ft];
    case "Date":
      return [Si, ft];
    case "RegExp":
      return [Ni, ft];
    case "Map":
      return [Mi, ft];
    case "Set":
      return [Oi, ft];
  }
  return n.includes("Array") ? [Ln, n] : n.includes("Error") ? [ou, n] : [In, n];
}, gn = ([e, t]) => e === Kn && (t === "function" || t === "symbol"), e1 = (e, t, n, r) => {
  const i = (o, l) => {
    const s = r.push(o) - 1;
    return n.set(l, s), s;
  }, a = (o) => {
    if (n.has(o))
      return n.get(o);
    let [l, s] = zt(o);
    switch (l) {
      case Kn: {
        let d = o;
        switch (s) {
          case "bigint":
            l = lu, d = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + s);
            d = null;
            break;
          case "undefined":
            return i([au], o);
        }
        return i([l, d], o);
      }
      case Ln: {
        if (s)
          return i([s, [...o]], o);
        const d = [], c = i([l, d], o);
        for (const h of o)
          d.push(a(h));
        return c;
      }
      case In: {
        if (s)
          switch (s) {
            case "BigInt":
              return i([s, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([s, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return a(o.toJSON());
        const d = [], c = i([l, d], o);
        for (const h of $g(o))
          (e || !gn(zt(o[h]))) && d.push([a(h), a(o[h])]);
        return c;
      }
      case Si:
        return i([l, o.toISOString()], o);
      case Ni: {
        const { source: d, flags: c } = o;
        return i([l, { source: d, flags: c }], o);
      }
      case Mi: {
        const d = [], c = i([l, d], o);
        for (const [h, f] of o)
          (e || !(gn(zt(h)) || gn(zt(f)))) && d.push([a(h), a(f)]);
        return c;
      }
      case Oi: {
        const d = [], c = i([l, d], o);
        for (const h of o)
          (e || !gn(zt(h))) && d.push(a(h));
        return c;
      }
    }
    const { message: u } = o;
    return i([l, { name: s, message: u }], o);
  };
  return a;
}, ao = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return e1(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, Fn = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? io(ao(e, t)) : structuredClone(e)
) : (e, t) => io(ao(e, t));
function t1(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function n1(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function r1(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || t1, r = e.options.footnoteBackLabel || n1, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let s = -1;
  for (; ++s < e.footnoteOrder.length; ) {
    const u = e.footnoteById.get(e.footnoteOrder[s]);
    if (!u)
      continue;
    const d = e.all(u), c = String(u.identifier).toUpperCase(), h = St(c.toLowerCase());
    let f = 0;
    const y = [], v = e.footnoteCounts.get(c);
    for (; v !== void 0 && ++f <= v; ) {
      y.length > 0 && y.push({ type: "text", value: " " });
      let A = typeof n == "string" ? n : n(s, f);
      typeof A == "string" && (A = { type: "text", value: A }), y.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + h + (f > 1 ? "-" + f : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(s, f),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(A) ? A : [A]
      });
    }
    const C = d[d.length - 1];
    if (C && C.type === "element" && C.tagName === "p") {
      const A = C.children[C.children.length - 1];
      A && A.type === "text" ? A.value += " " : C.children.push({ type: "text", value: " " }), C.children.push(...y);
    } else
      d.push(...y);
    const b = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + h },
      children: e.wrap(d, !0)
    };
    e.patch(u, b), l.push(b);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...Fn(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const uu = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return l1;
    if (typeof e == "function")
      return _n(e);
    if (typeof e == "object")
      return Array.isArray(e) ? i1(e) : a1(e);
    if (typeof e == "string")
      return o1(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function i1(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = uu(e[n]);
  return _n(r);
  function r(...i) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].apply(this, i))
        return !0;
    return !1;
  }
}
function a1(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return _n(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let a;
    for (a in e)
      if (i[a] !== t[a])
        return !1;
    return !0;
  }
}
function o1(e) {
  return _n(t);
  function t(n) {
    return n && n.type === e;
  }
}
function _n(e) {
  return t;
  function t(n, r, i) {
    return !!(u1(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function l1() {
  return !0;
}
function u1(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const su = [], s1 = !0, oo = !1, c1 = "skip";
function d1(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const a = uu(i), o = r ? -1 : 1;
  l(e, void 0, [])();
  function l(s, u, d) {
    const c = (
      /** @type {Record<string, unknown>} */
      s && typeof s == "object" ? s : {}
    );
    if (typeof c.type == "string") {
      const f = (
        // `hast`
        typeof c.tagName == "string" ? c.tagName : (
          // `xast`
          typeof c.name == "string" ? c.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (s.type + (f ? "<" + f + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let f = su, y, v, C;
      if ((!t || a(s, u, d[d.length - 1] || void 0)) && (f = f1(n(s, d)), f[0] === oo))
        return f;
      if ("children" in s && s.children) {
        const b = (
          /** @type {UnistParent} */
          s
        );
        if (b.children && f[0] !== c1)
          for (v = (r ? b.children.length : -1) + o, C = d.concat(b); v > -1 && v < b.children.length; ) {
            const A = b.children[v];
            if (y = l(A, v, C)(), y[0] === oo)
              return y;
            v = typeof y[1] == "number" ? y[1] : v + o;
          }
      }
      return f;
    }
  }
}
function f1(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [s1, e] : e == null ? su : [e];
}
function cu(e, t, n, r) {
  let i, a, o;
  typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, i = n) : (a = t, o = n, i = r), d1(e, a, l, i);
  function l(s, u) {
    const d = u[u.length - 1], c = d ? d.children.indexOf(s) : void 0;
    return o(s, c, d);
  }
}
const Yr = {}.hasOwnProperty, h1 = {};
function m1(e, t) {
  const n = t || h1, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = { ...Xg, ...n.handlers }, l = {
    all: u,
    applyData: g1,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: o,
    one: s,
    options: n,
    patch: p1,
    wrap: b1
  };
  return cu(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const c = d.type === "definition" ? r : i, h = String(d.identifier).toUpperCase();
      c.has(h) || c.set(h, d);
    }
  }), l;
  function s(d, c) {
    const h = d.type, f = l.handlers[h];
    if (Yr.call(l.handlers, h) && f)
      return f(l, d, c);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in d) {
        const { children: v, ...C } = d, b = Fn(C);
        return b.children = l.all(d), b;
      }
      return Fn(d);
    }
    return (l.options.unknownHandler || y1)(l, d, c);
  }
  function u(d) {
    const c = [];
    if ("children" in d) {
      const h = d.children;
      let f = -1;
      for (; ++f < h.length; ) {
        const y = l.one(h[f], d);
        if (y) {
          if (f && h[f - 1].type === "break" && (!Array.isArray(y) && y.type === "text" && (y.value = lo(y.value)), !Array.isArray(y) && y.type === "element")) {
            const v = y.children[0];
            v && v.type === "text" && (v.value = lo(v.value));
          }
          Array.isArray(y) ? c.push(...y) : c.push(y);
        }
      }
    }
    return c;
  }
}
function p1(e, t) {
  e.position && (t.position = Kh(e));
}
function g1(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, a = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: o };
      }
    n.type === "element" && a && Object.assign(n.properties, Fn(a)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function y1(e, t) {
  const n = t.data || {}, r = "value" in t && !(Yr.call(n, "hProperties") || Yr.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function b1(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function lo(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function uo(e, t) {
  const n = m1(e, t), r = n.one(e, void 0), i = r1(n), a = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && a.children.push({ type: "text", value: `
` }, i), a;
}
function v1(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      uo(n, t)
    );
    await e.run(i, r);
  } : function(n) {
    return (
      /** @type {HastRoot} */
      uo(n, t || e)
    );
  };
}
function so(e) {
  if (e)
    throw e;
}
var kn = Object.prototype.hasOwnProperty, du = Object.prototype.toString, co = Object.defineProperty, fo = Object.getOwnPropertyDescriptor, ho = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : du.call(t) === "[object Array]";
}, mo = function(t) {
  if (!t || du.call(t) !== "[object Object]")
    return !1;
  var n = kn.call(t, "constructor"), r = t.constructor && t.constructor.prototype && kn.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || kn.call(t, i);
}, po = function(t, n) {
  co && n.name === "__proto__" ? co(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, go = function(t, n) {
  if (n === "__proto__")
    if (kn.call(t, n)) {
      if (fo)
        return fo(t, n).value;
    } else
      return;
  return t[n];
}, w1 = function e() {
  var t, n, r, i, a, o, l = arguments[0], s = 1, u = arguments.length, d = !1;
  for (typeof l == "boolean" && (d = l, l = arguments[1] || {}, s = 2), (l == null || typeof l != "object" && typeof l != "function") && (l = {}); s < u; ++s)
    if (t = arguments[s], t != null)
      for (n in t)
        r = go(l, n), i = go(t, n), l !== i && (d && i && (mo(i) || (a = ho(i))) ? (a ? (a = !1, o = r && ho(r) ? r : []) : o = r && mo(r) ? r : {}, po(l, { name: n, newValue: e(d, o, i) })) : typeof i < "u" && po(l, { name: n, newValue: i }));
  return l;
};
const pr = /* @__PURE__ */ Lh(w1);
function Zr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function x1() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let a = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    l(null, ...i);
    function l(s, ...u) {
      const d = e[++a];
      let c = -1;
      if (s) {
        o(s);
        return;
      }
      for (; ++c < i.length; )
        (u[c] === null || u[c] === void 0) && (u[c] = i[c]);
      i = u, d ? A1(d, l)(...u) : o(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function A1(e, t) {
  let n;
  return r;
  function r(...o) {
    const l = e.length > o.length;
    let s;
    l && o.push(i);
    try {
      s = e.apply(this, o);
    } catch (u) {
      const d = (
        /** @type {Error} */
        u
      );
      if (l && n)
        throw d;
      return i(d);
    }
    l || (s instanceof Promise ? s.then(a, i) : s instanceof Error ? i(s) : a(s));
  }
  function i(o, ...l) {
    n || (n = !0, t(o, ...l));
  }
  function a(o) {
    i(null, o);
  }
}
const Te = { basename: k1, dirname: C1, extname: E1, join: S1, sep: "/" };
function k1(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  sn(e);
  let n = 0, r = -1, i = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let o = -1, l = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        n = i + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = i + 1), l > -1 && (e.codePointAt(i) === t.codePointAt(l--) ? l < 0 && (r = i) : (l = -1, r = o));
  return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function C1(e) {
  if (sn(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function E1(e) {
  sn(e);
  let t = e.length, n = -1, r = 0, i = -1, a = 0, o;
  for (; t--; ) {
    const l = e.codePointAt(t);
    if (l === 47) {
      if (o) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), l === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function S1(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    sn(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : N1(n);
}
function N1(e) {
  sn(e);
  const t = e.codePointAt(0) === 47;
  let n = M1(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function M1(e, t) {
  let n = "", r = 0, i = -1, a = 0, o = -1, l, s;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      l = e.codePointAt(o);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(i === o - 1 || a === 1))
        if (i !== o - 1 && a === 2) {
          if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (s = n.lastIndexOf("/"), s !== n.length - 1) {
                s < 0 ? (n = "", r = 0) : (n = n.slice(0, s), r = n.length - 1 - n.lastIndexOf("/")), i = o, a = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = o, a = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
      i = o, a = 0;
    } else
      l === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function sn(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const O1 = { cwd: T1 };
function T1() {
  return "/";
}
function Gr(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function P1(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Gr(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return D1(e);
}
function D1(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const gr = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class fu {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Gr(t) ? n = { path: t } : typeof t == "string" || z1(t) ? n = { value: t } : n = t : n = {}, this.cwd = O1.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < gr.length; ) {
      const a = gr[r];
      a in n && n[a] !== void 0 && n[a] !== null && (this[a] = a === "history" ? [...n[a]] : n[a]);
    }
    let i;
    for (i in n)
      gr.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Te.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    br(t, "basename"), yr(t, "basename"), this.path = Te.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Te.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    yo(this.basename, "dirname"), this.path = Te.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Te.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (yr(t, "extname"), yo(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Te.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Gr(t) && (t = P1(t)), br(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Te.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    br(t, "stem"), yr(t, "stem"), this.path = Te.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new se(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function yr(e, t) {
  if (e && e.includes(Te.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Te.sep + "`"
    );
}
function br(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function yo(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function z1(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const B1 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    Object.setPrototypeOf(a, r);
    const o = Object.getOwnPropertyNames(i);
    for (const l of o) {
      const s = Object.getOwnPropertyDescriptor(i, l);
      s && Object.defineProperty(a, l, s);
    }
    return a;
  }
), L1 = {}.hasOwnProperty;
class Ti extends B1 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = x1();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Ti()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(pr(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (xr("data", this.frozen), this.namespace[t] = n, this) : L1.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (xr("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = yn(t), r = this.parser || this.Parser;
    return vr("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), vr("process", this.parser || this.Parser), wr("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(a, o) {
      const l = yn(t), s = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(l)
      );
      r.run(s, l, function(d, c, h) {
        if (d || !c || !h)
          return u(d);
        const f = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          c
        ), y = r.stringify(f, h);
        R1(y) ? h.value = y : h.result = y, u(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function u(d, c) {
        d || !c ? o(d) : a ? a(c) : n(void 0, c);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), vr("processSync", this.parser || this.Parser), wr("processSync", this.compiler || this.Compiler), this.process(t, i), vo("processSync", "process", n), r;
    function i(a, o) {
      n = !0, so(a), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    bo(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? a(void 0, r) : new Promise(a);
    function a(o, l) {
      const s = yn(n);
      i.run(t, s, u);
      function u(d, c, h) {
        const f = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          c || t
        );
        d ? l(d) : o ? o(f) : r(void 0, f, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, a), vo("runSync", "run", r), i;
    function a(o, l) {
      so(o), i = l, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = yn(n), i = this.compiler || this.Compiler;
    return wr("stringify", i), bo(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (xr("use", this.frozen), t != null)
      if (typeof t == "function")
        s(t, n);
      else if (typeof t == "object")
        Array.isArray(t) ? l(t) : o(t);
      else
        throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function a(u) {
      if (typeof u == "function")
        s(u, []);
      else if (typeof u == "object")
        if (Array.isArray(u)) {
          const [d, ...c] = (
            /** @type {PluginTuple<Array<unknown>>} */
            u
          );
          s(d, c);
        } else
          o(u);
      else
        throw new TypeError("Expected usable value, not `" + u + "`");
    }
    function o(u) {
      if (!("plugins" in u) && !("settings" in u))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(u.plugins), u.settings && (i.settings = pr(!0, i.settings, u.settings));
    }
    function l(u) {
      let d = -1;
      if (u != null)
        if (Array.isArray(u))
          for (; ++d < u.length; ) {
            const c = u[d];
            a(c);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + u + "`");
    }
    function s(u, d) {
      let c = -1, h = -1;
      for (; ++c < r.length; )
        if (r[c][0] === u) {
          h = c;
          break;
        }
      if (h === -1)
        r.push([u, ...d]);
      else if (d.length > 0) {
        let [f, ...y] = d;
        const v = r[h][1];
        Zr(v) && Zr(f) && (f = pr(!0, v, f)), r[h] = [u, f, ...y];
      }
    }
  }
}
const I1 = new Ti().freeze();
function vr(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function wr(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function xr(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function bo(e) {
  if (!Zr(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function vo(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function yn(e) {
  return F1(e) ? e : new fu(e);
}
function F1(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function R1(e) {
  return typeof e == "string" || j1(e);
}
function j1(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const V1 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", wo = [], xo = { allowDangerousHtml: !0 }, H1 = /^(https?|ircs?|mailto|xmpp)$/i, Q1 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function U1(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, a = e.components, o = e.disallowedElements, l = e.rehypePlugins || wo, s = e.remarkPlugins || wo, u = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...xo } : xo, d = e.skipHtml, c = e.unwrapDisallowed, h = e.urlTransform || W1, f = I1().use(Cg).use(s).use(v1, u).use(l), y = new fu();
  typeof r == "string" && (y.value = r);
  for (const A of Q1)
    Object.hasOwn(e, A.from) && ("" + A.from + (A.to ? "use `" + A.to + "` instead" : "remove it") + V1 + A.id, void 0);
  const v = f.parse(y);
  let C = f.runSync(v, y);
  return i && (C = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      C.type === "root" ? C.children : [C]
    )
  }), cu(C, b), rm(C, {
    Fragment: en,
    components: a,
    ignoreInvalidStyle: !0,
    jsx: m,
    jsxs: M,
    passKeys: !0,
    passNode: !0
  });
  function b(A, x, T) {
    if (A.type === "raw" && T && typeof x == "number")
      return d ? T.children.splice(x, 1) : T.children[x] = { type: "text", value: A.value }, x;
    if (A.type === "element") {
      let N;
      for (N in fr)
        if (Object.hasOwn(fr, N) && Object.hasOwn(A.properties, N)) {
          const k = A.properties[N], B = fr[N];
          (B === null || B.includes(A.tagName)) && (A.properties[N] = h(String(k || ""), N, A));
        }
    }
    if (A.type === "element") {
      let N = t ? !t.includes(A.tagName) : o ? o.includes(A.tagName) : !1;
      if (!N && n && typeof x == "number" && (N = !n(A, x, T)), N && T && typeof x == "number")
        return c && A.children ? T.children.splice(x, 1, ...A.children) : T.children.splice(x, 1), x;
    }
  }
}
function W1(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && t > i || n > -1 && t > n || r > -1 && t > r || // It is a protocol, it should be allowed.
    H1.test(e.slice(0, t)) ? e : ""
  );
}
const w0 = ({ text: e, maxHeight: t, fontSize: n, showLessContent: r, showMoreContent: i }) => {
  const [a, o] = G.useState(!1), [l, s] = G.useState(!0), { observe: u } = Cn({
    onResize: ({ unobserve: d, height: c }) => {
      c && c > (t || c) && (o(!0), s(!1)), d();
    }
  });
  return e && e.length > 0 ? /* @__PURE__ */ M(G.Fragment, { children: [
    /* @__PURE__ */ m(
      "div",
      {
        translate: "yes",
        ref: u,
        className: `ui-mb-2 ui-whitespace-normal ui-break-words [&>*]:!ui-my-1 [&>*]:ui-white-space-pre-line [&>*]:ui-break-words ui-prose ui-flex-col ui-flex ${l ? "" : "ui-overflow-hidden masked"}`,
        style: {
          height: l ? "fit-content" : t,
          fontSize: n || ""
        },
        children: /* @__PURE__ */ m(U1, { children: e })
      }
    ),
    a && /* @__PURE__ */ M("div", { className: "ui-prose ui-flex ui-justify-center ui-flex-row ui-items-center", children: [
      /* @__PURE__ */ m("div", { className: "h-1/2 ui-border-b ui-border-b-gray-200 ui-flex-1" }),
      /* @__PURE__ */ m("div", { className: "ui-mx-4 ui-flex ui-justify-center ui-w-fit", children: l ? /* @__PURE__ */ m("button", { onClick: () => s(!1), children: r }) : /* @__PURE__ */ m("button", { onClick: () => s(!0), children: i }) }),
      /* @__PURE__ */ m("div", { className: "ui-border-b ui-border-b-gray-200 ui-flex-1" })
    ] })
  ] }) : null;
}, x0 = ({ maxHeight: e }) => /* @__PURE__ */ m("div", { className: "skeletonLoad", children: Array.apply(null, Array(Math.floor((e || 200) / 20))).map((t, n) => /* @__PURE__ */ m(
  "div",
  {
    className: "ui-mb-1 ui-h-4 ui-w-full [&:nth-child(4n)]:ui-w-3/4 [&:nth-child(4n)]:ui-mb-2 ui-bg-gray-100 ui-rounded-full"
  },
  n
)) }), A0 = ({ text: e, fontSize: t }) => /* @__PURE__ */ m("div", { style: { fontSize: t || "1rem" }, className: "ui-prose", children: e }), k0 = ({ fontSize: e }) => /* @__PURE__ */ m("div", { style: { height: e || "1rem" }, className: "ui-w-full ui-bg-gray-100 skeletonLoad ui-rounded-full" }), q1 = (e) => /* @__PURE__ */ w.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("g", null, /* @__PURE__ */ w.createElement("path", { d: "M15.75 7.5C15.75 12.75 9 17.25 9 17.25C9 17.25 2.25 12.75 2.25 7.5C2.25 5.70979 2.96116 3.9929 4.22703 2.72703C5.4929 1.46116 7.20979 0.75 9 0.75C10.7902 0.75 12.5071 1.46116 13.773 2.72703C15.0388 3.9929 15.75 5.70979 15.75 7.5Z", fill: "currentColor" }), /* @__PURE__ */ w.createElement("path", { d: "M9 9.75C10.2426 9.75 11.25 8.74264 11.25 7.5C11.25 6.25736 10.2426 5.25 9 5.25C7.75736 5.25 6.75 6.25736 6.75 7.5C6.75 8.74264 7.75736 9.75 9 9.75Z", fill: "white", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }))), hu = (e) => /* @__PURE__ */ w.createElement("svg", { id: "Bold", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ w.createElement("title", null, "arrow-button-right"), /* @__PURE__ */ w.createElement("path", { d: "M7.207,23.751,19.678,12.767h0a1.066,1.066,0,0,0,0-1.539L7.207.249A.987.987,0,0,0,5.793.356L4.236,2.206a1.028,1.028,0,0,0,.111,1.438L13.8,11.809a.25.25,0,0,1,0,.379l-9.45,8.168a1.021,1.021,0,0,0-.349.7,1,1,0,0,0,.238.741l1.558,1.851a.989.989,0,0,0,1.414.107Z" })), Y1 = (e) => {
  switch (e) {
    case "start_end_date":
      return "start_end_date";
    case "start_date":
      return "start_date";
    case "start_date_and_time":
      return "start_date_and_time";
    case "free_text":
      return "free_text";
    case "start_end_date_and_time":
    default:
      return "start_end_date_and_time";
  }
}, C0 = ({
  title: e,
  subtitle: t,
  location: n,
  timeZoneAdjustedStart: r,
  timeZoneAdjustedEnd: i,
  shouldShowTzoneDay: a = !1,
  shouldShowTimezone: o = !1,
  image: l,
  images: s,
  locale: u = "nb-NO",
  dateFormat: d,
  tzoneName: c = null,
  env: h,
  localTimeMessage: f,
  localTimeEquivalentMessage: y,
  localTimeLabel: v
}) => /* @__PURE__ */ M(tn, { additionalCls: "tablet:ui-p-5 tablet:ui-flex hover:ui-cursor-pointer ui-max-w-[450px] tablet:ui-max-w-full", children: [
  l || s ? /* @__PURE__ */ M(G.Fragment, { children: [
    /* @__PURE__ */ m("div", { className: "ui-flex tablet:ui-hidden ui-overflow-hidden ui-rounded-t-xl", children: /* @__PURE__ */ m(
      Cr,
      {
        imgixImage: l,
        croppedImages: s,
        queries: [],
        base: {
          width: 450,
          ar: "SixteenByNine"
        },
        style: { width: "100%", aspectRatio: "16/9" },
        alt: e + "-image",
        env: h
      }
    ) }),
    /* @__PURE__ */ m("div", { className: "ui-hidden tablet:ui-flex ui-mr-5 [&_img]:ui-block [&_img]:ui-rounded-md [&_img]:ui-overflow-hidden min-w-[150px]", children: /* @__PURE__ */ m(
      Cr,
      {
        imgixImage: l,
        croppedImages: s,
        queries: [],
        base: {
          width: 150,
          ar: "FourByThree"
        },
        style: { minWidth: 150, width: "100%", aspectRatio: "4/3" },
        alt: e + "-image",
        env: h
      }
    ) })
  ] }) : null,
  /* @__PURE__ */ M("div", { className: "ui-flex-1 ui-p-5 tablet:ui-p-0", children: [
    /* @__PURE__ */ m("div", { className: "ui-mb-2 ui-flex", children: /* @__PURE__ */ M("div", { className: "ui-flex-1", children: [
      /* @__PURE__ */ M("div", { className: "ui-flex ui-justify-between ui-items-center", children: [
        /* @__PURE__ */ m("div", { className: "ui-text-2xl ui-font-extrabold", children: e }),
        /* @__PURE__ */ m("div", { className: "ui-bg-blue-600 ui-h-8 ui-rounded-md ui-flex ui-items-center ui-justify-center ui-px-3", children: /* @__PURE__ */ m(hu, { height: 12, width: 12, color: "#FFF" }) })
      ] }),
      t && /* @__PURE__ */ m("div", { className: "ui-text-gray-600 ui-mb-1 ui-font-bold", children: t })
    ] }) }),
    /* @__PURE__ */ M(Pe, { children: [
      d && d.dateType !== "dont_show" && /* @__PURE__ */ m(
        $i,
        {
          locale: u,
          timeZoneAdjustedStart: r,
          timeZoneAdjustedEnd: i,
          shouldShowTzoneDay: a,
          shouldShowTimezone: o,
          dateFormat: Y1(d.dateType),
          text: d.dateText,
          tzoneName: c,
          localTimeLabel: v,
          localTimeEquivalentMessage: y,
          localTimeMessage: f
        }
      ),
      !d && /* @__PURE__ */ m(
        $i,
        {
          locale: u,
          timeZoneAdjustedStart: r,
          timeZoneAdjustedEnd: i,
          shouldShowTzoneDay: a,
          shouldShowTimezone: o,
          dateFormat: "start_date_and_time",
          text: "",
          tzoneName: c,
          localTimeLabel: v,
          localTimeEquivalentMessage: y,
          localTimeMessage: f
        }
      ),
      n && /* @__PURE__ */ m(
        ve,
        {
          icon: /* @__PURE__ */ m(q1, { width: 14, height: 14, color: "rgba(26, 26, 26, 0.4)", className: "ui-min-w-[14px]" }),
          children: n
        }
      )
    ] })
  ] })
] }), E0 = () => /* @__PURE__ */ M(tn, { additionalCls: "tablet:ui-p-5 tablet:ui-flex skeletonLoad ui-max-w-[450px] tablet:ui-max-w-full", children: [
  /* @__PURE__ */ m("div", { className: "ui-flex tablet:ui-hidden ui-overflow-hidden ui-rounded-t-xl", children: /* @__PURE__ */ m(
    Ui,
    {
      base: {
        width: 450,
        ar: "SixteenByNine"
      },
      style: { width: "100%", aspectRatio: "16/9" }
    }
  ) }),
  /* @__PURE__ */ m("div", { className: "ui-hidden tablet:ui-flex ui-mr-5 [&_div]:ui-block [&_div]:ui-rounded-md [&_div]:ui-overflow-hidden", children: /* @__PURE__ */ m(
    Ui,
    {
      base: {
        width: 150,
        ar: "FourByThree"
      },
      style: { width: "100%", aspectRatio: "4/3" }
    }
  ) }),
  /* @__PURE__ */ M("div", { className: "ui-flex-1 ui-p-5 tablet:ui-p-0", children: [
    /* @__PURE__ */ m("div", { className: "ui-mb-2 ui-flex", children: /* @__PURE__ */ M("div", { className: "ui-flex-1", children: [
      /* @__PURE__ */ M("div", { className: "ui-flex ui-justify-between ui-items-center", children: [
        /* @__PURE__ */ m("div", { className: "ui-w-3/4 ui-h-7 ui-bg-gray-100 ui-rounded-full" }),
        /* @__PURE__ */ m("div", { className: "ui-bg-blue-600 ui-h-8 ui-rounded-md ui-flex ui-items-center ui-justify-center ui-px-3", children: /* @__PURE__ */ m(hu, { height: 12, width: 12, color: "#FFF" }) })
      ] }),
      /* @__PURE__ */ m("div", { className: "ui-w-3/4 ui-h-4 ui-bg-gray-100 ui-mt-2 ui-rounded-full" })
    ] }) }),
    /* @__PURE__ */ m("div", { children: /* @__PURE__ */ M(Pe, { children: [
      /* @__PURE__ */ m(It, {}),
      /* @__PURE__ */ m(It, {}),
      /* @__PURE__ */ m(It, {})
    ] }) })
  ] })
] }), S0 = ({ children: e, state: t, placeholder: n, error: r }) => t === "LOADING" ? /* @__PURE__ */ m(G.Fragment, { children: n }) : t === "ERROR" ? /* @__PURE__ */ m(G.Fragment, { children: r }) : /* @__PURE__ */ m(G.Fragment, { children: e });
export {
  f0 as AddonBox,
  tr as AddonButton,
  c0 as AddonRow,
  d0 as AddonRowSkeleton,
  h0 as AddonSummary,
  Bt as Alert,
  Rn as AvailabilityBadge,
  m0 as BADGE_THEME,
  y0 as BUTTON_THEME,
  ve as Badge,
  Pe as BadgeGroup,
  It as BadgeSkeleton,
  ts as BasicTicketGroup,
  tn as Box,
  b0 as Button,
  p0 as DATE_FORMATS,
  w0 as Description,
  x0 as DescriptionSkeleton,
  $1 as EventInfoBox,
  e0 as EventInfoBoxSkeleton,
  C0 as EventListItem,
  E0 as EventListItemSkeleton,
  t0 as EventMap,
  n0 as EventMapSkeleton,
  _u as FeaturedTicketGroup,
  $i as FormattedDateBadges,
  g0 as FormattedDateBadgesSkeleton,
  r0 as FullscreenSpinner,
  A0 as GenericText,
  k0 as GenericTextSkeleton,
  _1 as INFO_BOX_TYPE,
  Pu as Image,
  Wi as InfoBox,
  K1 as LazyImage,
  Cr as LazyImageRenderer,
  Ui as LazyImageRendererSkeleton,
  Bu as LazyImageSkeleton,
  Qi as LazyImageTwicPic,
  v0 as LinkButton,
  S0 as Placeholder,
  $u as PromoTicketGroup,
  es as PromotedTicketGroup,
  X1 as ShadowBox,
  bt as Spinner,
  i0 as SpinnerContainer,
  a0 as SummaryButton,
  Wu as SummaryButtonSkeleton,
  l0 as TicketBox,
  u0 as TicketBoxSkeleton,
  s0 as TicketGroup,
  o0 as TicketRow,
  Yu as TicketRowSkeleton,
  er as TicketTypeButton,
  Ru as TwicPicsImage,
  No as VisibilityObserver,
  Xr as arFloat,
  qi as badgeVariantClasses,
  Nl as buttonThemes,
  ht as isVisible,
  Qu as spinnerSizes,
  Uu as spinnerThemes,
  Y1 as stringToDateFormat,
  Du as useVisible,
  zu as useVisibleOnce
};
